/* @flow */
import * as React from "react";
import IconBase from "./IconBase";
import GlobalStyleSheet from "./GlobalStyleSheet";

type Props = {
  modifiers?: Array<string>,
  color?: string,
  size?: number | string,
  style?: Object,
  // ... and also anything else you want to be on the svg element
};

export const IconClearAll = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconClearAll">
    <path d="M6.8,29.9h40.4v-5.8H6.8V29.9z M1,41.4h40.4v-5.8H1V41.4z M12.6,12.6v5.8H53v-5.8H12.6z" />
  </IconBase>
);

export const IconHelp = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconHelp">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeMiterlimit={10}
      d="M27,4.5c12.4,0,22.5,10.1,22.5,22.5S39.4,49.5,27,49.5S4.5,39.4,4.5,27S14.6,4.5,27,4.5z M26.7,35.3l0-3.5
	      c0.3-1.4,1.3-2.5,2.8-3c3.3-1,5.7-4,5.9-7.5c0.4-3.9-2.2-7.6-5.9-8.8c-0.3-0.1-0.6-0.2-0.9-0.2c-2.1-0.4-4.2,0-6,1.1
	      c-2,1.2-3.5,3.3-3.9,5.7 M26.9,41.9v-1.4"
    />
  </IconBase>
);

export const IconIpad = (props: Props) => (
  <IconBase viewBox="0 0 50 50" {...props} data-component-name="IconIpad">
    <path
      d="M 6 6 C 4.136719 6 2.609375 6.921875 1.59375 8.09375 C 0.578125 9.265625 0 10.679688 0 12 L 0 38.375 C 0 41.464844 2.535156 44 5.625 44 L 44.375 44 C 47.464844 44 50 41.464844 50 38.375 L 50 11.84375 C 50 8.65625 47.148438 6 44 6 Z M 6 8 L 44 8 C 45.949219 8 48 9.9375 48 11.84375 L 48 38.375 C 48 40.382813 46.382813 42 44.375 42 L 5.625 42 C 3.613281 42 2 40.386719 2 38.375 L 2 12 C 2 11.320313 2.378906 10.234375 3.09375 9.40625 C 3.808594 8.578125 4.785156 8 6 8 Z M 6.8125 10 C 6.335938 10.089844 5.992188 10.511719 6 11 L 6 39 C 6 39.550781 6.449219 40 7 40 L 44 40 C 44.550781 40 45 39.550781 45 39 L 45 11 C 45 10.449219 44.550781 10 44 10 L 7 10 C 6.96875 10 6.9375 10 6.90625 10 C 6.875 10 6.84375 10 6.8125 10 Z M 8 12 L 43 12 L 43 38 L 8 38 Z M 4 23.5 C 3.171875 23.5 2.5 24.171875 2.5 25 C 2.5 25.828125 3.171875 26.5 4 26.5 C 4.828125 26.5 5.5 25.828125 5.5 25 C 5.5 24.171875 4.828125 23.5 4 23.5 Z "
      fill="currentColor"
    />
  </IconBase>
);

export const IconRotateArrow = (props: Props) => (
  <IconBase
    viewBox="0 0 50 50"
    {...props}
    data-component-name="IconRotateArrow"
  >
    <path
      d="M 15 3.171875 L 2.5859375 15.585938 A 2.0002 2.0002 0 1 0 5.4140625 18.414062 L 13 10.828125 L 13 38 C 13 42.394668 16.605332 46 21 46 L 46 46 A 2.0002 2.0002 0 1 0 46 42 L 21 42 C 18.766668 42 17 40.233332 17 38 L 17 10.828125 L 24.585938 18.414062 A 2.0002 2.0002 0 1 0 27.414062 15.585938 L 15 3.171875 z"
      fill="currentColor"
    />
  </IconBase>
);

export const IconEnergyMeter = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconEnergyMeter"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M14,7A15,15,0,0,0,6.8,8.4C5.2,9.3,4,10.5,4,12V44a3.08,3.08,0,0,0,3,3H47a3.08,3.08,0,0,0,3-3V12c0-1.5-1.1-2.8-2.8-3.6A16.64,16.64,0,0,0,40,7Zm-1.2,7a1,1,0,0,0-.8,1v7a.94.94,0,0,0,1,1H30a.94.94,0,0,0,1-1V15a.94.94,0,0,0-1-1H12.8Zm26.7,4A5.5,5.5,0,1,0,45,23.5,5.55,5.55,0,0,0,39.5,18Zm-14,10a.52.52,0,1,0,.52.52A.53.53,0,0,0,25.5,28ZM8.8,47V40.8c0-1.1,2.2-4.6,5.4-4.6h26c3.2,1,4.8,3.5,4.8,4.7V47M39.5,23a.52.52,0,1,0,.52.52A.53.53,0,0,0,39.5,23ZM14.62,42a4,4,0,0,1,.61,0c2.63.41,2,5.06,2,5.06H12.08S11.29,42,14.62,42Zm8,0a4,4,0,0,1,.61,0c2.63.41,2,5.06,2,5.06H20.08S19.29,42,22.62,42Zm8,0a4,4,0,0,1,.61,0c2.63.41,2,5.06,2,5.06H28.08S27.29,42,30.62,42ZM36.08,47S35.29,42,38.62,42a4,4,0,0,1,.61,0c2.63.41,2,5.06,2,5.06Z"
    />
  </IconBase>
);

export const IconRuntimeHistory = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconRuntimeHistory"
  >
    <rect
      x="5"
      y="18"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeMiterlimit={10}
      width="12"
      height="31"
    />
    <rect
      x="21"
      y="29"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeMiterlimit={10}
      width="12"
      height="20"
    />
    <rect
      x="37"
      y="5"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeMiterlimit={10}
      width="12"
      height="44"
    />
  </IconBase>
);

export const IconScheduling = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconScheduling">
    <rect
      x="3"
      y="7"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      width="48"
      height="40"
    />
    <line
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      x1="11"
      y1="7"
      x2="11"
      y2="47"
    />
    <line
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      x1="51"
      y1="23"
      x2="3"
      y2="23"
    />
    <line
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      x1="51"
      y1="15"
      x2="3"
      y2="15"
    />
    <line
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      x1="51"
      y1="31"
      x2="3"
      y2="31"
    />
    <line
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      x1="51"
      y1="39"
      x2="3"
      y2="39"
    />
  </IconBase>
);

export const IconSettingsGear = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconSettingsGear"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeMiterlimit={10}
      d="M51,30v-6l-7.1-1.2c-0.4-1.7-1.1-3.3-2-4.7l4.2-5.9l-4.2-4.2L36,12.1c-1.5-0.9-3.1-1.6-4.8-2L30,3h-6l-1.2,7.1c-1.7,0.4-3.3,1.1-4.8,2l-5.8-4.2l-4.2,4.2L12,18c-0.9,1.5-1.6,3.1-2,4.8L3,24v6l7,1.2c0.4,1.7,1.1,3.3,2,4.8l-4.2,5.8l4.2,4.2l5.9-4.1c1.5,0.9,3.1,1.6,4.8,2L24,51h6l1.3-7.1c1.7-0.4,3.3-1.1,4.8-2l5.9,4.2l4.2-4.2l-4.2-5.9c0.9-1.5,1.5-3,2-4.7L51,30z M27,35c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S31.4,35,27,35z"
    />
  </IconBase>
);

export const IconCircledCheckmark = ({
  checked,
  children,
  ...props
}: Props & {
  checked?: ?boolean,
  children?: ?React.Node,
}) => (
  <IconBase
    viewBox="0 0 32 32"
    {...props}
    data-component-name="IconCircledCheckmark"
  >
    <circle
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeMiterlimit={10}
      cx="16"
      cy="16"
      r="12"
    />
    {checked ? (
      <polyline
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
        points="23,12 15,20 10,15 "
      />
    ) : null}
    {children ? (
      <text
        x="16"
        y="16"
        fontSize="0.65em"
        dy="0.35em"
        textAnchor="middle"
        fill="currentColor"
      >
        {children}
      </text>
    ) : null}
  </IconBase>
);
IconCircledCheckmark.defaultProps = {
  checked: false,
};

export const IconCircledArrowDown = (props: Props) => (
  <IconBase
    viewBox="0 0 40 40"
    {...props}
    data-component-name="IconCircledArrowDown"
  >
    <g transform="matrix(0.5,0,0,-0.5,10,30)">
      <path d="M6.6 20 20 6.6 33.4 20 30.9 22.3 21.6 13l0 20.4-3.2 0 0-20.4-9.4 9.3z" />
    </g>
    <ellipse
      cx="20"
      cy="20"
      rx="17"
      ry="17"
      fill="none"
      vectorEffect="non-scaling-stroke"
      strokeWidth={2}
      stroke="currentColor"
    />
  </IconBase>
);

export const IconCircledArrowUp = (props: Props) => (
  <IconBase
    viewBox="0 0 40 40"
    {...props}
    data-component-name="IconCircledArrowUp"
  >
    <g transform="matrix(0.5,0,0,0.5,10,10)">
      <path d="M6.6 20 20 6.6 33.4 20 30.9 22.3 21.6 13l0 20.4-3.2 0 0-20.4-9.4 9.3z" />
    </g>
    <ellipse
      cx="20"
      cy="20"
      rx="17"
      ry="17"
      fill="none"
      vectorEffect="non-scaling-stroke"
      strokeWidth={2}
      stroke="currentColor"
    />
  </IconBase>
);

export const IconThermostat = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconThermostat">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M31,29.82V5H23v24.8A10,10,0,1,0,37,39,10.15,10.15,0,0,0,31,29.82ZM27,16V34m0,0a5,5,0,1,1-5,5A5,5,0,0,1,27,34ZM31,9h4m-4,4h3m-3,4h4m-4,4h3m-3,4h4"
    />
  </IconBase>
);

export const IconThermostatMode = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconThermostatMode"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M50.62,22.21h0l-3-2.33-20-15.67A1,1,0,0,0,27,4a1,1,0,0,0-.58.21l-20,15.63-3,2.37m2.62-2V49a1,1,0,0,0,1,1H47a1,1,0,0,0,1-1V20.17M18.78,22.62h0a4.9,4.9,0,0,1,2-1.37c1.29-.46,3.05-.56,5.54,1.51,2.91,2.43,5.65,2.53,7.51,1.86a7,7,0,0,0,2.92-2A1,1,0,0,0,37,22M17.78,31.62h0a4.9,4.9,0,0,1,2-1.37c1.29-.46,3.05-.56,5.54,1.51,2.91,2.43,5.65,2.53,7.51,1.86a7,7,0,0,0,2.92-2A1,1,0,0,0,36,31M17.78,40.62h0a4.9,4.9,0,0,1,2-1.37c1.29-.46,3.05-.56,5.54,1.51,2.91,2.43,5.65,2.53,7.51,1.86a7,7,0,0,0,2.92-2A1,1,0,0,0,36,40"
    />
  </IconBase>
);

export const IconWifi = (props: Props) => (
  <IconBase viewBox="0 0 24 24" {...props} data-component-name="IconWifi">
    <path d="M10.6,18.5L12,20l1.4-1.5C13,18.2,12.5,18,12,18S11,18.2,10.6,18.5z" />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeMiterlimit={10}
      d="M16.1,15.6C15,14.6,13.6,14,12,14s-3,0.6-4.1,1.6"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeMiterlimit={10}
      d="M19.5,12c-2-1.8-4.6-3-7.5-3s-5.5,1.1-7.5,3"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeMiterlimit={10}
      d="M22.9,8.3C20,5.6,16.2,4,12,4S3.9,5.6,1.1,8.3"
    />
  </IconBase>
);

export const IconRadioAntenna = ({
  radioWavesLeftShown,
  radioWavesRightShown,
  ...props
}: Props & {
  radioWavesLeftShown: boolean,
  radioWavesRightShown: boolean,
}) => (
  <IconBase
    viewBox="0 0 387.1 431.9"
    {...props}
    data-component-name="IconRadioAntenna"
  >
    <g id="antenna">
      <path d="M189.3,184.5l-14.9,247.3h32l-6.9-247.3c-1.6,0.3-3.4,0.4-5.1,0.4C192.7,184.9,190.9,184.8,189.3,184.5z" />
      <path d="M194.4,146c-13.8,0-25,9-25,20c0,9.6,8.5,17.7,19.9,19.6v-0.1h10.2v0.1c11.4-1.9,19.9-10,19.9-19.6   C219.4,154.9,208.2,146,194.4,146z" />
    </g>
    <g
      id="radio-waves-left"
      style={{ visibility: radioWavesLeftShown ? "visible" : "hidden" }}
    >
      <path d="M159.9,115.4l4.5-5.4l-10.8-8.9l-4.5,5.4c-0.5,0.6-12,14.6-17.8,34.5c-8,27.1-1.6,52,18.3,71.9l4.9,4.9l9.8-9.9l-4.9-4.9   c-16.2-16.2-21.2-35.6-14.8-57.7C149.6,128.1,159.8,115.5,159.9,115.4z" />
      <path d="M118.8,73.3l4.5-5.4l-10.7-9l-4.5,5.4c-0.9,1.1-22.8,27.6-34,65.4c-10.5,35.5-13,87.7,34.4,135.1l4.9,4.9l9.9-9.8l-4.9-5   c-34-34-44.4-74.7-31-120.8C97.6,99.1,118.4,73.8,118.8,73.3z" />
      <path d="M14.1,159.9C15.9,76.3,81.2,15.6,81.9,15l3.1-3.1L75.1,2l-2.8,2.8C70.5,6.4,54,22,37,48C20.7,72.9,1.1,112.5,0,159.4   c-1.2,56,23.4,109.6,73.2,159.4l10-9.9C36.2,261.9,12.9,211.8,14.1,159.9z" />
    </g>
    <g
      id="radio-waves-right"
      style={{ visibility: radioWavesRightShown ? "visible" : "hidden" }}
    >
      <path d="M387,157.4c-1.1-46.9-20.7-86.5-36.9-111.4c-17-26-33.6-41.6-35.3-43.2L312,0l-9.9,9.9l2.9,2.9l0.2,0.2   c0.7,0.6,66,61.3,67.8,144.9c1.2,51.9-22.1,102-69.1,149l9.9,9.9C363.7,267,388.3,213.4,387,157.4z" />
      <path d="M304,128.8c-11.2-37.8-33-64.3-34-65.4l-10.7,9c0.2,0.2,20.9,25.3,31.3,60.4c13.7,46.3,3.3,87.1-30.9,121.2l9.9,9.9   C317,216.4,314.5,164.2,304,128.8z" />
      <path d="M257.9,142.9C252,123,240.5,109,240,108.4l-4.5-5.4l-10.8,8.9l4.4,5.4c0.1,0.1,10.3,12.7,15.3,29.9   c6.3,22.1,1.3,41.5-14.8,57.7l-4.9,4.9l9.9,9.9l5-4.9C259.5,194.9,265.8,170,257.9,142.9z" />
    </g>
  </IconBase>
);
IconRadioAntenna.defaultProps = {
  radioWavesLeftShown: true,
  radioWavesRightShown: true,
};

export const IconDisclosureArrowRight = (props: Props) => (
  <IconBase
    viewBox="0 0 364 1024"
    {...props}
    data-component-name="IconDisclosureArrowRight"
  >
    <path d="M339.144 548.572q0 7.428-5.714 13.142l-266.286 266.286q-5.714 5.714-13.142 5.714t-13.142-5.714l-28.572-28.572q-5.714-5.714-5.714-13.142t5.714-13.142l224.572-224.572-224.572-224.572q-5.714-5.714-5.714-13.142t5.714-13.142l28.572-28.572q5.714-5.714 13.142-5.714t13.142 5.714l266.286 266.286q5.714 5.714 5.714 13.142z" />
  </IconBase>
);

export const IconDropDownArrow = (props: Props) => (
  <IconBase
    viewBox="0 0 1024 1024"
    {...props}
    data-component-name="IconDropDownArrow"
  >
    <path d="M792.73 438.426c-20.838 21.402-240.384 230.554-240.384 230.554-11.162 11.416-25.754 17.1-40.346 17.1-14.644 0-29.236-5.684-40.346-17.1 0 0-219.546-209.152-240.436-230.554-20.838-21.402-22.272-59.852 0-82.74 22.324-22.836 53.402-24.628 80.692 0l200.09 191.898 200.038-191.846c27.34-24.628 58.47-22.836 80.692 0 22.322 22.834 20.94 61.338 0 82.688z" />
  </IconBase>
);

export const IconThinChevronLeft = (props: Props) => (
  <IconBase
    viewBox="0 0 1024 1024"
    {...props}
    data-component-name="IconThinChevronLeft"
  >
    <path d="M737.228 891.802c13.722 13.876 13.722 36.25 0 50.124s-35.892 13.876-49.612 0l-400.896-404.838c-13.722-13.876-13.722-36.3 0-50.124l400.896-404.89c13.722-13.876 35.892-13.876 49.612 0s13.722 36.25 0 50.124l-365.568 379.802 365.568 379.802z" />
  </IconBase>
);

export const IconThinChevronRight = (props: Props) => (
  <IconBase
    viewBox="0 0 1024 1024"
    {...props}
    data-component-name="IconUniE04D"
  >
    <path d="M286.704 891.802c-13.722 13.876-13.722 36.25 0 50.124s35.892 13.876 49.612 0l400.896-404.838c13.722-13.876 13.722-36.3 0-50.124l-400.896-404.89c-13.722-13.876-35.892-13.876-49.612 0s-13.722 36.25 0 50.124l365.568 379.802-365.568 379.802z" />
  </IconBase>
);

export const IconThinChevronDown = (props: Props) => (
  <IconBase
    viewBox="0 0 1024 1024"
    {...props}
    data-component-name="IconThinChevronDown"
  >
    <path d="M132.198 286.772c-13.876-13.722-36.3-13.722-50.124 0-13.824 13.67-13.824 35.892 0 49.612l404.89 400.896c13.876 13.722 36.25 13.722 50.124 0l404.89-400.896c13.824-13.722 13.876-35.892 0-49.612s-36.352-13.722-50.126-.052l-379.852 365.62-379.802-365.568z" />
  </IconBase>
);

export const IconThinnerChevronDown = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconThinnerChevronDown"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeWidth="2px"
      d="M49.2,16l-21,21c-0.2,0.2-0.5,0.3-0.7,0.3S27,37.2,26.8,37l-22-22"
    />
  </IconBase>
);

export const IconThinnerChevronUp = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconThinnerChevronUp"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeWidth="2px"
      d="M4.8,36.3l21-21c0.2-0.2,0.5-0.3,0.7-0.3s0.5,0.1,0.7,0.3l22,22"
    />
  </IconBase>
);

export const IconThinArrowUp = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconThinArrowUp"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2px"
      strokeMiterlimit="10"
      strokeLinecap="round"
      d="M27,42V12.42M38.59,23.64,27.72,12.73,27,12.05l-.72.68L15.41,23.64"
    />
  </IconBase>
);

export const IconThinArrowDown = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconDropDownArrow"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2px"
      strokeMiterlimit="10"
      strokeLinecap="round"
      d="M27,41.58V12.05M15.41,30.36,26.28,41.27,27,42l.72-.68L38.59,30.36"
    />
  </IconBase>
);

export const IconPlay = (props: Props) => (
  <IconBase viewBox="0 0 804 1024" {...props} data-component-name="IconPlay">
    <path d="M790.858 529.714l-758.858 421.714q-13.142 7.428-22.572 1.714t-9.428-20.572v-841.142q0-14.858 9.428-20.572t22.572 1.714l758.858 421.714q13.142 7.428 13.142 17.714t-13.142 17.714z" />
  </IconBase>
);

export const IconPause = (props: Props) => (
  <IconBase viewBox="0 0 876 1024" {...props} data-component-name="IconPause">
    <path d="M877.714 109.714v804.572q0 14.858-10.858 25.714t-25.714 10.858h-292.572q-14.858 0-25.714-10.858t-10.858-25.714v-804.572q0-14.858 10.858-25.714t25.714-10.858h292.572q14.858 0 25.714 10.858t10.858 25.714zm-512 0v804.572q0 14.858-10.858 25.714t-25.714 10.858h-292.572q-14.858 0-25.714-10.858t-10.858-25.714v-804.572q0-14.858 10.858-25.714t25.714-10.858h292.572q14.858 0 25.714 10.858t10.858 25.714z" />
  </IconBase>
);

export const IconStop = (props: Props) => (
  <IconBase viewBox="0 0 876 1024" {...props} data-component-name="IconStop">
    <path d="M877.714 109.714v804.572q0 14.858-10.858 25.714t-25.714 10.858h-804.572q-14.858 0-25.714-10.858t-10.858-25.714v-804.572q0-14.858 10.858-25.714t25.714-10.858h804.572q14.858 0 25.714 10.858t10.858 25.714z" />
  </IconBase>
);

export const IconRewind = (props: Props) => (
  <IconBase viewBox="0 0 950 1024" {...props} data-component-name="IconRewind">
    <path d="M925.142 80.572q10.858-10.858 18.286-7.428t7.428 18.286v841.142q0 14.858-7.428 18.286t-18.286-7.428l-405.714-405.714q-4.572-5.142-7.428-10.858v405.714q0 14.858-7.428 18.286t-18.286-7.428l-405.714-405.714q-10.858-10.858-10.858-25.714t10.858-25.714l405.714-405.714q10.858-10.858 18.286-7.428t7.428 18.286v405.714q2.858-6.286 7.428-10.858z" />
  </IconBase>
);

export const IconFastForward = (props: Props) => (
  <IconBase
    viewBox="0 0 950 1024"
    {...props}
    data-component-name="IconFastForward"
  >
    <path d="M25.714 943.428q-10.858 10.858-18.286 7.428t-7.428-18.286v-841.142q0-14.858 7.428-18.286t18.286 7.428l405.714 405.714q4.572 4.572 7.428 10.858v-405.714q0-14.858 7.428-18.286t18.286 7.428l405.714 405.714q10.858 10.858 10.858 25.714t-10.858 25.714l-405.714 405.714q-10.858 10.858-18.286 7.428t-7.428-18.286v-405.714q-2.858 5.714-7.428 10.858z" />
  </IconBase>
);

export const IconBatteryEmpty = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconBatteryEmpty"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M35,50.5H19a6,6,0,0,1-6-6v-32a6,6,0,0,1,6-6h2v-1a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2v1h2a6,6,0,0,1,6,6v32A6,6,0,0,1,35,50.5Z"
    />
  </IconBase>
);

export const IconBatteryLow = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconBatteryLow">
    <path d="M35,51.5H19a7,7,0,0,1-7-7v-32a7,7,0,0,1,7-7h1a3,3,0,0,1,3-3h8a3,3,0,0,1,3,3h1a7,7,0,0,1,7,7v32A7,7,0,0,1,35,51.5ZM19,7.5a5,5,0,0,0-5,5v32a5,5,0,0,0,5,5H35a5,5,0,0,0,5-5v-32a5,5,0,0,0-5-5H33a1,1,0,0,1-1-1v-1a1,1,0,0,0-1-1H23a1,1,0,0,0-1,1v1a1,1,0,0,1-1,1ZM37.5,46.7H16.7a1,1,0,0,1-1-1v-9a1,1,0,0,1,1-1H37.5a1,1,0,0,1,1,1v9A1,1,0,0,1,37.5,46.7Z" />
  </IconBase>
);

export const IconBatteryMostlyFull = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconBatteryMostlyFull"
  >
    <path d="M35,51.5H19a7,7,0,0,1-7-7v-32a7,7,0,0,1,7-7h1a3,3,0,0,1,3-3h8a3,3,0,0,1,3,3h1a7,7,0,0,1,7,7v32A7,7,0,0,1,35,51.5ZM19,7.5a5,5,0,0,0-5,5v32a5,5,0,0,0,5,5H35a5,5,0,0,0,5-5v-32a5,5,0,0,0-5-5H33a1,1,0,0,1-1-1v-1a1,1,0,0,0-1-1H23a1,1,0,0,0-1,1v1a1,1,0,0,1-1,1ZM37.5,46.7H16.7a1,1,0,0,1-1-1v-9a1,1,0,0,1,1-1H37.5a1,1,0,0,1,1,1v9A1,1,0,0,1,37.5,46.7Zm0-13H16.7a1,1,0,0,1-1-1v-9a1,1,0,0,1,1-1H37.5a1,1,0,0,1,1,1v9A1,1,0,0,1,37.5,33.7Z" />
  </IconBase>
);

export const IconBatteryFull = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconBatteryFull"
  >
    <path d="M35,51.5H19a7,7,0,0,1-7-7v-32a7,7,0,0,1,7-7h1a3,3,0,0,1,3-3h8a3,3,0,0,1,3,3h1a7,7,0,0,1,7,7v32A7,7,0,0,1,35,51.5ZM19,7.5a5,5,0,0,0-5,5v32a5,5,0,0,0,5,5H35a5,5,0,0,0,5-5v-32a5,5,0,0,0-5-5H33a1,1,0,0,1-1-1v-1a1,1,0,0,0-1-1H23a1,1,0,0,0-1,1v1a1,1,0,0,1-1,1ZM37.5,46.7H16.7a1,1,0,0,1-1-1v-9a1,1,0,0,1,1-1H37.5a1,1,0,0,1,1,1v9A1,1,0,0,1,37.5,46.7Zm0-13H16.7a1,1,0,0,1-1-1v-9a1,1,0,0,1,1-1H37.5a1,1,0,0,1,1,1v9A1,1,0,0,1,37.5,33.7Zm0-13H16.7a1,1,0,0,1-1-1v-9a1,1,0,0,1,1-1H37.5a1,1,0,0,1,1,1v9A1,1,0,0,1,37.5,20.7Z" />
  </IconBase>
);

export const IconBell = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconBell">
    <path d="M19,49a6,6,0,0,1-3.78-10.63l-.81-.78A34.28,34.28,0,0,1,7.2,27.65c-1.48-3.36-1.59-6.08-.34-8.08a1.69,1.69,0,0,1,.44-.7l.08-.09,0,0,.09-.1a5.85,5.85,0,0,1,3.29-1.46c2.59-.48,4.67-.94,6.34-1.41a13.87,13.87,0,0,0,4.15-1.71l0,0,4.6-4.59A11.78,11.78,0,0,1,39,7a5,5,0,0,1,9,3,4.94,4.94,0,0,1-2.52,4.31,11.75,11.75,0,0,1-2.93,11.77L38,30.65l0,0a13.62,13.62,0,0,0-1.74,4.17c-.46,1.67-.92,3.74-1.4,6.34a5.83,5.83,0,0,1-1.46,3.3l-.1.09-.09.1a1.84,1.84,0,0,1-.63.41c-1.94,1.27-4.58,1.22-7.85-.15A6,6,0,0,1,19,49ZM8.75,20.25a1.28,1.28,0,0,1-.13.29c-1.18,1.75-.43,4.4.41,6.31a32.39,32.39,0,0,0,6.8,9.32c.56.56,1.12,1.09,1.69,1.6a1,1,0,0,1,.32.88,1,1,0,0,1-.56.76,4,4,0,1,0,5.7,4,1,1,0,0,1,.51-.77,1,1,0,0,1,.93,0c.29.14.51.25.73.34,1.94.86,4.62,1.62,6.37.4a.75.75,0,0,1,.25-.13,1.37,1.37,0,0,1,.17-.17,4,4,0,0,0,.91-2.23c.48-2.66.95-4.79,1.44-6.52s1.37-4.12,2.21-5l0,0,4.6-4.6A9.77,9.77,0,0,0,43.3,14.15a1,1,0,0,1,0-.8,1,1,0,0,1,.59-.52A3,3,0,1,0,40.3,8.75a1,1,0,0,1-.59.52,1,1,0,0,1-.79-.07A9.83,9.83,0,0,0,34.24,8a9.71,9.71,0,0,0-6.91,2.85L23,15.2a1,1,0,0,1-.21.26.8.8,0,0,1-.21.15,16.12,16.12,0,0,1-4.89,2.1c-1.73.49-3.87,1-6.52,1.44A4,4,0,0,0,9,20,1.34,1.34,0,0,1,8.75,20.25ZM37.24,30h0ZM9,19.88A.54.54,0,0,1,9,20a.85.85,0,0,0,.1-.19ZM15.77,23a1,1,0,0,1-.23-2l.77-.17c1.08-.25,2.55-.59,3.91-1a13.38,13.38,0,0,0,3.43-1.37c.87-.8,3.28-3.26,4.58-4.58l.34-.35A7.74,7.74,0,0,1,34,11a1,1,0,0,1,1,1,1,1,0,0,1-1,1h0a5.73,5.73,0,0,0-4,2l-.35.35C28.25,16.78,25.91,19.16,25,20a13.73,13.73,0,0,1-4.22,1.82c-1.42.41-2.93.75-4,1L16,23A.91.91,0,0,1,15.77,23Zm28.46-8.25a1,1,0,0,1-.75-.34L38.65,9a1,1,0,0,1,1.49-1.33L45,13.11a1,1,0,0,1-.09,1.42A1,1,0,0,1,44.23,14.78ZM24,44.51a1,1,0,0,1-.57-.18l-7.13-5a1,1,0,0,1,1.15-1.64l7.13,5A1,1,0,0,1,24,44.51Z" />
  </IconBase>
);

export const IconBlindsClosed = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconBlindsClosed"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2px"
      d="M43.8,44.92H41.32V14.66h1.32V9H12.36v5.66h1.31V44.89H11.2V48H43.8v-3ZM15.25,44l1.45-3.16H38.27L39.67,44Zm0-5.19,1.48-3.21H38.3l1.47,3.21Zm0-5.19,1.48-3.16H38.3l1.47,3.16Zm0-5.21,1.48-3.16H38.3l1.47,3.16Zm0-5.16L16.73,20H38.3l1.47,3.22Zm0-4.8,1.74-4H38l1.73,4Z"
    />
  </IconBase>
);

export const IconBlindsHalfOpen = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconBlindsHalfOpen"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2px"
      d="M43.3,43.4h-2.5V13.2h1.3V7.5H11.9v5.7h1.3v30.2h-2.5v3.1h32.6V43.4z M38.1,42.4H36l0,0H21.4l0,0h-5.5V29h22.2 V42.4z M14.8,26.9l1.5-3.2h21.6l1.5,3.2H14.8z M14.8,21.8l1.5-3.2h21.6l1.5,3.2L14.8,21.8z M14.8,17l1.7-4h21l1.7,4H14.8z"
    />
  </IconBase>
);

export const IconBlindsMostlyClosed = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconBlindsMostlyClosed"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2px"
      d="M43.3,43.4h-2.5V13.2h1.3V7.5H11.9v5.7h1.3v30.2h-2.5v3.1h32.6V43.4z M38.1,42.4h-2.9l0,0H17.4l0,0h-1.5v-8.3 h22.2L38.1,42.4L38.1,42.4z M14.8,32.1l1.5-3.1h21.6l1.5,3.2L14.8,32.1z M14.8,26.9l1.5-3.2h21.6l1.5,3.2H14.8z M14.8,21.8l1.5-3.2 h21.6l1.5,3.2L14.8,21.8z M14.8,17l1.7-4h21l1.7,4H14.8z"
    />
  </IconBase>
);

export const IconBlindsMostlyOpen = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconBlindsMostlyOpen"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2px"
      d="M43.3,43.43H40.83V13.17h1.31V7.51H11.86v5.66h1.31V43.41H10.7v3.08H43.3V43.43Zm-5.19-1H32.66l0,0H18.84l0,0H15.89V23.76H38.11ZM14.75,21.76l1.48-3.21H37.8l1.47,3.21Zm0-4.79,1.74-4h21l1.74,4Z"
    />
  </IconBase>
);

export const IconBlindsOpen = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconBlindsOpen">
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2px"
      d="M43.3,43.43H40.83V13.17h1.31V7.51H11.86v5.66h1.31V43.41H10.7v3.08H43.3V43.43Zm-5.19-1H35.3l0,0H18.49l0,0H15.89V12.91H38.11Z"
    />
  </IconBase>
);

export const IconCalendarEmpty = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconCalendarEmpty"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M43.17,6H50a1.93,1.93,0,0,1,2,2V50a1.93,1.93,0,0,1-2,2H4a1.93,1.93,0,0,1-2-2V8A1.93,1.93,0,0,1,4,6h7M36.81,6H17.5M43,10V4a1.93,1.93,0,0,0-2-2H39a1.93,1.93,0,0,0-2,2v6a1.93,1.93,0,0,0,2,2h2A1.93,1.93,0,0,0,43,10ZM17,10V4a1.93,1.93,0,0,0-2-2H13a1.93,1.93,0,0,0-2,2v6a1.93,1.93,0,0,0,2,2h2A1.93,1.93,0,0,0,17,10ZM2,17a1,1,0,0,0,1,1H51a1,1,0,0,0,1-1"
    />
  </IconBase>
);

export const IconCalendar = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconCalendar">
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M43.17,6H50a1.93,1.93,0,0,1,2,2V50a1.93,1.93,0,0,1-2,2H4a1.93,1.93,0,0,1-2-2V8A1.93,1.93,0,0,1,4,6h7M36.81,6H17.5M43,10V4a1.93,1.93,0,0,0-2-2H39a1.93,1.93,0,0,0-2,2v6a1.93,1.93,0,0,0,2,2h2A1.93,1.93,0,0,0,43,10ZM17,10V4a1.93,1.93,0,0,0-2-2H13a1.93,1.93,0,0,0-2,2v6a1.93,1.93,0,0,0,2,2h2A1.93,1.93,0,0,0,17,10ZM2,17a1,1,0,0,0,1,1H51a1,1,0,0,0,1-1M46,45V24a1,1,0,0,0-1-1H9a1,1,0,0,0-1,1V45a1,1,0,0,0,1,1H45A1,1,0,0,0,46,45ZM8.25,31H45.83m-37,7.67,36.59.16M28,45.67V23M18,45.9V23.25M37,45.92V23.13"
    />
  </IconBase>
);

export const IconCameraDisconnected = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconCameraDisconnected"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      d="M37.2,13.1l6.7-2.9c0.7-0.3,1.6,0,2,0.7l5.4,11.4c0.3,0.7,0,1.6-0.7,2L19,39.3c-0.7,0.3-1.6,0-2-0.7l-5.4-11.4
    	c-0.3-0.7,0-1.6,0.7-2l6.6-3.2 M12.9,29.9l-8.6-0.3c-0.5,0-0.9,0.5-0.7,0.9l6.1,12.8c0.2,0.3,0.6,0.4,0.9,0.2
    	c0.1-0.1,0.1-0.1,0.2-0.2l5-7.3 M52.5,44h-12c-1.1,0-2-0.9-2-2v-8 M40.9,29.1c0.4,0.5,0.6,1.2,0.6,1.9c0,1.7-1.4,3-3.1,2.9
    	c-1.3,0-2.5-0.9-2.8-2.2 M19.8,21.7c-2.5-4.5-0.9-10.3,3.6-12.8S33.7,8,36.2,12.6s0.9,10.3-3.6,12.8c-1.4,0.8-3,1.2-4.5,1.2
    	C24.6,26.5,21.4,24.7,19.8,21.7 M27.6,10.1V20 M27.7,22c-0.3,0-0.6,0.2-0.7,0.5c0,0.3,0.2,0.6,0.5,0.7c0.1,0,0.1,0,0.2,0
    	c0.3,0,0.5-0.3,0.5-0.7C28.2,22.2,28,22,27.7,22z"
    />
  </IconBase>
);

export const IconCamera = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconCamera">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M16,38.6,10.6,27.2a1.63,1.63,0,0,1,.7-2l31.6-15a1.63,1.63,0,0,1,2,.7l5.4,11.4a1.63,1.63,0,0,1-.7,2L18,39.3A1.55,1.55,0,0,1,16,38.6Zm-4.1-8.7-8.6-.3c-.5,0-.9.5-.7.9L8.7,43.3a.65.65,0,0,0,1.1,0l5-7.3m36.7,8h-12a2,2,0,0,1-2-2V34m2.4-4.9a3.08,3.08,0,0,1,.6,1.9,3,3,0,0,1-3,3,3,3,0,0,1-2.9-2.3"
    />
  </IconBase>
);

export const IconSnapshot = (props: Props) => (
  <IconBase
    viewBox="0 0 1096 1024"
    {...props}
    data-component-name="IconSnapshot"
  >
    <path d="M548 384.132q67.93 0 116.164 48.236t48.236 116.164-48.236 116.164-116.164 48.236-116.164-48.236-48.236-116.164 48.236-116.164 116.164-48.236zm401.868-237.466q60.508 0 103.32 42.814t42.814 103.32v511.468q0 60.508-42.814 103.32t-103.32 42.814h-803.734q-60.508 0-103.32-42.814t-42.814-103.32v-511.468q0-60.508 42.814-103.32t103.32-42.814h127.866l29.112-77.634q10.846-27.97 39.672-48.236t59.08-20.264h292.268q30.254 0 59.08 20.264t39.672 48.236l29.112 77.634h127.866zm-401.868 657.6q105.604 0 180.67-75.064t75.064-180.67-75.064-180.67-180.67-75.064-180.67 75.064-75.064 180.67 75.064 180.67 180.67 75.064z" />
  </IconBase>
);

export const IconCaretDown = (props: Props) => (
  <IconBase
    viewBox="0 0 584 1024"
    {...props}
    data-component-name="IconCaretDown"
  >
    <path d="M584.572 402.286q0 14.858-10.858 25.714l-256 256q-10.858 10.858-25.714 10.858t-25.714-10.858l-256-256q-10.858-10.858-10.858-25.714t10.858-25.714 25.714-10.858h512q14.858 0 25.714 10.858t10.858 25.714z" />
  </IconBase>
);

export const IconCaretUp = (props: Props) => (
  <IconBase viewBox="0 0 584 1024" {...props} data-component-name="IconCaretUp">
    <path d="M584.572 694.858q0 14.858-10.858 25.714t-25.714 10.858h-512q-14.858 0-25.714-10.858t-10.858-25.714 10.858-25.714l256-256q10.858-10.858 25.714-10.858t25.714 10.858l256 256q10.858 10.858 10.858 25.714z" />
  </IconBase>
);

export const IconCasementWindowClosedLocked = (props: Props) => (
  <IconBase
    viewBox="0 0 809 1024"
    {...props}
    data-component-name="IconCasementWindowClosedLocked"
  >
    <path d="M552.449 737.663c0 4.258-3.193 8.516-6.387 9.58v18.096c0 2.129-1.064 3.193-3.193 3.193s-3.193-1.064-3.193-3.193v-18.096h-2.129c-4.258-1.064-6.387-5.322-6.387-9.58 0-5.322 4.258-10.644 10.644-10.644 5.322 0 10.644 4.258 10.644 10.644zm-11.709-98.994c-17.031 0-30.869 13.838-30.869 30.869v23.418h61.738v-23.418c0-17.031-13.838-30.869-30.869-30.869zm131.992 84.092c0 72.383-59.609 131.992-131.992 131.992-45.771 0-86.22-23.418-109.638-59.609h-255.468c-7.451 0-12.773-5.322-12.773-12.773v-630.154c0-7.451 5.322-12.773 12.773-12.773h383.202c7.451 0 12.773 5.322 12.773 12.773v442.811c57.48 13.838 101.123 65.996 101.123 127.734zm-255.468 46.836c-4.258-10.644-7.451-22.353-8.516-34.062h-203.31v-535.418h323.593v391.717l11.709-1.064h5.322v-425.78h-357.655v604.607h228.857zm86.22-173.506v-370.428h-272.499v484.324h178.827c5.322-54.287 43.642-98.994 93.672-113.896zm108.574 117.09c0-11.709-9.58-20.225-20.225-20.225v-24.482c0-28.74-23.418-51.094-51.094-51.094-28.74 0-51.094 23.418-51.094 51.094v24.482c-11.709 0-20.225 9.58-20.225 20.225v68.125c0 11.709 9.58 20.225 20.225 20.225h102.187c11.709 0 20.225-9.58 20.225-20.225v-68.125z" />
  </IconBase>
);

export const IconCasementWindowClosedUnlocked = (props: Props) => (
  <IconBase
    viewBox="0 0 809 1024"
    {...props}
    data-component-name="IconCasementWindowClosedUnlocked"
  >
    <path d="M205.439 200.116h323.593v391.717c-8.516 1.064-17.031 2.129-25.547 5.322v-371.493h-272.499v484.324h178.827l-1.064 12.773s0 8.516 1.064 12.773h-204.374v-535.418zm211.825 569.481h-228.857v-604.607h357.655v425.78c8.516 0 17.031 1.064 25.547 3.193v-454.52h-408.748v655.701h268.241c-5.322-7.451-9.58-17.031-13.838-25.547zm151.152-15.967c0 3.193-2.129 6.387-5.322 7.451v13.838c0 1.064-1.064 2.129-2.129 2.129s-2.129-1.064-2.129-2.129v-13.838c-3.193-1.064-5.322-4.258-5.322-7.451 0-4.258 3.193-7.451 7.451-7.451s7.451 3.193 7.451 7.451zm102.187-26.611c0 70.254-56.416 126.669-126.669 126.669s-126.669-56.416-126.669-126.669c0-70.254 56.416-126.669 126.669-126.669s126.669 56.416 126.669 126.669zm-55.351 8.515c0-8.516-7.451-15.967-15.967-15.967h-61.738v-38.32c0-21.289-17.031-38.32-38.32-38.32s-38.32 17.031-38.32 38.32v20.225c0 4.258 3.193 7.451 7.451 7.451s7.451-3.193 7.451-7.451v-20.225c0-12.773 10.644-23.418 23.418-23.418s23.418 10.644 23.418 23.418c0 0 0 39.385-1.064 38.32-8.516 0-14.902 7.451-14.902 15.967v51.094c0 8.516 7.451 15.967 15.967 15.967h76.64c8.516 0 15.967-7.451 15.967-15.967v-51.094z" />
  </IconBase>
);

export const IconCasementWindowClosed = (props: Props) => (
  <IconBase
    viewBox="0 0 638 1024"
    {...props}
    data-component-name="IconCasementWindowClosed"
  >
    <path d="M571.844 930.909h-505.351v-836.156h505.351zm-465.454-39.896h425.558v-756.364h-425.558zm512 132.987h-598.442l-.677.012c-10.65 0-19.283-8.633-19.283-19.283l.013-.711-.001-984.07-.012-.677c0-10.65 8.633-19.283 19.283-19.283l.711.013 598.407-.001.677-.012c10.65 0 19.283 8.633 19.283 19.283l-.013.711.001 984.07.012.677c0 10.65-8.633 19.283-19.283 19.283l-.711-.013zm-578.494-39.896h558.545v-944.208h-558.545z" />
  </IconBase>
);

export const IconCasementWindowOpen = (props: Props) => (
  <IconBase
    viewBox="0 0 548 1024"
    {...props}
    data-component-name="IconCasementWindowOpen"
  >
    <path d="M531.28 952.591h-514.142c-9.997 0-17.138-7.141-17.138-17.138v-845.478c0-9.997 7.141-17.138 17.138-17.138h514.142c9.997 0 17.138 7.141 17.138 17.138v845.478c0 9.997-8.569 17.138-17.138 17.138zm-497.004-34.276h479.866v-811.202h-479.866v811.202zm378.466 105.685l-355.615-157.099v-705.517l355.615-161.384v1024zm-321.339-178.522l287.063 125.679v-918.315l-287.063 129.964v662.672z" />
  </IconBase>
);

export const IconCasementWindowUnknown = (props: Props) => (
  <IconBase
    viewBox="0 0 730 1024"
    {...props}
    data-component-name="IconCasementWindowUnknown"
  >
    <path d="M353.524 815.238l-1.524 19.81s0 10.667 1.524 16.762h-274.286c-10.667 0-18.286-7.619-18.286-18.286v-729.905c0-10.667 7.619-18.286 18.286-18.286h426.667c10.667 0 18.286 7.619 18.286 18.286v544c-12.19 1.524-24.381 3.048-36.571 7.619v-533.333h-390.095v693.333h256zm10.666 86.857h-327.619v-865.524h512v609.524c12.19 0 24.381 1.524 36.571 4.571v-632.381c0-10.667-7.619-18.286-18.286-18.286h-548.571c-10.667 0-18.286 7.619-18.286 18.286v902.095c0 10.667 7.619 18.286 18.286 18.286h364.19c-7.619-12.19-13.714-24.381-18.286-36.571zm176.762-248.381c-100.571 0-181.333 80.762-181.333 181.333s80.762 181.333 181.333 181.333 181.333-80.762 181.333-181.333-80.762-181.333-181.333-181.333zm18.286 274.286h-30.476v-121.905h30.476v121.905zm0-152.381h-30.476v-30.476h30.476v30.476z" />
  </IconBase>
);

const rotateAnimationId = "nx-components_Icons_rotate";
GlobalStyleSheet.preload(
  rotateAnimationId,
  `
    @keyframes ${rotateAnimationId} {
      0% { transform: rotate(360deg); }
      50% { transform: rotate(180deg); }
      100% { transform: rotate(0deg); }
    }
  `
);

export const IconChat = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconChat">
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M9,6a5,5,0,0,0-5,5V35a5,5,0,0,0,5,5h4.09a7.84,7.84,0,0,1-.18,3.25,5.18,5.18,0,0,1-2.41,2.91A1,1,0,0,0,11,48a12.39,12.39,0,0,0,11.56-8H45a5,5,0,0,0,5-5V11a5,5,0,0,0-5-5Zm8,14a3,3,0,1,0,3,3A3,3,0,0,0,17,20Zm10,0a3,3,0,1,0,3,3A3,3,0,0,0,27,20Zm10,0a3,3,0,1,0,3,3A3,3,0,0,0,37,20Z"
    />
  </IconBase>
);

export const IconCheckSign = (props: Props) => (
  <IconBase
    viewBox="0 0 878 1024"
    {...props}
    data-component-name="IconCheckSign"
  >
    <path d="M391.429 742.286l350.857-350.857q10.857-10.857 10.857-25.714t-10.857-25.714l-58.286-58.286q-10.857-10.857-25.714-10.857t-25.714 10.857l-266.857 266.857-120.571-120.571q-10.857-10.857-25.714-10.857t-25.714 10.857l-58.286 58.286q-10.857 10.857-10.857 25.714t10.857 25.714l204.571 204.571q10.857 10.857 25.714 10.857t25.714-10.857zm486.285-504.572v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z" />
  </IconBase>
);

export const IconCheckmark = (props: Props) => (
  <IconBase
    viewBox="0 0 1024 1024"
    {...props}
    data-component-name="IconCheckmark"
  >
    <path d="M864 128l-480 480-224-224-160 160 384 384 640-640z" />
  </IconBase>
);

export const IconChevronDown = (props: Props) => (
  <IconBase
    viewBox="0 0 950 1024"
    {...props}
    data-component-name="IconChevronDown"
  >
    <path d="M920.144 402.286q0 30.286-21.142 51.428l-372 372q-21.714 21.714-52 21.714-30.858 0-51.428-21.714l-372-372q-21.714-20.572-21.714-51.428 0-30.286 21.714-52l42.286-42.858q22.286-21.142 52-21.142 30.286 0 51.428 21.142l277.714 277.714 277.714-277.714q21.142-21.142 51.428-21.142 29.714 0 52 21.142l42.858 42.858q21.142 22.286 21.142 52z" />
  </IconBase>
);

export const IconChevronLeft = (props: Props) => (
  <IconBase
    viewBox="0 0 658 1024"
    {...props}
    data-component-name="IconChevronLeft"
  >
    <path d="M423.858 898.858l-372.572-372q-21.142-21.142-21.142-51.714t21.142-51.714l372.572-372q21.142-21.142 51.714-21.142t51.714 21.142l42.858 42.858q21.142 21.142 21.142 51.714t-21.142 51.714l-277.714 277.714 277.714 277.142q21.142 21.714 21.142 52t-21.142 51.428l-42.858 42.858q-21.142 21.142-51.714 21.142t-51.714-21.142z" />
  </IconBase>
);

export const IconChevronRight = (props: Props) => (
  <IconBase
    viewBox="0 0 658 1024"
    {...props}
    data-component-name="IconChevronRight"
  >
    <path d="M627.856 475.428q0 29.714-21.142 52l-372.572 372q-21.142 21.142-51.428 21.142t-51.428-21.142l-43.428-42.858q-21.142-22.286-21.142-52 0-30.286 21.142-51.428l277.714-277.714-277.714-277.142q-21.142-22.286-21.142-52 0-30.286 21.142-51.428l43.428-42.858q20.572-21.714 51.428-21.714t51.428 21.714l372.572 372q21.142 21.142 21.142 51.428z" />
  </IconBase>
);

export const IconChevronUp = (props: Props) => (
  <IconBase
    viewBox="0 0 950 1024"
    {...props}
    data-component-name="IconChevronUp"
  >
    <path d="M920.144 694.858q0 30.286-21.142 51.428l-42.858 42.858q-21.714 21.714-52 21.714-30.858 0-51.428-21.714l-277.714-277.142-277.714 277.142q-20.572 21.714-51.428 21.714t-51.428-21.714l-42.858-42.858q-21.714-20.572-21.714-51.428 0-30.286 21.714-52l372-372q21.142-21.142 51.428-21.142 29.714 0 52 21.142l371.428 372q21.714 21.714 21.714 52z" />
  </IconBase>
);

export const IconCircle = (props: Props) => (
  <IconBase viewBox="0 0 878 1024" {...props} data-component-name="IconCircle">
    <path d="M877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z" />
  </IconBase>
);

const gradientHash = (colorTop, colorBottom) => {
  return `${colorTop}${colorBottom}`.replace(/[^a-z0-9]/gi, "");
};
export const IconCircleGradient = ({
  colorTop,
  colorBottom,
  ...props
}: Props & { colorTop: string, colorBottom: string }) => (
  <IconBase
    viewBox="0 0 100 100"
    {...props}
    data-component-name="IconCircleGradient"
  >
    <defs>
      <linearGradient
        id={`gradient-${gradientHash(colorTop, colorBottom)}`}
        x1="0%"
        y1="0%"
        x2="0%"
        y2="100%"
      >
        <stop offset="0%" stopColor={colorTop} />
        <stop offset="100%" stopColor={colorBottom} />
      </linearGradient>
    </defs>
    <circle
      cx="50"
      cy="50"
      r="47"
      stroke={`url(#gradient-${gradientHash(colorTop, colorBottom)})`}
      strokeWidth="3"
      fill="none"
    />
  </IconBase>
);

export const IconClimate = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconClimate">
    <path
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2px"
      d="M18,29.84V5H10v24.8A10,10,0,1,0,24,39,10.15,10.15,0,0,0,18,29.84ZM14,16V34m0,0a5,5,0,1,1-5,5A5,5,0,0,1,14,34ZM18,9h4m-4,4h3m-3,4h4m-4,4h3m-3,4h4"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2px"
      d="M43.12,29.84V5h-8v24.8a10,10,0,1,0,14,9.2A10.13,10.13,0,0,0,43.12,29.84ZM39.12,16V34m0,0a5,5,0,1,1-5,5A5,5,0,0,1,39.12,34Zm4-25h4m-4,4h3m-3,4h4m-4,4h3m-3,4h4"
    />
  </IconBase>
);

export const IconClock = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconClock">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      d="M27,4C14.3,4,4,14.3,4,27s10.3,23,23,23s23-10.3,23-23S39.7,4,27,4z M27,9c-0.6,0-1,0.4-1,1v14.2
        c-1.6,0.6-2.4,2.3-1.8,3.8c0,0.1,0.1,0.2,0.1,0.3l-6,6c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l0,0l6-6c1.5,0.6,3.3-0.1,3.9-1.6
        s-0.1-3.3-1.6-3.9V10C28,9.4,27.6,9,27,9z"
    />
  </IconBase>
);

export const IconClose = (props: Props) => (
  <IconBase viewBox="0 0 1024 1024" {...props} data-component-name="IconClose">
    <path d="M1014.662 822.66l-.012-.01-310.644-310.65 310.644-310.65.012-.01c3.344-3.346 5.762-7.254 7.312-11.416 4.246-11.376 1.824-24.682-7.324-33.83l-146.746-146.746c-9.148-9.146-22.45-11.566-33.828-7.32-4.16 1.55-8.07 3.968-11.418 7.31l-.008.01-310.648 310.652-310.648-310.65-.01-.01c-3.346-3.342-7.254-5.76-11.414-7.31-11.38-4.248-24.682-1.826-33.83 7.32l-146.748 146.748c-9.148 9.148-11.568 22.452-7.322 33.828 1.552 4.16 3.97 8.072 7.312 11.416l.01.01 310.65 310.648-310.65 310.652-.008.01c-3.342 3.346-5.76 7.254-7.314 11.414-4.248 11.376-1.826 24.682 7.322 33.83l146.748 146.746c9.15 9.148 22.452 11.568 33.83 7.322 4.16-1.552 8.07-3.97 11.416-7.312l.01-.01 310.648-310.65 310.648 310.65.012.008c3.348 3.344 7.254 5.762 11.414 7.314 11.378 4.246 24.684 1.826 33.828-7.322l146.746-146.748c9.148-9.148 11.57-22.454 7.324-33.83-1.552-4.16-3.97-8.068-7.314-11.414z" />
  </IconBase>
);

export const IconCloudOff = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconCloudOff">
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M43.2,41.29a8.48,8.48,0,0,0,.3-16.88c0-.18,0-.36,0-.53A12.52,12.52,0,0,0,19.92,18M6,6.79,16.48,17.26h-.06l4.15,4.15v0L38.63,39.42h-.05l1.91,1.91h0L47.2,48M14,17.56A6.68,6.68,0,0,0,9.4,23.45a9.22,9.22,0,0,0,3.15,17.88H37.79"
    />
  </IconBase>
);

export const IconCreateGroup = (props: Props) => (
  <IconBase
    viewBox="0 0 1024 1024"
    {...props}
    data-component-name="IconCreateGroup"
  >
    <path d="M910.288 900.407h-677.12c-43.993 0-79.658-35.664-79.658-79.658v-736.909c0-43.994 35.665-79.658 79.658-79.658h677.12c43.994 0 79.658 35.664 79.658 79.658v736.909c0 43.994-35.664 79.658-79.658 79.658zm-154.025-471.099c0-6.841-2.494-12.909-7.468-18.203-4.982-4.668-11.049-7.154-18.204-7.468l-110.618.467v-111.552c0-6.841-2.494-12.908-7.468-18.203-4.982-4.667-11.049-7.154-18.204-7.468l-51.341.467c-7.162-.307-13.229 2.181-18.203 7.468-4.982 4.667-7.469 10.735-7.469 18.203v110.619l-110.618.467c-7.162-.307-13.229 2.181-18.203 7.468-4.982 4.667-7.469 10.735-7.469 18.203v50.408c0 7.468 2.487 13.536 7.469 18.203 4.974 5.295 11.041 7.782 18.203 7.468l110.618.467v110.618c0 7.468 2.487 13.535 7.469 18.203 4.974 5.294 11.041 7.782 18.203 7.468l51.341.467c7.154-.307 13.222-2.801 18.204-7.468 4.974-5.287 7.468-11.355 7.468-18.204v-111.552l110.618.467c7.154-.307 13.222-2.801 18.204-7.468 4.974-5.287 7.468-11.355 7.468-18.203v-51.342zm-590.786 538.676h677.12c8.418 0 16.521-1.325 24.138-3.746-10.209 32.221-40.336 55.579-75.934 55.579h-677.09c-43.994 0-79.658-35.664-79.658-79.658v-736.833c0-35.585 23.343-65.701 55.544-75.921-2.439 7.643-3.779 15.775-3.779 24.226v736.695c.002 43.995 35.665 79.658 79.659 79.658z" />
  </IconBase>
);

export const IconDoorOpen = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconDoorOpen">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M28.78,1.5l-.09,0-16,5a1,1,0,0,0-.69,1v40a1,1,0,0,0,.75,1l16,4a1,1,0,0,0,1.25-1V2.5a1,1,0,0,0-.34-.75,1,1,0,0,0-.78-.25ZM32,48.5h9a1,1,0,0,0,1-1V6.5a1,1,0,0,0-1-1H32m-6,20c-.55,0-1,.68-1,1.5s.45,1.5,1,1.5,1-.67,1-1.5S26.55,25.5,26,25.5Z"
    />
  </IconBase>
);

export const IconDoor = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconDoor">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M12.91,4A1,1,0,0,0,12,5V49a1,1,0,0,0,1,1H41a1,1,0,0,0,1-1V4.91A1,1,0,0,0,41,4H12.91ZM36.5,26A1.5,1.5,0,1,0,38,27.5,1.5,1.5,0,0,0,36.5,26Z"
    />
  </IconBase>
);

export const IconDoorbellTriggered = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconDoorbellTriggered"
  >
    <path d="M35.05,29.29a2.11,2.11,0,1,0-2.11-2.1A2.11,2.11,0,0,0,35.05,29.29Zm0-2.52a.42.42,0,1,1-.42.42A.42.42,0,0,1,35.05,26.77Zm5.48,9V8.08a1.66,1.66,0,0,0-1.67-1.53H15.1a1.67,1.67,0,0,0-1.53,1.68V45.3A1.69,1.69,0,0,0,15.25,47H33.13a7,7,0,0,0,5.54,2.69v0a7.07,7.07,0,0,0,1.86-13.9ZM38.67,48a5.4,5.4,0,0,1-5.39-5.39H31.6a7.09,7.09,0,0,0,.53,2.69H15.25V8.23H38.84v27.3h-.17a7.08,7.08,0,0,0-7.07,7.07h1.68a5.4,5.4,0,0,1,5.39-5.39h.27A5.39,5.39,0,0,1,38.67,48Zm3.7-4.72A1.81,1.81,0,0,0,42,43a1.56,1.56,0,0,1-.21-.18,2.18,2.18,0,0,1-.34-1.43,2.57,2.57,0,0,0-1.34-2.32,1.34,1.34,0,0,0-2.62,0,2.57,2.57,0,0,0-1.34,2.32,2.18,2.18,0,0,1-.34,1.43,1.48,1.48,0,0,1-.26.21,1.88,1.88,0,0,0-.29.26A1.11,1.11,0,0,0,35,44a1.35,1.35,0,0,0,.64,1.12,2.62,2.62,0,0,0,.93.35,5.1,5.1,0,0,0,.65.09,1.63,1.63,0,0,0,1.58,1.23,1.65,1.65,0,0,0,1.59-1.23,5.19,5.19,0,0,0,.64-.09,2.44,2.44,0,0,0,.93-.35A1.34,1.34,0,0,0,42.65,44,1.09,1.09,0,0,0,42.37,43.28Zm-1.57.85a6.38,6.38,0,0,1-1.07.12l-.82.1.2.81a.27.27,0,1,1-.53-.07l.2-.8-.83,0a6.11,6.11,0,0,1-1.06-.12L36.52,44a2.33,2.33,0,0,0,.34-.31,3.34,3.34,0,0,0,.7-2.34,1.21,1.21,0,0,1,.84-1.22l.43-.14.45.14a1.22,1.22,0,0,1,.85,1.22,3.29,3.29,0,0,0,.7,2.34,2.16,2.16,0,0,0,.32.3A1.68,1.68,0,0,1,40.8,44.13ZM43,17.77a1,1,0,0,1-.7-.28,1,1,0,0,1,0-1.42l5.2-5.3a1,1,0,1,1,1.42,1.41l-5.2,5.3A1,1,0,0,1,43,17.77Zm9.9,8.61H45.5a1,1,0,0,1,0-2h7.4a1,1,0,0,1,0,2Zm-3.7,12.5a1,1,0,0,1-.71-.3l-5.3-5.3a1,1,0,0,1,0-1.41,1,1,0,0,1,1.42,0l5.3,5.3a1,1,0,0,1-.71,1.71Zm-38.3-21a1,1,0,0,1-.71-.3L5,12.3a1,1,0,0,1,1.42-1.4l5.2,5.3a1,1,0,0,1-.71,1.7ZM8.4,26.5H1a1,1,0,0,1,0-2H8.4a1,1,0,0,1,0,2ZM4.7,39A1,1,0,0,1,4,38.71a1,1,0,0,1,0-1.42L9.29,32a1,1,0,1,1,1.42,1.42l-5.3,5.3A1,1,0,0,1,4.7,39Z" />
  </IconBase>
);

export const IconDoorbellWaiting = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconDoorbellWaiting"
  >
    <path d="M33.4,28.4a2.5,2.5,0,1,0-2.5-2.5A2.5,2.5,0,0,0,33.4,28.4Zm0-3a.5.5,0,1,1-.5.5A.5.5,0,0,1,33.4,25.4Zm6.5,10.7V3.22a2,2,0,0,0-2-1.82H9.72a2,2,0,0,0-1.82,2v44a2,2,0,0,0,2,2H31.12a8.36,8.36,0,0,0,6.58,3.2v0a8.4,8.4,0,0,0,2.2-16.5ZM37.7,50.6a6.41,6.41,0,0,1-6.4-6.4h-2a8.34,8.34,0,0,0,.64,3.2H9.9V3.4h28V35.8h-.2v0a8.41,8.41,0,0,0-8.4,8.4h2a6.41,6.41,0,0,1,6.4-6.4v0H38A6.4,6.4,0,0,1,37.7,50.6ZM42.09,45a2.16,2.16,0,0,0-.39-.34c-.07-.06-.16-.12-.25-.21A2.6,2.6,0,0,1,41,42.76,3.07,3.07,0,0,0,39.46,40a1.6,1.6,0,0,0-3.12,0,3.06,3.06,0,0,0-1.58,2.76,2.58,2.58,0,0,1-.41,1.69,1.89,1.89,0,0,1-.3.25,2.08,2.08,0,0,0-.35.31,1.28,1.28,0,0,0-.32.84,1.6,1.6,0,0,0,.76,1.33,3.18,3.18,0,0,0,1.11.42c.22,0,.48.08.77.11a1.94,1.94,0,0,0,3.76,0c.29,0,.54-.07.77-.11a3.25,3.25,0,0,0,1.1-.41,1.61,1.61,0,0,0,.77-1.34A1.29,1.29,0,0,0,42.09,45Zm-1.87,1a8.24,8.24,0,0,1-1.26.14l-1,.12.24,1a.32.32,0,1,1-.63-.08l.23-.95-1-.05A8.24,8.24,0,0,1,35.58,46a2.4,2.4,0,0,1-.43-.11,3.24,3.24,0,0,0,1.23-3.14,1.45,1.45,0,0,1,1-1.45l.51-.17.55.17a1.45,1.45,0,0,1,1,1.45,3.16,3.16,0,0,0,1.23,3.13A1.73,1.73,0,0,1,40.22,46Z" />
  </IconBase>
);

export const IconDoubleHungWindowClosedLocked = (props: Props) => (
  <IconBase
    viewBox="0 0 629 1024"
    {...props}
    data-component-name="IconDoubleHungWindowClosedLocked"
  >
    <path d="M263.022 817.157v-137.895h145.556v40.858c10.214-5.107 21.706-7.661 33.197-10.214v-624.359h-390.703v764.808h263.022c1.277-11.491 3.83-22.983 6.384-33.197h-57.456zm0-698.414h145.556v157.047h-145.556v-157.047zm0 190.245h145.556v148.11h-145.556v-148.11zm0 196.628h145.556v140.449h-145.556v-140.449zm-33.197 311.541h-145.556v-137.895h145.556v137.895zm0-171.092h-145.556v-140.449h145.556v140.449zm0-188.968h-145.556v-148.11h145.556v148.11zm0-181.306h-145.556v-157.047h145.556v157.047zm99.591 661.386h-312.818c-8.938 0-16.599-7.661-16.599-16.599v-903.98c0-8.938 7.661-16.599 16.599-16.599h459.651c8.938 0 16.599 7.661 16.599 16.599v692.03c-7.661-1.277-14.045-1.277-21.706-1.277h-11.491v-674.155h-426.454v870.783h284.728c2.554 11.491 6.384 22.983 11.491 33.197zm141.726-223.441c84.269 0 151.94 67.671 151.94 151.94s-67.671 151.94-151.94 151.94-151.94-67.671-151.94-151.94 67.671-151.94 151.94-151.94zm-8.938 177.476c-3.83-1.277-7.661-5.107-7.661-10.214 0-6.384 5.107-11.491 11.491-11.491s11.491 5.107 11.491 11.491c0 5.107-2.554 8.938-7.661 10.214v19.152c0 2.554-1.277 3.83-3.83 3.83s-3.83-1.277-3.83-3.83v-19.152zm-52.349-60.01c-12.768 0-22.983 10.214-22.983 22.983v75.332c0 12.768 10.214 22.983 22.983 22.983h113.636c12.768 0 22.983-10.214 22.983-22.983v-75.332c0-12.768-10.214-22.983-22.983-22.983v-26.813c0-30.643-25.536-56.18-56.18-56.18s-56.18 25.536-56.18 56.18c-1.277 8.938-1.277 17.875-1.277 26.813zm22.983 0v-26.813c0-19.152 15.322-34.474 34.474-34.474s34.474 15.322 34.474 34.474v26.813h-68.948z" />
  </IconBase>
);

export const IconDoubleHungWindowClosedUnlocked = (props: Props) => (
  <IconBase
    viewBox="0 0 629 1024"
    {...props}
    data-component-name="IconDoubleHungWindowClosedUnlocked"
  >
    <path d="M263.022 817.157v-137.895h145.556v40.858c10.214-5.107 21.706-7.661 33.197-10.214v-624.359h-390.703v764.808h263.022c1.277-11.491 3.83-22.983 6.384-33.197h-57.456zm0-698.414h145.556v157.047h-145.556v-157.047zm0 190.245h145.556v148.11h-145.556v-148.11zm0 196.628h145.556v140.449h-145.556v-140.449zm-33.197 311.541h-145.556v-137.895h145.556v137.895zm0-171.092h-145.556v-140.449h145.556v140.449zm0-188.968h-145.556v-148.11h145.556v148.11zm0-181.306h-145.556v-157.047h145.556v157.047zm100.868 661.386h-314.095c-8.938 0-16.599-7.661-16.599-16.599v-903.98c0-8.938 7.661-16.599 16.599-16.599h459.651c8.938 0 16.599 7.661 16.599 16.599v692.03c-7.661-1.277-14.045-1.277-21.706-1.277h-11.491v-674.155h-426.454v870.783h284.728c2.554 11.491 6.384 22.983 12.768 33.197zm177.477-43.411c0 3.83-2.554 7.661-6.384 8.938v16.599c0 1.277-1.277 2.554-2.554 2.554s-2.554-1.277-2.554-2.554v-16.599c-3.83-2.554-6.384-5.107-8.938-8.938 0-5.107 5.107-10.214 10.214-10.214s10.214 5.107 10.214 10.214zm114.912-28.09c0 84.269-67.671 151.94-151.94 151.94s-151.94-67.671-151.94-151.94c0-84.269 67.671-151.94 151.94-151.94s151.94 67.671 151.94 151.94zm-54.902 5.107c0-10.214-8.938-19.152-19.152-19.152h-76.608v-48.519c0-26.813-21.706-47.242-48.519-47.242h-1.277c-25.536 0-47.242 21.706-47.242 47.242v25.536c0 5.107 5.107 10.214 10.214 10.214s10.214-5.107 10.214-10.214v-25.536c0-15.322 12.768-28.09 28.09-28.09s28.09 12.768 28.09 28.09c0 0 0 48.519 1.277 48.519-10.214 0-19.152 8.938-19.152 19.152v63.84c0 10.214 8.938 19.152 19.152 19.152h95.761c10.214 0 19.152-8.938 19.152-19.152v-63.84z" />
  </IconBase>
);

export const IconDoubleHungWindowClosed = (props: Props) => (
  <IconBase
    viewBox="0 0 539 1024"
    {...props}
    data-component-name="IconDoubleHungWindowClosed"
  >
    <path d="M520.371 1024h-502.234c-10.016 0-18.136-8.12-18.136-18.136v-987.728c0-10.016 8.12-18.136 18.136-18.136h502.234c10.016 0 18.136 8.12 18.136 18.136v987.728c0 10.016-8.12 18.136-18.136 18.136zm-484.099-36.272h465.962v-951.455h-465.962zm446.431-58.594h-426.899v-835.662h426.899zm-390.627-36.273h354.354v-763.117h-354.354zm195.314 18.136h-36.272v-799.39h36.272zm177.177-573.384h-390.627v-36.272h390.627zm0 404.578h-390.627v-36.272h390.627zm0-190.152h-390.627v-52.037h390.627z" />
  </IconBase>
);

export const IconDoubleHungWindowOpen = (props: Props) => (
  <IconBase
    viewBox="0 0 738 1024"
    {...props}
    data-component-name="IconDoubleHungWindowOpen"
  >
    <path d="M564.148 856.889h-362.667v-709.926h362.667v709.926zm-331.852-30.815h301.037v-648.296h-301.037v648.296zm363.852 111.407h-426.667c-8.296 0-15.407-7.111-15.407-15.407v-839.111c0-8.296 7.111-15.407 15.407-15.407h426.667c8.296 0 15.407 7.111 15.407 15.407v839.111c0 8.296-7.111 15.407-15.407 15.407zm-411.259-30.814h395.852v-808.296h-395.852v808.296zm209.778-303.408h-24.889v-440.889h24.889v440.889zm154.074-248.889h-331.852v-30.815h331.852v30.815zm0 106.667h-331.852v-30.815h331.852v30.815zm0 165.926h-331.852v-30.815h331.852v30.815z" />
  </IconBase>
);

export const IconDoubleHungWindowUnknown = (props: Props) => (
  <IconBase
    viewBox="0 0 629 1024"
    {...props}
    data-component-name="IconDoubleHungWindowUnknown"
  >
    <path d="M331.97 937.177h-315.372c-8.938 0-16.599-7.661-16.599-16.599v-903.98c0-8.938 7.661-16.599 16.599-16.599h459.651c8.938 0 16.599 7.661 16.599 16.599v693.307c-7.661-1.277-16.599-2.554-24.259-2.554h-8.938v-674.155h-426.454v870.783h286.005c2.554 11.491 7.661 22.983 12.768 33.197zm-12.768-120.02c-3.83 10.214-5.107 21.706-6.384 33.197h-261.746v-764.808h390.703v624.359c-11.491 2.554-22.983 5.107-33.197 8.938v-39.581h-145.556v137.895h56.18zm89.377-171.092v-140.449h-145.556v140.449h145.556zm-178.754-337.077h-145.556v148.11h145.556v-148.11zm33.197 148.109h145.556v-148.11h-145.556v148.11zm-178.753 48.519v140.449h145.556v-140.449h-145.556zm324.31-386.873h-145.556v157.047h145.556v-157.047zm-324.31 0v157.047h145.556v-157.047h-145.556zm0 698.414h145.556v-137.895h-145.556v137.895zm386.873-97.037c-80.439 0-145.556 65.117-145.556 145.556s65.117 145.556 145.556 145.556c80.439 0 145.556-65.117 145.556-145.556s-65.117-145.556-145.556-145.556zm14.045 228.548h-25.536v-102.145h25.536v102.145zm0-127.68h-25.536v-25.536h25.536v25.536z" />
  </IconBase>
);

export const IconDroplets = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconDroplets">
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M10,1.84,9.19,2.91A61.84,61.84,0,0,0,5.62,8.28C3.84,11.31,2,15,2,18a8,8,0,0,0,16,0c0-3.05-1.84-6.69-3.62-9.72a61.84,61.84,0,0,0-3.57-5.37Zm34,9.1L43.22,12a59.94,59.94,0,0,0-3.6,5.34C37.84,20.35,36,24,36,27a8,8,0,0,0,16,0c0-3.05-1.84-6.65-3.62-9.66A59.94,59.94,0,0,0,44.78,12ZM24,27.84l-.81,1.07a61.84,61.84,0,0,0-3.57,5.37C17.84,37.31,16,41,16,44a8,8,0,0,0,16,0c0-3-1.84-6.69-3.62-9.72a61.84,61.84,0,0,0-3.57-5.37Z"
    />
  </IconBase>
);

export const IconEnvelope = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconEnvelope">
    <path d="M51,45H3a1,1,0,0,1-1-1V10A1,1,0,0,1,3,9H51a1,1,0,0,1,1,1V44A1,1,0,0,1,51,45ZM4,43H50V11H4ZM27.23,31.35,50,20.92V18.7L26.82,29.33,4,18.5v2.29L26.39,31.34a.91.91,0,0,0,.43.1A1,1,0,0,0,27.23,31.35Z" />
  </IconBase>
);

export const IconEqualizer = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconEqualizer">
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2px"
      d="M44,51a2.07,2.07,0,0,1-1-.26A2,2,0,0,1,42,49V31.06a1.31,1.31,0,0,1,0-.28V24H41a4,4,0,0,1-4-4V18a4,4,0,0,1,4-4h1V5a2,2,0,0,1,1.56-2l.17,0h.08a2,2,0,0,1,1.56.53A2,2,0,0,1,46,5.05v9h1a4,4,0,0,1,4,4v2a4,4,0,0,1-4,4H46v6.77a1.31,1.31,0,0,1,0,.28V49a2,2,0,0,1-1,1.74A2,2,0,0,1,44,51ZM27,51a2.07,2.07,0,0,1-1-.26A2,2,0,0,1,25,49V44.06a1.31,1.31,0,0,1,0-.28V42H24a4,4,0,0,1-4-4V36a4,4,0,0,1,4-4h1V5a2,2,0,0,1,1.56-2l.17,0h.08a2,2,0,0,1,1.56.53A2,2,0,0,1,29,5.05V32h1a4,4,0,0,1,4,4v2a4,4,0,0,1-4,4H29v1.77a1.31,1.31,0,0,1,0,.28V49a2,2,0,0,1-1,1.74A2,2,0,0,1,27,51ZM10,51a2.07,2.07,0,0,1-1-.26A2,2,0,0,1,8,49V28.06a1.31,1.31,0,0,1,0-.28V21H7a4,4,0,0,1-4-4V15a4,4,0,0,1,4-4H8V5A2,2,0,0,1,9.56,3l.17,0h.08a2,2,0,0,1,1.56.53A2,2,0,0,1,12,5.05v6h1a4,4,0,0,1,4,4v2a4,4,0,0,1-4,4H12v6.77a1.31,1.31,0,0,1,0,.28V49a2,2,0,0,1-1,1.74A2,2,0,0,1,10,51ZM8,11h4M8,21h4M25,32h4M25,42h4M42,14h4M42,24h4.42"
    />
  </IconBase>
);

export const IconExit = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconExit">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M34.3,13V3c0-0.6-0.4-1-1-1h-30C3.3,2,3.2,2,3.1,2C2.6,2.1,2.3,2.5,2.3,3v48c0,0.6,0.4,1,1,1h30
        c0.6,0,1-0.4,1-1V41 M42.1,36.6l8.9-8.9l0.7-0.7L51,26.3l-8.9-8.9 M21.3,27h29.6"
    />
  </IconBase>
);

export const IconFanMoving = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconFanMoving"
    style={{
      overflow: "visible",
      ...props.style,
    }}
  >
    <g
      style={{
        animation: `${rotateAnimationId} 3s linear 0ms infinite `,
        transformOrigin: "center",
      }}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth="2px"
        d="M41.2,26.8c-1.7-1.7-3.8-2.9-6.2-3.4l7.1-7.1c1.5-1.5,2.3-3.4-0.5-5.4c-5.8-3.4-13.3-1.4-16.8,4.4
    			c-0.7,1.1-1.1,2.4-1.4,3.7l-7.2-7.1c-1.5-1.5-3.4-2.3-5.4,0.5c-3.4,5.9-1.5,13.4,4.4,16.8c1.1,0.7,2.4,1.1,3.7,1.4l-7.1,7.1
    			c-1.5,1.5-2.4,3.5,0.5,5.4c5.8,3.4,13.4,1.5,16.8-4.4c0.7-1.1,1.2-2.4,1.4-3.7l7.1,7.1c1.5,1.5,3.4,2.3,5.4-0.5
    			C45.9,36.8,45.1,30.8,41.2,26.8z M27,31.5c-2.5,0-4.5-2-4.5-4.5l0,0l0,0c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5S29.4,31.5,27,31.5
    			C27,31.5,27,31.5,27,31.5z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        d="M16.2,38.3l-0.3,0.4l-0.3,0.4l0,0c-3.5-3-5.6-7.3-5.9-11.9c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5
    			C10.9,31.4,12.9,35.4,16.2,38.3z M38.5,13L38.5,13c-0.3-0.2-0.6-0.1-0.7,0.1c-0.2,0.2-0.2,0.5,0.1,0.7c3.3,2.8,5.3,6.8,5.6,11.2
    			c0,0.3,0.2,0.5,0.5,0.5l0,0c0.3,0,0.5-0.3,0.5-0.5c0,0,0,0,0,0C44,20.3,41.9,16,38.5,13z M39.3,36.8c-2.9,3.3-6.9,5.2-11.2,5.5
    			c-0.3,0-0.5,0.3-0.5,0.5c0,0,0,0,0,0c0,0.3,0.2,0.5,0.5,0.5l0,0c4.6-0.3,8.9-2.4,11.9-5.9l-0.4-0.3l0.4,0.3c0.2-0.2,0.2-0.5,0-0.7
    			C39.8,36.6,39.5,36.6,39.3,36.8L39.3,36.8z M14.4,15.4c0.1,0,0.3-0.1,0.4-0.2c2.9-3.3,6.9-5.2,11.2-5.5c0.3,0,0.5-0.3,0.5-0.5
    			c0,0,0,0,0,0c0-0.3-0.3-0.5-0.5-0.5c0,0,0,0,0,0C21.3,9,17,11.1,14,14.5l0,0c-0.2,0.2-0.2,0.5,0,0.7
    			C14.1,15.3,14.2,15.4,14.4,15.4L14.4,15.4z M28.2,39.8L28.2,39.8c3.6-0.2,7-1.9,9.5-4.7l-0.3-0.4L37,34.5
    			c-2.2,2.6-5.4,4.1-8.8,4.3c-0.3,0-0.5,0.2-0.5,0.5S27.9,39.8,28.2,39.8z M36.5,15.7L36.5,15.7c-0.3-0.2-0.6-0.2-0.8,0
    			c-0.2,0.2-0.2,0.5,0,0.7c2.6,2.2,4.1,5.4,4.3,8.8c0,0.3,0.2,0.5,0.5,0.5l0,0c0.3,0,0.5-0.2,0.5-0.5c0,0,0,0,0,0
    			C40.8,21.5,39.2,18.1,36.5,15.7z M18.6,36.1l-0.3,0.3l-0.1,0.1L18.6,36.1z M26.4,12.2c-3.7,0.2-7.1,1.9-9.5,4.7l0,0
    			c-0.2,0.2-0.2,0.5,0,0.7c0.2,0.2,0.5,0.2,0.7,0c0,0,0.1-0.1,0.1-0.1c2.2-2.6,5.4-4.1,8.8-4.3c0.3,0,0.5-0.3,0.5-0.5c0,0,0,0,0,0
    			C26.9,12.4,26.7,12.2,26.4,12.2z M14.5,26.9c0-0.3-0.3-0.5-0.5-0.5c-0.3,0-0.5,0.3-0.5,0.5c0,0,0,0,0,0c0.2,3.7,1.9,7.1,4.7,9.5
    			l0.1-0.1l0.6-0.7C16.3,33.4,14.7,30.2,14.5,26.9z"
      />
    </g>
  </IconBase>
);

export const IconFanOff = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconFanOff">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M37,17.6c-2.4,0-4.7,0.7-6.8,2V9.5c0-2.1-0.8-4.1-4.2-3.5c-6.5,1.7-10.4,8.4-8.8,15c0.3,1.3,0.9,2.5,1.6,3.6
      l-10.1,0c-2.1,0-4.1,0.8-3.5,4.2c1.7,6.6,8.4,10.5,15,8.8c1.3-0.3,2.5-0.9,3.6-1.6l0,10c0,2.1,0.8,4.1,4.2,3.5
      c6.6-1.7,10.5-8.4,8.8-15c-0.3-1.3-0.9-2.5-1.6-3.6h10.1c2.1,0,4.1-0.8,3.5-4.2C47.4,21.3,42.6,17.6,37,17.6z M30.2,31
      c-1.7,1.7-4.6,1.7-6.3,0l0,0l0,0c-1.7-1.7-1.7-4.6,0-6.3c1.7-1.7,4.6-1.7,6.3,0C32,26.4,32,29.2,30.2,31C30.2,31,30.2,31,30.2,31z"
    />
  </IconBase>
);

export const IconFanOn = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconFanOn"
    style={{
      overflow: "visible",
      ...props.style,
    }}
  >
    <g>
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth="2px"
        d="M41.2,26.8c-1.7-1.7-3.8-2.9-6.2-3.4l7.1-7.1c1.5-1.5,2.3-3.4-0.5-5.4c-5.8-3.4-13.3-1.4-16.8,4.4
    			c-0.7,1.1-1.1,2.4-1.4,3.7l-7.2-7.1c-1.5-1.5-3.4-2.3-5.4,0.5c-3.4,5.9-1.5,13.4,4.4,16.8c1.1,0.7,2.4,1.1,3.7,1.4l-7.1,7.1
    			c-1.5,1.5-2.4,3.5,0.5,5.4c5.8,3.4,13.4,1.5,16.8-4.4c0.7-1.1,1.2-2.4,1.4-3.7l7.1,7.1c1.5,1.5,3.4,2.3,5.4-0.5
    			C45.9,36.8,45.1,30.8,41.2,26.8z M27,31.5c-2.5,0-4.5-2-4.5-4.5l0,0l0,0c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5S29.4,31.5,27,31.5
    			C27,31.5,27,31.5,27,31.5z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth="0.5px"
        d="M16.2,38.3l-0.3,0.4l-0.3,0.4l0,0c-3.5-3-5.6-7.3-5.9-11.9c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5
    			C10.9,31.4,12.9,35.4,16.2,38.3z M38.5,13L38.5,13c-0.3-0.2-0.6-0.1-0.7,0.1c-0.2,0.2-0.2,0.5,0.1,0.7c3.3,2.8,5.3,6.8,5.6,11.2
    			c0,0.3,0.2,0.5,0.5,0.5l0,0c0.3,0,0.5-0.3,0.5-0.5c0,0,0,0,0,0C44,20.3,41.9,16,38.5,13z M39.3,36.8c-2.9,3.3-6.9,5.2-11.2,5.5
    			c-0.3,0-0.5,0.3-0.5,0.5c0,0,0,0,0,0c0,0.3,0.2,0.5,0.5,0.5l0,0c4.6-0.3,8.9-2.4,11.9-5.9l-0.4-0.3l0.4,0.3c0.2-0.2,0.2-0.5,0-0.7
    			C39.8,36.6,39.5,36.6,39.3,36.8L39.3,36.8z M14.4,15.4c0.1,0,0.3-0.1,0.4-0.2c2.9-3.3,6.9-5.2,11.2-5.5c0.3,0,0.5-0.3,0.5-0.5
    			c0,0,0,0,0,0c0-0.3-0.3-0.5-0.5-0.5c0,0,0,0,0,0C21.3,9,17,11.1,14,14.5l0,0c-0.2,0.2-0.2,0.5,0,0.7
    			C14.1,15.3,14.2,15.4,14.4,15.4L14.4,15.4z M28.2,39.8L28.2,39.8c3.6-0.2,7-1.9,9.5-4.7l-0.3-0.4L37,34.5
    			c-2.2,2.6-5.4,4.1-8.8,4.3c-0.3,0-0.5,0.2-0.5,0.5S27.9,39.8,28.2,39.8z M36.5,15.7L36.5,15.7c-0.3-0.2-0.6-0.2-0.8,0
    			c-0.2,0.2-0.2,0.5,0,0.7c2.6,2.2,4.1,5.4,4.3,8.8c0,0.3,0.2,0.5,0.5,0.5l0,0c0.3,0,0.5-0.2,0.5-0.5c0,0,0,0,0,0
    			C40.8,21.5,39.2,18.1,36.5,15.7z M18.6,36.1l-0.3,0.3l-0.1,0.1L18.6,36.1z M26.4,12.2c-3.7,0.2-7.1,1.9-9.5,4.7l0,0
    			c-0.2,0.2-0.2,0.5,0,0.7c0.2,0.2,0.5,0.2,0.7,0c0,0,0.1-0.1,0.1-0.1c2.2-2.6,5.4-4.1,8.8-4.3c0.3,0,0.5-0.3,0.5-0.5c0,0,0,0,0,0
    			C26.9,12.4,26.7,12.2,26.4,12.2z M14.5,26.9c0-0.3-0.3-0.5-0.5-0.5c-0.3,0-0.5,0.3-0.5,0.5c0,0,0,0,0,0c0.2,3.7,1.9,7.1,4.7,9.5
    			l0.1-0.1l0.6-0.7C16.3,33.4,14.7,30.2,14.5,26.9z"
      />
    </g>
  </IconBase>
);

export const IconFilter = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconFilter">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      d="M32,50.49a1.53,1.53,0,0,1-.75-.2l-10-6A1.51,1.51,0,0,1,20.5,43V25.58L4.92,9A1.45,1.45,0,0,1,4.5,8V5A1.5,1.5,0,0,1,5.72,3.52H48A1.5,1.5,0,0,1,49.5,5v3a1.59,1.59,0,0,1-.14.64l-.13.18a1.37,1.37,0,0,1-.16.18L49,9.18,33.5,25.58V49a1.48,1.48,0,0,1-.76,1.28A1.52,1.52,0,0,1,32,50.49ZM20.5,25.58h13"
    />
  </IconBase>
);

export const IconGarageClosed = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconGarageClosed"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M25,4.13,45,14.61V44H40V19a1,1,0,0,0-1-1H11a1,1,0,0,0-1,1V44H5V14.61ZM10,44H40M35,28.08v7.84"
    />
  </IconBase>
);

export const IconGarageOpen = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconGarageOpen">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M27,6.1,47,16.6V46H42V21a.94.94,0,0,0-1-1H13a.94.94,0,0,0-1,1V46H7V16.6Z"
    />
  </IconBase>
);

export const IconGaragePartial = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconGaragePartial"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M27,6.14,47,16.61V46H42V20.9a1,1,0,0,0-.72-.86H12.52a1.08,1.08,0,0,0-.24.18.61.61,0,0,0-.12.16.41.41,0,0,0-.05.09.67.67,0,0,0-.07.18A.82.82,0,0,0,12,21V46H7V16.61ZM30,20V46H12M26,30.08v7.84"
    />
  </IconBase>
);

export const IconGears = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconGears">
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M42.09,2a1,1,0,0,0-.71.47L39.75,5.16a8.69,8.69,0,0,0-1.53,0L36.56,2.5a1,1,0,0,0-1.25-.38L32.5,3.31a1,1,0,0,0-.59,1.16l.68,3a9.93,9.93,0,0,0-1.06,1.09l-3.06-.68a1,1,0,0,0-1.13.62l-1.15,2.81a1,1,0,0,0,.37,1.25l2.66,1.66a9.77,9.77,0,0,0,0,1.53l-2.63,1.66a1,1,0,0,0-.37,1.25l1.19,2.81a1,1,0,0,0,1.12.59l3.06-.68a10,10,0,0,0,1.1,1.06L32,25.53a1,1,0,0,0,.59,1.13l2.85,1.15a1,1,0,0,0,1.22-.37l1.68-2.66a9.13,9.13,0,0,0,1.57,0l1.68,2.66a1,1,0,0,0,1.22.37l2.85-1.19a1,1,0,0,0,.56-1.15l-.75-3.06a9.74,9.74,0,0,0,1.06-1.07l3.09.66a1,1,0,0,0,1.16-.63l1.16-2.81a1,1,0,0,0-.41-1.25l-2.69-1.66a8.88,8.88,0,0,0,0-1.46l2.66-1.75a1,1,0,0,0,.41-1.22L50.66,8.38a1,1,0,0,0-1.16-.6l-3,.75a10.2,10.2,0,0,0-1.09-1.09L46,4.38a1,1,0,0,0-.59-1.16L42.59,2.06A1.06,1.06,0,0,0,42.09,2ZM39,9.88a5.07,5.07,0,1,0,2,.37A5,5,0,0,0,39,9.88ZM16.34,19a1,1,0,0,0-.81.84l-.62,4a11.66,11.66,0,0,0-2.07.84L9.5,22.34a1,1,0,0,0-1.28.1L5.47,25.19a1,1,0,0,0-.09,1.28l2.34,3.34a12.12,12.12,0,0,0-.84,2.07l-4,.68a1,1,0,0,0-.84,1v3.88a1,1,0,0,0,.81,1l4,.68a11.79,11.79,0,0,0,.88,2.1L5.34,44.5a1,1,0,0,0,.1,1.28l2.75,2.75a1,1,0,0,0,1.28.09l3.34-2.34a12.12,12.12,0,0,0,2.07.84l.65,4a1,1,0,0,0,1,.84h3.88a1,1,0,0,0,1-.81l.71-4.1a12.15,12.15,0,0,0,2-.84l3.37,2.37a1,1,0,0,0,1.28-.09l2.75-2.75a1,1,0,0,0,.1-1.28l-2.41-3.38a11,11,0,0,0,.84-2l4.1-.68a1,1,0,0,0,.81-1V33.53a1,1,0,0,0-.84-1l-4.1-.68a11.31,11.31,0,0,0-.81-2l2.37-3.41a1,1,0,0,0-.09-1.28l-2.75-2.75a1,1,0,0,0-1.28-.1l-3.34,2.41a12.46,12.46,0,0,0-2.07-.84l-.68-4.07a1,1,0,0,0-1-.84H16.34ZM18.5,29.34a6.16,6.16,0,1,0,6.16,6.16A6.18,6.18,0,0,0,18.5,29.34Z"
    />
  </IconBase>
);

export const IconGlobe = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconGlobe">
    <path d="M27.09,51l-1,0A24,24,0,0,1,4.31,19.21,24,24,0,0,1,24.75,3.12,20.63,20.63,0,0,1,26.82,3h0a21.37,21.37,0,0,1,2.79.16h.32a19.62,19.62,0,0,1,4.28.88l.34.09a2.31,2.31,0,0,1,.68.35,23.3,23.3,0,0,1,5.12,2.62,2.06,2.06,0,0,1,.69.47A23.66,23.66,0,0,1,51,25.66a1.94,1.94,0,0,1,0,.68v.13c0,.17,0,.33,0,.5a24.91,24.91,0,0,1-4.57,14.26l0,0A24.06,24.06,0,0,1,27.09,51ZM26.84,5c-.63,0-1.27,0-1.9.09A22,22,0,0,0,6.2,19.86,22.05,22.05,0,0,0,44.8,40.07l0,0A22.82,22.82,0,0,0,49,27c0-.14,0-.28,0-.41V26.3a.85.85,0,0,1,0-.23,1.7,1.7,0,0,1,0-.22A21.63,21.63,0,0,0,39.8,9.16,1,1,0,0,1,39.59,9a.84.84,0,0,1-.27-.13,21.65,21.65,0,0,0-4.94-2.51A.88.88,0,0,1,34,6.07L33.66,6a17.41,17.41,0,0,0-3.86-.8,1,1,0,0,1-.3,0A19.59,19.59,0,0,0,26.84,5ZM29.73,46.2a1,1,0,0,1-.59-.19,1,1,0,0,1-.35-1.16L31,39l-.69-1-1.89-.83a1,1,0,0,1-.55-.6l-.81-2.42A.86.86,0,0,1,27,33.8V32.38a1,1,0,0,1,.29-.71L28,31V29.58a1,1,0,0,1,.55-.89l1.25-.62a.88.88,0,0,1,.42-.11l3.32-.08a.93.93,0,0,1,.76.32L35,29l1.85.92a1.24,1.24,0,0,1,.26.19L38,31l2.94.84a1,1,0,0,1,.7.72l.27,1.08a1,1,0,0,1-.08.69L41,36l-.87,2.6a1,1,0,0,1-.51.58L38,40l-7.66,6A1,1,0,0,1,29.73,46.2Zm-.12-10.71,1.48.64a2.12,2.12,0,0,1,.85.69l.69,1a2,2,0,0,1,.24,1.85l-.95,2.53,4.84-3.8a1.79,1.79,0,0,1,.34-.22l1.26-.63.74-2.22c0-.09.07-.18.11-.27l.67-1.33,0-.16-2.39-.68a2.07,2.07,0,0,1-.87-.51l-.77-.77-1.71-.85a2.37,2.37,0,0,1-.59-.45l-.38-.42L30.49,30,30,30.2V31a2,2,0,0,1-.59,1.41l-.41.41v.85ZM31,27a2,2,0,0,1-.64-.11l-3-1a2,2,0,0,1,.7-3.9,2.37,2.37,0,0,1,.58.11l3,1a2,2,0,0,1,1.16,1,2,2,0,0,1,.1,1.53,2,2,0,0,1-1,1.16A2,2,0,0,1,31,27Zm-3-3,3,1-3-1Zm-8,1.89a1,1,0,0,1-.45-.11l-1.18-.59a1,1,0,0,1-.5-.58l-1.82-5.45A.86.86,0,0,1,16,18.8V15.2a1,1,0,0,1,.1-.44L17,13V10l-.77-.38a1,1,0,0,1-.55-.88,1,1,0,0,1,.51-.89q.91-.51,1.86-.93A1,1,0,0,1,19,7l2,1.11L24,8a.94.94,0,0,1,.72.29A1,1,0,0,1,25,9v2.08l2,.9,1.29-1.3a1,1,0,0,1,1.41,0l2.43,2.43a1,1,0,0,1,.29.81,1,1,0,0,1-.44.73L30,16l-3.71,3.7a1,1,0,0,1-.71.3H24l-3,1v3.88a1,1,0,0,1-1,1Zm-2-7.21,1,3V21a2,2,0,0,1,1.36-1.9l3-1A2,2,0,0,1,24,18h1.17l3.41-3.42.3-.25,1-.64L29,12.79l-.59.59a2,2,0,0,1-2.23.41l-2-.9A2,2,0,0,1,23,11.07V10l-1.95.05a2,2,0,0,1-1-.25l-1.2-.66A2,2,0,0,1,19,10v3a2,2,0,0,1-.22.89L18,15.44ZM47.83,25.4a1,1,0,0,1-.89-.55l-.88-1.76a1.07,1.07,0,0,1-.09-.27l-.73-4a1,1,0,0,1,1.91-.57,22.39,22.39,0,0,1,1.67,6.06,1,1,0,0,1-.7,1.09A1,1,0,0,1,47.83,25.4ZM32.46,9a1,1,0,0,1-.7-.29L31,8l-1.47-.49a1,1,0,0,1-.66-.72,1,1,0,0,1,.27-.94l.26-.26a1,1,0,0,1,.86-.28,22,22,0,0,1,2.78.6,1,1,0,0,1,.69,1.21l-.3,1.18a1,1,0,0,1-.7.71A.84.84,0,0,1,32.46,9Z" />
  </IconBase>
);

export const IconGrid = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconGrid">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M16,22.12H8.72A1.22,1.22,0,0,0,7.5,23.34v7.32a1.22,1.22,0,0,0,1.22,1.22H16a1.22,1.22,0,0,0,1.22-1.22V23.34A1.22,1.22,0,0,0,16,22.12ZM16,7.5H8.72A1.21,1.21,0,0,0,7.5,8.72V16a1.21,1.21,0,0,0,1.22,1.22H16c.68,0,1.22-1.76,1.22-2.44V8.72A1.21,1.21,0,0,0,16,7.5Zm0,29.25H8.72A1.21,1.21,0,0,0,7.5,38v7.31A1.21,1.21,0,0,0,8.72,46.5H16a1.21,1.21,0,0,0,1.22-1.22V38A1.21,1.21,0,0,0,16,36.75ZM30.66,22.12H23.34a1.22,1.22,0,0,0-1.22,1.22v7.32a1.22,1.22,0,0,0,1.22,1.22h7.32a1.22,1.22,0,0,0,1.22-1.22V23.34A1.22,1.22,0,0,0,30.66,22.12Zm0,14.63H23.34A1.22,1.22,0,0,0,22.12,38v7.31a1.22,1.22,0,0,0,1.22,1.22h7.32a1.22,1.22,0,0,0,1.22-1.22V38A1.22,1.22,0,0,0,30.66,36.75ZM45.28,22.12H38a1.22,1.22,0,0,0-1.22,1.22v7.32A1.22,1.22,0,0,0,38,31.88h7.31a1.22,1.22,0,0,0,1.22-1.22V23.34A1.22,1.22,0,0,0,45.28,22.12Zm0-14.62H38a1.21,1.21,0,0,0-1.22,1.22V16A1.21,1.21,0,0,0,38,17.25h7.31c.68,0,1.22-1.76,1.22-2.44V8.72A1.21,1.21,0,0,0,45.28,7.5Zm-14.62,0H23.34a1.22,1.22,0,0,0-1.22,1.22V16a1.22,1.22,0,0,0,1.22,1.22h7.32c.67,0,1.22-1.76,1.22-2.44V8.72A1.22,1.22,0,0,0,30.66,7.5ZM45.28,36.75H38A1.21,1.21,0,0,0,36.75,38v7.31A1.21,1.21,0,0,0,38,46.5h7.31a1.21,1.21,0,0,0,1.22-1.22V38A1.21,1.21,0,0,0,45.28,36.75Z"
    />
  </IconBase>
);

export const IconSad = (props: Props) => (
  <IconBase viewBox="0 0 50 50" {...props} data-component-name="IconSad">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M15,35c0,0,4-4,10-4s10,4,10,4"
    />
    <g fill="currentColor">
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M25,2C12.297,2,2,12.297,2,25c0,12.703,10.297,23,23,23c12.703,0,23-10.297,23-23C48,12.297,37.703,2,25,2L25,2z"
      />
    </g>
    <circle cx="33" cy="22" r="3" fill="currentColor" />
    <circle cx="17" cy="22" r="3" fill="currentColor" />
  </IconBase>
);

export const IconHD = (props: Props) => (
  <IconBase viewBox="0 0 1365 1024" {...props} data-component-name="IconHD">
    <path d="M941.22 387.99h-35.924v254.655h35.282c30.102 0 51.516-3.343 64.227-10.022 12.713-6.675 22.67-18.331 29.887-34.966 7.194-16.647 10.803-43.605 10.803-80.913 0-49.382-8.061-83.186-24.154-101.412-16.121-18.227-42.817-27.343-80.121-27.343zm-579.562 57.544h157.361v-163.094h144.66v466.065h-144.66v-188.518h-157.361v188.517h-144.019v-466.065h144.019v163.096zm399.619 302.969v-466.065h213.955c42.185 0 76.247 5.722 102.212 17.171 25.967 11.441 47.428 27.87 64.379 49.277 16.961 21.405 29.247 46.309 36.878 74.706 7.634 28.404 11.441 58.498 11.441 90.291 0 49.801-5.67 88.426-17 115.886-11.341 27.435-27.083 50.447-47.215 68.98-20.142 18.546-41.755 30.894-64.853 37.041-31.587 8.475-60.192 12.711-85.842 12.711h-213.955zm477.048-611.712h-1111.306c-69.168 0-125.21 59.511-125.21 132.919v486.627c0 73.407 56.042 132.919 125.21 132.919h1111.306c69.144 0 125.196-59.511 125.196-132.919v-486.627c0-73.407-56.052-132.919-125.196-132.919z" />
  </IconBase>
);

export const IconHeart = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconHeart">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M37,8c-4.2,0-7.9,2.1-10,5.4C24.9,10.1,21.2,8,17,8C10.4,8,5,13.4,5,20c0,14,16,21,22,26c6-5,22-12,22-26 C49,13.4,43.6,8,37,8z"
    />
  </IconBase>
);

export const IconHingedDoorClosedLocked = (props: Props) => (
  <IconBase
    viewBox="0 0 1121 1024"
    {...props}
    data-component-name="IconHingedDoorClosedLocked"
  >
    <path d="M810.331 940.682c-6.719-10.751-10.751-21.501-14.782-33.596h-225.764v-798.236h344.021v587.255c10.751-2.688 21.501-4.031 32.252-4.031v-599.349c0-9.407-6.719-16.126-16.126-16.126h-376.273c-9.407 0-16.126 6.719-16.126 16.126v814.362h-21.501v-874.835h451.528v659.822c10.751 1.344 21.501 2.688 32.252 5.375v-681.323c0-9.407-6.719-16.126-16.126-16.126h-967.559c-9.407 0-16.126 6.719-16.126 16.126v907.087c0 9.407 6.719 16.126 16.126 16.126h47.034c1.344 0 4.031 1.344 6.719 1.344h376.273l6.719-1.344h94.068c2.688 1.344 4.031 1.344 6.719 1.344h256.672zm-778.079-908.43h451.528v874.835h-21.501v-814.362c0-9.407-6.719-16.126-16.126-16.126h-376.273c-9.407 0-16.126 6.719-16.126 16.126v814.362h-21.501v-874.835zm53.753 874.835v-798.236h344.021v798.236h-344.021zm501.25-381.649v-134.383h13.438v134.383h-13.438zm-174.699-134.383v134.383h-13.438v-134.383h13.438zm556.347 491.843c0 5.375-2.688 9.407-8.063 12.094v22.845c0 2.688-1.344 4.031-4.031 4.031s-4.031-1.344-4.031-4.031v-22.845h-2.688c-5.375-1.344-8.063-6.719-8.063-12.094 0-8.063 5.375-13.438 13.438-13.438 6.719 0 13.438 5.375 13.438 13.438zm-14.782-124.977c-21.501 0-38.971 17.47-38.971 38.971v29.564h77.942v-29.564c0-21.501-17.47-38.971-38.971-38.971zm159.916 99.444c0 88.693-71.223 159.916-159.916 159.916s-159.916-71.223-159.916-159.916 71.223-159.916 159.916-159.916 159.916 71.223 159.916 159.916zm-69.88-5.375c0-13.438-12.094-25.533-25.533-25.533v-30.908c0-36.283-29.564-64.504-64.504-64.504s-64.504 28.22-64.504 64.504v30.908c-13.438 0-25.533 12.094-25.533 25.533v86.005c0 13.438 12.094 25.533 25.533 25.533h129.008c13.438 0 25.533-12.094 25.533-25.533v-86.005z" />
  </IconBase>
);

export const IconHingedDoorClosedUnlocked = (props: Props) => (
  <IconBase
    viewBox="0 0 1121 1024"
    {...props}
    data-component-name="IconHingedDoorClosedUnlocked"
  >
    <path d="M412.556 525.438h-13.438v-134.383h13.438v134.383zm382.993 381.649c4.031 12.094 9.407 22.845 14.782 33.596h-256.672c-2.688 0-5.375-1.344-6.719-1.344h-94.068c-2.688 1.344-4.031 1.344-6.719 1.344h-376.273c-2.688 0-5.375-1.344-6.719-1.344h-47.034c-9.407 0-16.126-6.719-16.126-16.126v-907.087c0-9.407 6.719-16.126 16.126-16.126h967.559c9.407 0 16.126 6.719 16.126 16.126v681.323c-10.751-2.688-21.501-5.375-32.252-5.375v-659.822h-451.528v874.835h21.501v-814.362c0-9.407 6.719-16.126 16.126-16.126h376.273c9.407 0 16.126 6.719 16.126 16.126v598.005c-10.751 0-21.501 2.688-32.252 4.031v-585.911h-344.021v798.236h225.764zm-365.523-798.237h-344.021v798.236h344.021v-798.236zm53.754-76.598h-451.528v874.835h21.501v-814.362c0-9.407 6.719-16.126 16.126-16.126h376.273c9.407 0 16.126 6.719 16.126 16.126v814.362h21.501v-874.835zm116.913 493.186v-134.383h-13.438v134.383h13.438zm353.428 172.011c-88.693 0-159.916 71.223-159.916 159.916s71.223 159.916 159.916 159.916 159.916-71.223 159.916-159.916-71.223-159.916-159.916-159.916zm90.036 235.17c0 10.751-9.407 20.157-20.157 20.157h-96.756c-10.751 0-20.157-9.407-20.157-20.157v-64.504c0-10.751 8.063-20.157 18.814-20.157 1.344 1.344 1.344-48.378 1.344-48.378 0-16.126-13.438-29.564-29.564-29.564s-29.564 13.438-29.564 29.564v25.533c0 5.375-4.031 9.407-9.407 9.407s-9.407-4.031-9.407-9.407v-25.533c0-26.877 21.501-48.378 48.378-48.378s48.378 21.501 48.378 48.378v48.378h77.942c10.751 0 20.157 9.407 20.157 20.157v64.504zm-59.128-41.658c0 4.031-2.688 8.063-6.719 9.407v17.47c0 1.344-1.344 2.688-2.688 2.688s-2.688-1.344-2.688-2.688v-17.47c-4.031-1.344-6.719-5.375-6.719-9.407 0-5.375 4.031-9.407 9.407-9.407s9.407 4.031 9.407 9.407z" />
  </IconBase>
);

export const IconHingedDoorClosed = (props: Props) => (
  <IconBase
    viewBox="0 0 1088 1024"
    {...props}
    data-component-name="IconHingedDoorClosed"
  >
    <path d="M449.143 572.076h-14.635v-146.348h14.635zm204.888-146.348h-14.635v146.348h14.635zm358.554 598.418h-409.874c-2.507 0-4.889-.539-7.035-1.507l-102.336.044c-2.038.925-4.42 1.464-6.927 1.464h-410.557c-2.507 0-4.889-.539-7.035-1.507l-51.407.044c-9.618 0-17.415-7.797-17.415-17.415v-987.852c0-9.618 7.797-17.415 17.415-17.415h1053.709c9.618 0 17.415 7.797 17.415 17.415v987.852l.002.293c0 9.537-7.732 17.269-17.269 17.269l-.157-.001h-51.507c-1.949.836-4.217 1.322-6.598 1.322l-.448-.006zm17.415-36.148h23.855v-953.167h-492.17v953.021h23.855v-887.019c0-9.567 7.714-17.332 17.261-17.415h409.783c9.618 0 17.415 7.797 17.415 17.415zm-409.775 0h374.945v-869.749h-374.945zm-117.079 0h23.855v-953.167h-492.17v953.021h23.855v-887.019c0-9.567 7.714-17.332 17.261-17.415h409.783c9.618 0 17.415 7.797 17.415 17.415zm-409.776 0h374.945v-869.749h-374.945z" />
  </IconBase>
);

export const IconHingedDoorOpen = (props: Props) => (
  <IconBase
    viewBox="0 0 936 1024"
    {...props}
    data-component-name="IconHingedDoorOpen"
  >
    <path d="M913.723 975.426h-892.718c-11.815 0-21.005-9.19-21.005-21.005v-887.467c0-11.815 9.19-21.005 21.005-21.005h892.718c11.815 0 21.005 9.19 21.005 21.005v886.154c1.313 11.815-9.19 22.318-21.005 22.318zm-870.4-43.323h849.395v-842.831h-849.395v842.831zm347.898 91.897h-2.626l-317.703-52.513c-7.877-1.313-13.128-7.877-13.128-15.754v-813.949c0-6.564 3.938-13.128 10.503-14.441l317.703-126.031c7.877-2.626 18.379 1.313 21.005 9.19l1.313 5.251v991.179c0 9.19-7.877 17.067-17.067 17.067zm-301.949-82.708l286.195 47.262v-947.856l-284.882 112.903-1.313 787.692zm266.502-376.779h-13.128v-131.282h13.128v131.282zm199.549 458.174c-9.19 0-15.754-6.564-15.754-15.754v-991.179c0-9.19 6.564-15.754 15.754-15.754 2.626 0 3.938 0 5.251 1.313l307.2 126.031c5.251 2.626 9.19 7.877 9.19 14.441v812.636c0 7.877-5.251 14.441-13.128 15.754l-308.513 52.513zm15.754-983.302v949.169l275.692-47.262v-789.005l-275.692-112.903zm31.508 530.379h-13.128v-131.282h13.128v131.282z" />
  </IconBase>
);

export const IconHingedDoorUnknown = (props: Props) => (
  <IconBase
    viewBox="0 0 1121 1024"
    {...props}
    data-component-name="IconHingedDoorUnknown"
  >
    <path d="M412.556 525.438h-13.438v-134.383h13.438v134.383zm382.993 381.649c4.031 12.094 9.407 22.845 14.782 33.596h-256.672c-2.688 0-5.375-1.344-6.719-1.344h-94.068c-2.688 1.344-4.031 1.344-6.719 1.344h-376.273c-2.688 0-5.375-1.344-6.719-1.344h-47.034c-9.407 0-16.126-6.719-16.126-16.126v-907.087c0-9.407 6.719-16.126 16.126-16.126h967.559c9.407 0 16.126 6.719 16.126 16.126v681.323c-10.751-2.688-21.501-5.375-32.252-5.375v-659.822h-451.528v874.835h21.501v-814.362c0-9.407 6.719-16.126 16.126-16.126h376.273c9.407 0 16.126 6.719 16.126 16.126v598.005c-10.751 0-21.501 2.688-32.252 4.031v-585.911h-344.021v798.236h225.764zm-365.523-798.237h-344.021v798.236h344.021v-798.236zm53.754-76.598h-451.528v874.835h21.501v-814.362c0-9.407 6.719-16.126 16.126-16.126h376.273c9.407 0 16.126 6.719 16.126 16.126v814.362h21.501v-874.835zm116.913 493.186v-134.383h-13.438v134.383h13.438zm353.428 172.011c-88.693 0-159.916 71.223-159.916 159.916s71.223 159.916 159.916 159.916 159.916-71.223 159.916-159.916-71.223-159.916-159.916-159.916zm16.126 228.451h-26.877v-107.507h26.877v107.507zm0-134.383h-26.877v-26.877h26.877v26.877z" />
  </IconBase>
);

export const IconHistory = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconHistory">
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M19,13.5H10v-9m.3,8.7A22,22,0,1,1,5,27.5,22.77,22.77,0,0,1,7.4,17.4M27,11.5v16l-8,8m8-10a2,2,0,1,1-2,2A2,2,0,0,1,27,25.5Z"
    />
  </IconBase>
);

export const IconHomeController = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconHomeController"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M42.9,3.6H11.1A1.37,1.37,0,0,0,9.7,5V49a1.37,1.37,0,0,0,1.4,1.4H43A1.37,1.37,0,0,0,44.4,49V5A1.6,1.6,0,0,0,42.9,3.6ZM30.8,39.4a1.37,1.37,0,0,1-1.4,1.4H17.6a1.37,1.37,0,0,1-1.4-1.4V14.3a1.37,1.37,0,0,1,1.4-1.4H29.5a1.37,1.37,0,0,1,1.4,1.4l-.1,25.1Zm8.5-1.3a1.37,1.37,0,0,1-1.4,1.4h-2a1.37,1.37,0,0,1-1.4-1.4v-.8a1.37,1.37,0,0,1,1.4-1.4h2a1.37,1.37,0,0,1,1.4,1.4v.8Zm0-5.3a1.37,1.37,0,0,1-1.4,1.4h-2a1.37,1.37,0,0,1-1.4-1.4V32a1.37,1.37,0,0,1,1.4-1.4h2A1.37,1.37,0,0,1,39.3,32v.8Zm0-5.3a1.37,1.37,0,0,1-1.4,1.4h-2a1.37,1.37,0,0,1-1.4-1.4v-.8a1.37,1.37,0,0,1,1.4-1.4h2a1.37,1.37,0,0,1,1.4,1.4Zm0-5.3a1.37,1.37,0,0,1-1.4,1.4h-2a1.37,1.37,0,0,1-1.4-1.4v-.8A1.37,1.37,0,0,1,35.9,20h2a1.37,1.37,0,0,1,1.4,1.4Zm0-5.4a1.37,1.37,0,0,1-1.4,1.4h-2a1.37,1.37,0,0,1-1.4-1.4V16a1.37,1.37,0,0,1,1.4-1.4h2A1.37,1.37,0,0,1,39.3,16Z"
    />
  </IconBase>
);

export const IconHomeMode = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconHomeMode">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M6,20.17V49a1,1,0,0,0,1,1H47a1,1,0,0,0,1-1V20.17m2.62,2-3-2.33L27.6,4.17A1,1,0,0,0,27,4a1,1,0,0,0-.58.21L6.4,19.84l-3,2.37"
    />
  </IconBase>
);

export const IconHouse = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconHouse">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2px"
      strokeMiterlimit="10"
      d="M43.94,29h2.62V7H7.44V29h2.67M26.94,18.86,33.39,29H43.94V47h-12V38a5,5,0,0,0-10,0v9h-12V29H20.49ZM13.94,35h4v5h-4Zm22,0h4v5h-4Z"
    />
  </IconBase>
);

export const IconInfo = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconInfo">
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2px"
      d="M27,51A24,24,0,1,1,51,27,24,24,0,0,1,27,51Zm2.84-35.85a2.5,2.5,0,0,1-.23,1.08,2.75,2.75,0,0,1-.62.88,3,3,0,0,1-.91.6,2.64,2.64,0,0,1-1.12.23,2.57,2.57,0,0,1-1.09-.23,3,3,0,0,1-.89-.6,2.86,2.86,0,0,1-.6-.88,2.64,2.64,0,0,1-.22-1.08A2.8,2.8,0,0,1,24.38,14a3.08,3.08,0,0,1,.6-.9,3,3,0,0,1,.89-.6A2.72,2.72,0,0,1,27,12.31a2.8,2.8,0,0,1,1.12.22,3,3,0,0,1,.91.6,3,3,0,0,1,.62.9A2.64,2.64,0,0,1,29.84,15.15Zm-.61,7.38V41H24.77V22.53Z"
    />
  </IconBase>
);

export const IconInsynctive = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconInsynctive">
    <path d="M22.89,30.79,21.07,30a7.55,7.55,0,0,1,13.72-.11L33,30.71a5.56,5.56,0,0,0-10.09.08Zm-5.1-1.19L16,28.73a13.38,13.38,0,0,1,12-7.56,13.18,13.18,0,0,1,11.89,7.39l-1.79.88A11.23,11.23,0,0,0,28,23.17,11.36,11.36,0,0,0,17.79,29.6Zm-6.07-1.37-1.74-1A20.63,20.63,0,0,1,45.78,27l-1.72,1a18.64,18.64,0,0,0-32.34.24Zm38.9,22.89H4.88a1,1,0,0,1-1-1V4.38a1,1,0,0,1,1-1H50.62a1,1,0,0,1,1,1V50.12A1,1,0,0,1,50.62,51.12Zm-44.74-2H49.62V5.38H5.88Z" />
  </IconBase>
);

export const IconIrrigationOff = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconIrrigationOff"
  >
    <path d="M34.61,45.21H19.83V37.7h1.92V18.55h1.31v-2H19.22V13.28c0-2,2.09-4.44,8-4.44,5.5,0,8,2.23,8,4.44v3.27H31.38v2h1.31V37.7h1.92Zm-12.78-2H32.61V39.7H30.69V20.55H29.38v-6h3.79V13.28c0-1.18-2.09-2.44-6-2.44s-6,1.23-6,2.44v1.27h3.84v6H23.75V39.7H21.83ZM19.62,38.8m-2.37-3.09-3,8.41a1,1,0,0,0,.49-1.33.93.93,0,0,0-.28-.37,9,9,0,0,1,3.41-7.92,1,1,0,1,0-1.22-1.58C12,36.5,12,42.27,12.78,43.61a1.14,1.14,0,0,0,1,.61A1.11,1.11,0,0,0,14.24,44.12Zm-4-3.59A15.69,15.69,0,0,1,15.35,30a1,1,0,0,0,.15-1.41,1,1,0,0,0-1.4-.15,17.47,17.47,0,0,0-5.36,8.67,10,10,0,0,0-3.12-3.76,1,1,0,1,0-1,1.74c1.28.72,2.92,3.89,3.65,5.72L10,45ZM6,44.18A1,1,0,0,0,6.71,43a13.56,13.56,0,0,0-4.18-6.34,1,1,0,0,0-1.41.14,1,1,0,0,0,.15,1.41,11.51,11.51,0,0,1,3.5,5.28,1,1,0,0,0,1,.76Zm43.25-.06a1,1,0,0,0,.49-1.33.93.93,0,0,0-.28-.37,9,9,0,0,1,3.42-7.92A1,1,0,0,0,53,33.09a1,1,0,0,0-1.4-.17C47,36.5,47,42.27,47.78,43.61a1.14,1.14,0,0,0,1,.61A1.11,1.11,0,0,0,49.24,44.12Zm-4-3.59A15.66,15.66,0,0,1,50.35,30a1,1,0,0,0,.15-1.41,1,1,0,0,0-1.4-.15,17.47,17.47,0,0,0-5.36,8.67,10,10,0,0,0-3.12-3.76,1,1,0,0,0-1,1.74c1.29.72,2.93,3.89,3.66,5.72L45,45ZM41,44.18A1,1,0,0,0,41.71,43a13.56,13.56,0,0,0-4.18-6.34,1,1,0,1,0-1.26,1.55,11.51,11.51,0,0,1,3.5,5.28,1,1,0,0,0,1,.76Z" />
  </IconBase>
);

export const IconIrrigationOn = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconIrrigationOn"
  >
    <path d="M34.61,45.21H19.83V37.7h1.92V18.55h1.31v-2H19.22V13.28c0-2,2.09-4.44,8-4.44,5.5,0,8,2.23,8,4.44v3.27H31.38v2h1.31V37.7h1.92Zm-12.78-2H32.61V39.7H30.69V20.55H29.38v-6h3.79V13.28c0-1.18-2.09-2.44-6-2.44s-6,1.23-6,2.44v1.27h3.84v6H23.75V39.7H21.83ZM39.19,18.43A1.21,1.21,0,1,1,38,17.22,1.23,1.23,0,0,1,39.19,18.43Zm6,0a1.21,1.21,0,1,1-1.21-1.21A1.23,1.23,0,0,1,45.15,18.43ZM42.07,16a1.21,1.21,0,1,1-1.21-1.21A1.19,1.19,0,0,1,42.07,16Zm0,5a1.21,1.21,0,1,1-1.21-1.21A1.22,1.22,0,0,1,42.07,21Zm3.08,2.28A1.21,1.21,0,1,1,43.94,22,1.23,1.23,0,0,1,45.15,23.24Zm0-9.71a1.21,1.21,0,1,1-1.21-1.21,1.26,1.26,0,0,1,1.21,1.21ZM48.74,21a1.21,1.21,0,1,1-1.21-1.21A1.22,1.22,0,0,1,48.74,21Zm-1.21,3.49a1.21,1.21,0,1,1-1.21,1.21A1.22,1.22,0,0,1,47.53,24.45Zm0-9.7A1.21,1.21,0,1,1,46.32,16,1.26,1.26,0,0,1,47.53,14.75Zm0-5A1.22,1.22,0,1,1,46.32,11,1.26,1.26,0,0,1,47.53,9.79ZM16.36,17a1.21,1.21,0,1,1-1.21,1.21A1.23,1.23,0,0,1,16.36,17ZM9.19,18.18a1.21,1.21,0,1,1,1.21,1.21,1.22,1.22,0,0,1-1.21-1.21Zm4.24,1.32a1.21,1.21,0,1,1-1.21,1.21A1.23,1.23,0,0,1,13.43,19.5Zm-1.16-3.84a1.22,1.22,0,1,1,1.21,1.21A1.24,1.24,0,0,1,12.27,15.66ZM9.19,13.38a1.21,1.21,0,1,1,1.21,1.21,1.22,1.22,0,0,1-1.21-1.21Zm0,9.7A1.21,1.21,0,1,1,10.4,24.3a1.26,1.26,0,0,1-1.21-1.22ZM5.6,15.66a1.22,1.22,0,1,1,1.21,1.21A1.24,1.24,0,0,1,5.6,15.66ZM6.76,9.79A1.22,1.22,0,1,1,5.55,11,1.23,1.23,0,0,1,6.76,9.79Zm0,9.71a1.21,1.21,0,1,1-1.21,1.21A1.22,1.22,0,0,1,6.76,19.5ZM5.55,25.66a1.22,1.22,0,0,1,1.21-1.21h0a1.21,1.21,0,1,1-1.21,1.21M19.62,38.8m-2.37-3.09-3,8.41a1,1,0,0,0,.49-1.33.93.93,0,0,0-.28-.37,9,9,0,0,1,3.41-7.92,1,1,0,1,0-1.22-1.58C12,36.5,12,42.27,12.78,43.61a1.14,1.14,0,0,0,1,.61A1.11,1.11,0,0,0,14.24,44.12Zm-4-3.59A15.69,15.69,0,0,1,15.35,30a1,1,0,0,0,.15-1.41,1,1,0,0,0-1.4-.15,17.47,17.47,0,0,0-5.36,8.67,10,10,0,0,0-3.12-3.76,1,1,0,1,0-1,1.74c1.28.72,2.92,3.89,3.65,5.72L10,45ZM6,44.18A1,1,0,0,0,6.71,43a13.56,13.56,0,0,0-4.18-6.34,1,1,0,0,0-1.41.14,1,1,0,0,0,.15,1.41,11.51,11.51,0,0,1,3.5,5.28,1,1,0,0,0,1,.76Zm43.25-.06a1,1,0,0,0,.49-1.33.93.93,0,0,0-.28-.37,9,9,0,0,1,3.42-7.92A1,1,0,0,0,53,33.09a1,1,0,0,0-1.4-.17C47,36.5,47,42.27,47.78,43.61a1.14,1.14,0,0,0,1,.61A1.11,1.11,0,0,0,49.24,44.12Zm-4-3.59A15.66,15.66,0,0,1,50.35,30a1,1,0,0,0,.15-1.41,1,1,0,0,0-1.4-.15,17.47,17.47,0,0,0-5.36,8.67,10,10,0,0,0-3.12-3.76,1,1,0,0,0-1,1.74c1.29.72,2.93,3.89,3.66,5.72L45,45ZM41,44.18A1,1,0,0,0,41.71,43a13.56,13.56,0,0,0-4.18-6.34,1,1,0,1,0-1.26,1.55,11.51,11.51,0,0,1,3.5,5.28,1,1,0,0,0,1,.76Z" />
  </IconBase>
);

export const IconKey = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconKey">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      d="M3.63,49.66,5,51l6.07,0L14,48V45l3.05,0L20,42V40l2.05,0L24,38V36l2.05,0,4.43-3.78m-8.26-7.89L3,43l0,6.07,1,1L19.51,34.51M31,32.11a15.1,15.1,0,1,0-9.1-9.1Zm11.64-6.18-1.2-1.25L28.07,11.37l1.24-1.24A10.3,10.3,0,0,1,43.87,24.69Z"
    />
  </IconBase>
);

export const IconLightSwitchOff = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconLightSwitchOff"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      d="M33.68,32.86l-.77,3.21c-.06.39-.39.49-.77.49,0,0-6.25.06-6.36,0h-.06a.79.79,0,0,1-.39-.66l-.1-.17H23.79a.67.67,0,0,1-.67-.66V20.42a.68.68,0,0,1,.67-.67H30a.66.66,0,0,1,.44.17.6.6,0,0,1,.16.44v7l3,4.81c0,.11.12.17.12.28A.44.44,0,0,1,33.68,32.86ZM35.29,45.8h.06A4.62,4.62,0,0,0,40,41.2V12.8a4.61,4.61,0,0,0-4.6-4.61H18a4.61,4.61,0,0,0-4.6,4.61V41.2A4.6,4.6,0,0,0,18,45.8H35.29Zm-1.52-13a.59.59,0,0,0-.06-.45c-.06-.11-.06-.22-.11-.27l-3-4.81v-7a.6.6,0,0,0-.16-.44A.66.66,0,0,0,30,19.7h-6.2a.67.67,0,0,0-.66.66V35.07a.66.66,0,0,0,.66.66h1.45l.12.17a.58.58,0,0,0,.38.66h.06c.11.06,6.36,0,6.36,0a.75.75,0,0,0,.77-.49ZM27,32.25l-2.78-4.88h6.47m-7.56,4.88,2.61,3.14L27,32.25h6.76"
    />
  </IconBase>
);

export const IconLightSwitchOn = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconLightSwitchOn"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      d="M33.75,21.58c0,.11-.07.17-.12.28l-3,4.81v7a.6.6,0,0,1-.16.44.66.66,0,0,1-.44.17H23.79a.68.68,0,0,1-.67-.67V18.93a.67.67,0,0,1,.67-.66h1.44l.1-.17a.79.79,0,0,1,.39-.66h.06c.11-.06,6.36,0,6.36,0,.38,0,.71.1.77.49l.77,3.21A.44.44,0,0,1,33.75,21.58ZM35.28,8.2H18a4.6,4.6,0,0,0-4.6,4.6V41.2A4.61,4.61,0,0,0,18,45.81H35.35A4.61,4.61,0,0,0,40,41.2V12.8a4.62,4.62,0,0,0-4.6-4.61h-.07ZM33,17.93a.75.75,0,0,0-.77-.49s-6.25-.06-6.36,0h-.06a.58.58,0,0,0-.38.66l-.12.17H23.84a.66.66,0,0,0-.66.66V33.64a.67.67,0,0,0,.66.66H30a.66.66,0,0,0,.44-.17.6.6,0,0,0,.16-.44v-7l3-4.81c0-.05,0-.16.11-.27a.59.59,0,0,0,.06-.45Zm-2.3,8.7H24.21L27,21.75m6.76,0H27l-1.26-3.14-2.61,3.14m24.57-4.67-4,4.06m7.58,6.59H45.62m2.84,9.58L44.4,33.25M10.29,21.14l-4-4.06M8.38,27.73H2.71M9.6,33.25,5.54,37.31"
    />
  </IconBase>
);

export const IconLightbulb0 = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconLightbulb0">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      d="M20,40v4c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2v-4H20z M34,40c0-1,0-4,0-6c0-5.4,7-5.6,7-15c0-7.7-6.3-14-14-14 s-14,6.3-14,14c0,9.6,7,10.7,7,15c0,1.3,0,6,0,6 M30,46c0,1.7-1.3,3-3,3s-3-1.3-3-3 M27,24v13 M23,20l4,4l4-4"
    />
  </IconBase>
);

export const IconLightbulb100 = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconLightbulb100"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      d="M20,40v4c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2v-4H20z M34,40c0-1,0-4,0-6c0-5.4,7-5.6,7-15c0-7.7-6.3-14-14-14 s-14,6.3-14,14c0,9.6,7,10.7,7,15c0,1.3,0,6,0,6 M30,46c0,1.7-1.3,3-3,3s-3-1.3-3-3 M27,24v13 M23,20l4,4l4-4 M6.8,4.2l5.3,5.2 M2.2,18h7.4 M5.9,30.5l5.2-5.3 M47.2,4.6L42,9.9 M51.9,18.5h-7.4 M48.2,31l-5.3-5.3"
    />
  </IconBase>
);

export const IconLightning = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconLightning">
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2px"
      d="M26.81,2a1,1,0,0,0-.75.62l-10,24a1,1,0,0,0,.1.94A1,1,0,0,0,17,28h7.62L17.15,50.42l-.09.25a1,1,0,0,0,1.78.88l19-29a1,1,0,0,0,0-1A1,1,0,0,0,37,21H29.53L37.4,3.39A1,1,0,0,0,36.5,2H26.81Z"
    />
  </IconBase>
);

export const IconListUl = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconListUl">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M13,22H49M5,20H9v4H5Zm8-8H49M5,10H9v4H5Zm8,22H49M5,30H9v4H5Zm8,12H49M5,40H9v4H5Z"
    />
  </IconBase>
);

export const IconLocation = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconLocation">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M27,2.8a14,14,0,0,0-13.9,14c0,6.4,3.3,13.7,6.6,19.5a98.11,98.11,0,0,0,6.6,10.1,1,1,0,0,0,1.3.2l.2-.2a107.6,107.6,0,0,0,6.6-10.2C37.7,30.4,41,23.1,41,16.8A14.11,14.11,0,0,0,27,2.8Zm0,9.9a5,5,0,1,1-5,5A5,5,0,0,1,27,12.7ZM17.2,36.9a41,41,0,0,0-9.9,2.4,9.55,9.55,0,0,0-3,1.8A4.07,4.07,0,0,0,3,43.7,4.25,4.25,0,0,0,5.2,47a18.06,18.06,0,0,0,5.2,2.2,63.81,63.81,0,0,0,16.6,2,59.77,59.77,0,0,0,16.6-2A16.92,16.92,0,0,0,48.8,47,4.25,4.25,0,0,0,51,43.7a3.7,3.7,0,0,0-1.2-2.5,10.86,10.86,0,0,0-3-1.8A36.77,36.77,0,0,0,36.9,37"
    />
  </IconBase>
);

export const IconLockUnknown = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconLockUnknown"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2px"
      d="M10.6,26.39a8.74,8.74,0,1,1,11.93,3.45A8.67,8.67,0,0,1,18.33,31a8.94,8.94,0,0,1-7.73-4.57m7.32-9.31v7.15M18,25.68a.55.55,0,0,0-.51.36.54.54,0,0,0,.36.5H18c.22,0,.36-.21.36-.5A.34.34,0,0,0,18,25.68Zm9-2.43H41.06a1.45,1.45,0,0,1,1.44,1.44V42a1.44,1.44,0,0,1-1.44,1.44H17.94A1.44,1.44,0,0,1,16.5,42V30.73m20.94-7.48V18.92a7.85,7.85,0,0,0-7.94-8c-3.12.11-4.09.74-6.37,3.07m8.54,17.88a2.17,2.17,0,0,0-4.34,0,2.08,2.08,0,0,0,.73,1.59v2a1.44,1.44,0,1,0,2.88,0v-2A2.08,2.08,0,0,0,31.67,31.92Z"
    />
  </IconBase>
);

export const IconLocked = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconLocked">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M11,50.5a2,2,0,0,1-2-2v-24a2,2,0,0,1,2-2H43a2,2,0,0,1,2,2v24a2,2,0,0,1-2,2Zm27-28v-6a11,11,0,0,0-22,0v6m14,12a3,3,0,0,0-6,0,2.87,2.87,0,0,0,1,2.2v2.8a2,2,0,0,0,4,0V36.7A2.87,2.87,0,0,0,30,34.5Z"
    />
  </IconBase>
);

export const IconUnlocked = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconUnlocked">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M10,52a2,2,0,0,1-2-2V26a2,2,0,0,1,2-2H42a2,2,0,0,1,2,2V50a2,2,0,0,1-2,2ZM35.6,16.1s-1.1-3.6-1.3-4.3a11,11,0,0,0-21.1,6.5C13.6,19.4,15,24,15,24M29,36a3,3,0,0,0-6,0,2.87,2.87,0,0,0,1,2.2V41a2,2,0,0,0,4,0V38.2A2.87,2.87,0,0,0,29,36Z"
    />
  </IconBase>
);

export const IconMicrophone = (props: Props) => (
  <IconBase
    viewBox="0 0 658 1024"
    {...props}
    data-component-name="IconMicrophone"
  >
    <path d="M658.286 402.286v73.142q0 126.286-84.286 219.714t-208.286 107.142v75.428h146.286q14.858 0 25.714 10.858t10.858 25.714-10.858 25.714-25.714 10.858h-365.714q-14.858 0-25.714-10.858t-10.858-25.714 10.858-25.714 25.714-10.858h146.286v-75.428q-124-13.714-208.286-107.142t-84.286-219.714v-73.142q0-14.858 10.858-25.714t25.714-10.858 25.714 10.858 10.858 25.714v73.142q0 105.714 75.142 180.858t180.858 75.142 180.858-75.142 75.142-180.858v-73.142q0-14.858 10.858-25.714t25.714-10.858 25.714 10.858 10.858 25.714zm-146.286-219.428v292.572q0 75.428-53.714 129.142t-129.142 53.714-129.142-53.714-53.714-129.142v-292.572q0-75.428 53.714-129.142t129.142-53.714 129.142 53.714 53.714 129.142z" />
  </IconBase>
);

export const IconMinusSign = (props: Props) => (
  <IconBase
    viewBox="0 0 876 1024"
    {...props}
    data-component-name="IconMinusSign"
  >
    <path d="M694 548.572v-73.142q0-14.858-10.858-25.714t-25.714-10.858h-438.858q-14.858 0-25.714 10.858t-10.858 25.714v73.142q0 14.858 10.858 25.714t25.714 10.858h438.858q14.858 0 25.714-10.858t10.858-25.714zm182.856-36.572q0 119.428-58.858 220.286t-159.714 159.714-220.286 58.858-220.286-58.858-159.714-159.714-58.858-220.286 58.858-220.286 159.714-159.714 220.286-58.858 220.286 58.858 159.714 159.714 58.858 220.286z" />
  </IconBase>
);

export const IconMinus = (props: Props) => (
  <IconBase viewBox="0 0 1024 1024" {...props} data-component-name="IconMinus">
    <path d="M778.188 460.8h-532.428c-28.314 0-30.72 22.938-30.72 51.2s2.406 51.2 30.72 51.2h532.428c28.314 0 30.772-22.938 30.772-51.2s-2.458-51.2-30.772-51.2z" />
  </IconBase>
);

export const IconMoon = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconMoon">
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2px"
      d="M42.88,34a16.76,16.76,0,0,1-15.17,9.7,16.33,16.33,0,0,1-6.48-1.32,17.13,17.13,0,0,1-5.34-3.57,16.88,16.88,0,0,1-3.56-5.33A16.21,16.21,0,0,1,11,27a16.48,16.48,0,0,1,1.25-6.37,16.21,16.21,0,0,1,8.52-8.83,16.44,16.44,0,0,1,6.31-1.49,1.26,1.26,0,0,1,1.33.85,1.27,1.27,0,0,1-.33,1.56,11.82,11.82,0,0,0-2.26,14.65,11.8,11.8,0,0,0,4.31,4.31,11.78,11.78,0,0,0,10.9.48,1.3,1.3,0,0,1,1.57.28,1.35,1.35,0,0,1,.38.74,1.38,1.38,0,0,1-.1.83Z"
    />
  </IconBase>
);

export const IconMouseTrapArmed = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconMouseTrapArmed"
  >
    <g>
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="27"
        y1="11.7"
        x2="27"
        y2="9"
      />
      <g>
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeMiterlimit="10"
          d="M12.6,28.2V10c0-0.9,0.7-1.6,1.7-1.6h16.9"
        />
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeMiterlimit="10"
          d="M31.1,8.4h8.6c0.9,0,1.6,0.7,1.6,1.6v18.2"
        />
      </g>
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        d="M10.6,48.6h32.7c0.9,0,1.7-0.7,1.7-1.6V7c0-0.9-0.7-1.6-1.6-1.6H10.6C9.7,5.4,9,6.1,9,7v40 C9,47.9,9.7,48.6,10.6,48.6z"
      />
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="15.3"
        y1="27.9"
        x2="17.1"
        y2="23.4"
      />
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="18.9"
        y1="27.9"
        x2="20.7"
        y2="23.4"
      />
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="22.5"
        y1="27.9"
        x2="24.3"
        y2="23.4"
      />
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="26.1"
        y1="27.9"
        x2="27.9"
        y2="23.4"
      />
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="29.7"
        y1="27.9"
        x2="31.5"
        y2="23.4"
      />
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="33.3"
        y1="27.9"
        x2="35.1"
        y2="23.4"
      />
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="36.9"
        y1="27.9"
        x2="38.7"
        y2="23.4"
      />
    </g>
  </IconBase>
);

export const IconMouseTrapDisarmed = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconMouseTrapDisarmed"
  >
    <g>
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="27"
        y1="11.7"
        x2="27"
        y2="9"
      />
      <g>
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeMiterlimit="10"
          d="M12.6,28.2V10c0-0.9,0.7-1.6,1.7-1.6h16.9"
        />
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeMiterlimit="10"
          d="M31.1,8.4h8.6c0.9,0,1.6,0.7,1.6,1.6v18.2"
        />
      </g>
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        d="M10.6,48.6h32.7c0.9,0,1.7-0.7,1.7-1.6V7c0-0.9-0.7-1.6-1.6-1.6H10.6C9.7,5.4,9,6.1,9,7V47 C9,47.9,9.7,48.6,10.6,48.6z"
      />
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="15.3"
        y1="27.9"
        x2="17.1"
        y2="23.4"
      />
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="18.9"
        y1="27.9"
        x2="20.7"
        y2="23.4"
      />
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="22.5"
        y1="27.9"
        x2="24.3"
        y2="23.4"
      />
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="26.1"
        y1="27.9"
        x2="27.9"
        y2="23.4"
      />
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="29.7"
        y1="27.9"
        x2="31.5"
        y2="23.4"
      />
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="33.3"
        y1="27.9"
        x2="35.1"
        y2="23.4"
      />
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="36.9"
        y1="27.9"
        x2="38.7"
        y2="23.4"
      />
    </g>
    <line
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      x1="3.5"
      y1="2.5"
      x2="51.2"
      y2="50.2"
    />
  </IconBase>
);

export const IconMouseTrapTripped = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconMouseTrapTripped"
  >
    <g>
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="27"
        y1="11.7"
        x2="27"
        y2="9"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        d="M22.9,43.2h-8.6c-0.9,0-1.7-0.7-1.7-1.6V23.4"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        d="M41.4,23.4v18.2c0,0.9-0.7,1.6-1.6,1.6h-8.6"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        d="M10.6,48.6h32.7c0.9,0,1.7-0.7,1.7-1.6V7c0-0.9-0.7-1.6-1.6-1.6H10.6C9.7,5.4,9,6.1,9,7v40 C9,47.9,9.7,48.6,10.6,48.6z"
      />
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="15.3"
        y1="27.9"
        x2="17.1"
        y2="23.4"
      />
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="18.9"
        y1="27.9"
        x2="20.7"
        y2="23.4"
      />
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="22.5"
        y1="27.9"
        x2="24.3"
        y2="23.4"
      />
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="26.1"
        y1="27.9"
        x2="27.9"
        y2="23.4"
      />
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="29.7"
        y1="27.9"
        x2="31.5"
        y2="23.4"
      />
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="33.3"
        y1="27.9"
        x2="35.1"
        y2="23.4"
      />
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="36.9"
        y1="27.9"
        x2="38.7"
        y2="23.4"
      />
      <path d="M32,33.3c-1.7,0-3.2,1.4-3.2,3.2c0,0.3,0.1,0.6,0.2,0.9c-0.6-0.3-1.2-0.5-2-0.5s-1.4,0.2-2,0.5 c0.1-0.3,0.2-0.6,0.2-0.9c0-1.7-1.4-3.2-3.2-3.2s-3.1,1.4-3.1,3.2c0,1.7,1.4,3.1,3.1,3.1c0.3,0,0.6-0.1,0.9-0.2 c-0.3,0.6-0.5,1.2-0.5,2c0,2.5,2,4.5,4.5,4.5s4.5-2,4.5-4.5c0-0.7-0.2-1.4-0.5-2c0.3,0.1,0.6,0.2,0.9,0.2c1.7,0,3.1-1.4,3.1-3.1 C35.1,34.7,33.7,33.3,32,33.3z" />
      <circle cx="27" cy="43.2" r="0.9" />
    </g>
  </IconBase>
);

export const IconMovie = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconMovie">
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M52.39,51.35c-.63-3.2-.19-7.45-.07-12.29.16-7.28-.66-16-7.66-24.52A44.09,44.09,0,0,0,38,8a21.31,21.31,0,0,0-2.12-1.67h-.07a22,22,0,1,0,9.74,18.21M23.71,22.72a1.77,1.77,0,1,0,1.77,1.77A1.77,1.77,0,0,0,23.71,22.72ZM23.65,10.8a5.72,5.72,0,0,0-3.14.68,3.14,3.14,0,0,0-1.25,2.72,4.49,4.49,0,0,0,1.79,3.24,7.46,7.46,0,0,0,1.33.91,2.16,2.16,0,0,0,2.56,0,7.46,7.46,0,0,0,1.33-.91,4.49,4.49,0,0,0,1.79-3.24,3.14,3.14,0,0,0-1.25-2.69A5.62,5.62,0,0,0,23.65,10.8Zm-9.57,6.26a2.44,2.44,0,0,0-1.35.54,5.68,5.68,0,0,0-1.65,2.81,5.54,5.54,0,0,0-.28,3.22,3.12,3.12,0,0,0,2.17,2,4.44,4.44,0,0,0,3.62-.74,7.62,7.62,0,0,0,1.28-1,2.3,2.3,0,0,0,.79-2.45,7.37,7.37,0,0,0-.49-1.55,4.36,4.36,0,0,0-2.5-2.71A3.9,3.9,0,0,0,14,17.06Zm18.37,0a2.94,2.94,0,0,0-.78.17h0a4.39,4.39,0,0,0-2.5,2.68,7.78,7.78,0,0,0-.5,1.55,2.46,2.46,0,0,0,0,1.37,2.36,2.36,0,0,0,.77,1.05,7.64,7.64,0,0,0,1.29,1,4.4,4.4,0,0,0,3.62.73,3.11,3.11,0,0,0,2.17-2,5.5,5.5,0,0,0-.29-3.13,5.61,5.61,0,0,0-1.6-2.8,2.63,2.63,0,0,0-1.39-.54,3.93,3.93,0,0,0-.84,0ZM29,28.23a5.08,5.08,0,0,0-.78,0,2.48,2.48,0,0,0-1.29.4,2.59,2.59,0,0,0-.81,1.09,8,8,0,0,0-.54,1.51A4.47,4.47,0,0,0,26,35a3.14,3.14,0,0,0,2.61,1.47,5.44,5.44,0,0,0,3-1.29,5.47,5.47,0,0,0,2.21-2.38,3.13,3.13,0,0,0-.58-2.91h0a4.42,4.42,0,0,0-3.38-1.61,7.42,7.42,0,0,0-.82,0Zm-10.76.14a8.52,8.52,0,0,0-.87.08,4.38,4.38,0,0,0-3.26,1.73,3.18,3.18,0,0,0-.45,3A5.65,5.65,0,0,0,16,35.44a5.55,5.55,0,0,0,3,1.16A3.18,3.18,0,0,0,21.49,35a4.34,4.34,0,0,0,.26-3.67,7.75,7.75,0,0,0-.61-1.53,2.45,2.45,0,0,0-.86-1A2.33,2.33,0,0,0,19,28.45a4.13,4.13,0,0,0-.78-.08ZM45.55,25a21.1,21.1,0,0,0-7.3-16.89"
    />
  </IconBase>
);

export const IconMusic = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconMusic">
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2px"
      d="M47,5V40s-.12,6-7,6c-7.51,0-8-4.87-8-6,0-2.41.94-5,8-5,3.25,0,4-.84,4-3V15.21c0-1.32-.08-1.79-1.54-1.46-2.52.57-19,4.13-19.62,4.29s-.84.55-.84,1.7V45c0,2.26-1.74,6-8,6s-7-4-7-6c0-3,2.25-4.89,7-4.89,4.43,0,5-1.25,5-3.11V10a1.63,1.63,0,0,1,1.37-1.82C22,7.81,45.14,3,45.14,3S47,2.61,47,5Z"
    />
  </IconBase>
);

export const IconNestAwayIcon = (props: Props) => (
  <IconBase
    viewBox="0 0 1067 1024"
    {...props}
    data-component-name="IconNestAwayIcon"
  >
    <path d="M535.467 230.4l-448 354.133v418.133c0 12.8 8.533 21.333 21.333 21.333h853.333c12.8 0 21.333-8.533 21.333-21.333v-416l-448-356.267zm238.933 221.867c29.867 0 53.333 23.467 53.333 53.333s-23.467 53.333-53.333 53.333c-29.867 0-53.333-23.467-53.333-53.333s25.6-53.333 53.333-53.333zm-78.933 443.733c-2.133 6.4-6.4 12.8-12.8 21.333-10.667 12.8-44.8 59.733-53.333 70.4s-23.467 27.733-40.533 14.933c-14.933-12.8-8.533-27.733 0-42.667 12.8-17.067 57.6-81.067 57.6-81.067l21.333-74.667 40.533 57.6c-4.267 10.667-10.667 27.733-12.8 34.133zm215.466-134.4c-6.4 10.667-21.333 8.533-34.133 4.267-14.933-6.4-61.867-27.733-70.4-32s-10.667-6.4-14.933-10.667c-6.4-10.667-19.2-27.733-19.2-27.733l-17.067 76.8s104.533 170.667 113.067 185.6 10.667 36.267-4.267 44.8c-19.2 10.667-32 2.133-44.8-17.067-12.8-17.067-117.333-181.333-125.867-194.133s-19.2-29.867-14.933-53.333c2.133-12.8 10.667-51.2 17.067-87.467l-46.933 36.267s-14.933 83.2-17.067 91.733c-2.133 10.667-14.933 14.933-21.333 12.8-10.667-2.133-19.2-8.533-17.067-25.6l14.933-102.4c2.133-8.533 6.4-12.8 12.8-17.067l70.4-59.733c8.533-4.267 12.8-10.667 27.733-10.667h25.6c17.067 0 25.6 6.4 36.267 34.133 12.8 27.733 36.267 81.067 36.267 81.067s68.267 34.133 78.933 38.4c12.8 8.533 21.333 21.333 14.933 32zm147.2-352l-512-405.333c-6.4-6.4-17.067-6.4-25.6 0l-512 405.333c-6.4 4.267-8.533 10.667-8.533 17.067v128c0 8.533 6.4 14.933 12.8 19.2 8.533 4.267 17.067 2.133 23.467-2.133l499.2-394.667 499.2 394.667c4.267 2.133 8.533 4.267 12.8 4.267 2.133 0 6.4 0 6.4-2.133 8.533-4.267 12.8-10.667 12.8-19.2v-128c0-6.4-4.267-12.8-8.533-17.067z" />
  </IconBase>
);

export const IconNestHomeIcon = (props: Props) => (
  <IconBase
    viewBox="0 0 1067 1024"
    {...props}
    data-component-name="IconNestHomeIcon"
  >
    <path d="M1047.467 576c-4.267 0-8.533-2.133-12.8-4.267l-499.2-394.667-499.2 394.667c-6.4 4.267-14.933 6.4-23.467 2.133-6.4-4.267-12.8-10.667-12.8-19.2v-128c0-6.4 2.133-12.8 8.533-17.067l512-405.333c8.533-6.4 19.2-6.4 25.6 0l512 405.333c4.267 4.267 8.533 10.667 8.533 17.067v128c0 8.533-4.267 14.933-12.8 19.2 0 2.133-4.267 2.133-6.4 2.133zm-512-345.6l-448 354.133v418.133c0 12.8 8.533 21.333 21.333 21.333h256c12.8 0 21.333-8.533 21.333-21.333v-249.6c0-81.067 61.867-149.333 140.8-155.733 87.467-6.4 157.867 64 157.867 149.333v256c0 12.8 8.533 21.333 21.333 21.333h256c12.8 0 21.333-8.533 21.333-21.333v-416l-448-356.267z" />
  </IconBase>
);

export const IconNestUnknownIcon = (props: Props) => (
  <IconBase
    viewBox="0 0 1067 1024"
    {...props}
    data-component-name="IconNestUnknownIcon"
  >
    <path d="M535.467 230.4l-448 354.133v418.133c0 12.8 8.533 21.333 21.333 21.333h853.333c12.8 0 21.333-8.533 21.333-21.333v-416l-448-356.267zm44.8 759.467c-2.133 6.4-6.4 12.8-12.8 12.8h-51.2c-6.4 0-12.8-6.4-12.8-12.8v-51.2c0-6.4 6.4-12.8 12.8-12.8h51.2c6.4 0 12.8 6.4 12.8 12.8v51.2zm42.666-285.867c-27.733 14.933-44.8 42.667-44.8 72.533v74.667c0 14.933-10.667 25.6-25.6 25.6h-25.6c-14.933 0-25.6-10.667-25.6-25.6v-74.667c0-59.733 34.133-113.067 87.467-140.8 36.267-21.333 57.6-59.733 53.333-102.4-6.4-46.933-42.667-85.333-89.6-89.6-2.133-2.133-6.4-2.133-10.667-2.133-25.6 0-49.067 8.533-68.267 25.6-21.333 21.333-34.133 46.933-34.133 76.8 0 14.933-10.667 25.6-25.6 25.6h-25.6c-14.933 0-25.6-10.667-25.6-25.6 0-51.2 21.333-98.133 59.733-132.267 32-27.733 74.667-44.8 119.467-44.8 6.4 0 12.8 0 19.2 2.133 81.067 8.533 147.2 74.667 155.733 157.867 8.533 72.533-29.867 142.933-93.867 177.067zm443.734-277.333v128c0 8.533-4.267 14.933-12.8 19.2 0 2.133-4.267 2.133-6.4 2.133-4.267 0-8.533-2.133-12.8-4.267l-499.2-394.667-499.2 394.667c-6.4 4.267-14.933 6.4-23.467 2.133-6.4-4.267-12.8-10.667-12.8-19.2v-128c0-6.4 2.133-12.8 8.533-17.067l512-405.333c8.533-6.4 19.2-6.4 25.6 0l512 405.333c4.267 4.267 8.533 10.667 8.533 17.067z" />
  </IconBase>
);

export const IconNewspaper = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconNewspaper">
    <path
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M49,37.5l-12,12H7a2,2,0,0,1-2-2V6.5l3,3,3-3,4,3,4-3,4,3,4-3,4,3,4-3,4,3,4.1-3,3,3,2.9-3Zm-38-22H43v4H11Zm18,10H44m-15,4H44m-15,4H44m-34,8H25m4-4h6m-6,4h6m-24-16H24v12H11Zm26,24v-12H49"
    />
  </IconBase>
);

export const IconNexiaLogo = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconNexiaLogo">
    <path
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2px"
      d="M26,22.06h9.36l-1.21,2.45.58.39,7,0L33.05,7.49l-4,9.82m.8,4.74-1.35-8-7.82,4.45L26,22.06m8.73,2.85-.58-.39-.19.39-2.11,4.28L31,30.8l.4,5.94,11.23-6.47ZM26,22.06H11.34l12,24.46L31,30.8"
    />
  </IconBase>
);

export const IconPencil = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconPencil">
    <path
      strokeWidth="2px"
      d="M6,49a1,1,0,0,1-.71-.3,1,1,0,0,1-.23-1.05l3.3-8.8a1,1,0,0,1,.23-.36L40,7.19a1,1,0,0,1,1.42,0l5.5,5.5a1,1,0,0,1,0,1.42l-31.4,31.4a1.1,1.1,0,0,1-.37.23l-8.8,3.2A1,1,0,0,1,6,49Zm4.16-9.25L7.7,46.32l6.55-2.38L44.79,13.4,40.7,9.31ZM46.31,13.51l-1.42-1.42,1.5-1.5a2.12,2.12,0,0,0,0-3,2.17,2.17,0,0,0-3,0l-1.5,1.5L40.49,7.69,42,6.19A4.12,4.12,0,0,1,47.81,12ZM42,18.4a1,1,0,0,1-.7-.29l-5.4-5.3a1,1,0,0,1,1.4-1.42l5.4,5.3a1,1,0,0,1,0,1.41A1,1,0,0,1,42,18.4ZM14.6,45.6a1,1,0,0,1-.71-.29l-1.6-1.6A1,1,0,0,1,12,43V42H11a1,1,0,0,1-.68-.27l-1.6-1.5a1,1,0,0,1,1.36-1.46L11.4,40H13a1,1,0,0,1,1,1v1.59l1.31,1.3a1,1,0,0,1,0,1.42A1,1,0,0,1,14.6,45.6ZM7.3,44,10,46.8l-3.5.7Z"
    />
  </IconBase>
);

export const IconPhone = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconPhone">
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M14.81,4A1,1,0,0,0,14,5V44a5.84,5.84,0,0,0,2.09,4.41A6.18,6.18,0,0,0,20,50H35a5,5,0,0,0,5-5V14a5,5,0,0,0-5-5H19V5a1,1,0,0,0-1-1H14.81ZM21,14a3,3,0,0,0-3,3v8a3,3,0,0,0,3,3H33a3,3,0,0,0,3-3V17a3,3,0,0,0-3-3Zm0,17a2,2,0,1,0,2,2A2,2,0,0,0,21,31Zm6,0a2,2,0,1,0,2,2A2,2,0,0,0,27,31Zm6,0a2,2,0,1,0,2,2A2,2,0,0,0,33,31ZM21,37a2,2,0,1,0,2,2A2,2,0,0,0,21,37Zm6,0a2,2,0,1,0,2,2A2,2,0,0,0,27,37Zm6,0a2,2,0,1,0,2,2A2,2,0,0,0,33,37ZM21,43a2,2,0,1,0,2,2A2,2,0,0,0,21,43Zm6,0a2,2,0,1,0,2,2A2,2,0,0,0,27,43Zm6,0a2,2,0,1,0,2,2A2,2,0,0,0,33,43Z"
    />
  </IconBase>
);

export const IconPlane = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconPlane">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M48.51,2.1a8.13,8.13,0,0,0-1,.15,16.89,16.89,0,0,0-4,1.57A26.13,26.13,0,0,0,37.42,8h0l-6.75,6.71-24-3.25a1,1,0,0,0-.85.32l-3.4,3.5a1,1,0,0,0,.34,1.62l18.5,7.25L11.7,33.91H7.1a1,1,0,0,0-.65.25l-4,3.38a1,1,0,0,0-.35,1,1,1,0,0,0,.75.75l9.54,2.34,2.34,9.53a1,1,0,0,0,.67.7,1,1,0,0,0,1-.2l3.41-3a1,1,0,0,0,.34-.75V42.32l9.82-9.53,7.15,18.5a1,1,0,0,0,.73.6,1,1,0,0,0,.9-.26l3.5-3.41a1,1,0,0,0,.31-.84l-3.25-24L46,16.63a29.26,29.26,0,0,0,4.19-6.19,16.33,16.33,0,0,0,1.56-4,3.83,3.83,0,0,0-.62-3.56l0,0a2.85,2.85,0,0,0-1.65-.75A4.21,4.21,0,0,0,48.51,2.1Z"
    />
  </IconBase>
);

export const IconPlusSign = (props: Props) => (
  <IconBase
    viewBox="0 0 876 1024"
    {...props}
    data-component-name="IconPlusSign"
  >
    <path d="M694 548.572v-73.142q0-14.858-10.858-25.714t-25.714-10.858h-146.286v-146.286q0-14.858-10.858-25.714t-25.714-10.858h-73.142q-14.858 0-25.714 10.858t-10.858 25.714v146.286h-146.286q-14.858 0-25.714 10.858t-10.858 25.714v73.142q0 14.858 10.858 25.714t25.714 10.858h146.286v146.286q0 14.858 10.858 25.714t25.714 10.858h73.142q14.858 0 25.714-10.858t10.858-25.714v-146.286h146.286q14.858 0 25.714-10.858t10.858-25.714zm182.856-36.572q0 119.428-58.858 220.286t-159.714 159.714-220.286 58.858-220.286-58.858-159.714-159.714-58.858-220.286 58.858-220.286 159.714-159.714 220.286-58.858 220.286 58.858 159.714 159.714 58.858 220.286z" />
  </IconBase>
);

export const IconPlus = (props: Props) => (
  <IconBase viewBox="0 0 1024 1024" {...props} data-component-name="IconPlus">
    <path d="M778.188 460.8h-215.04v-215.04c0-28.262-22.886-30.72-51.2-30.72-28.262 0-51.2 2.406-51.2 30.72v215.04h-214.988c-28.314 0-30.72 22.938-30.72 51.2s2.406 51.2 30.72 51.2h214.988v215.04c0 28.262 22.938 30.72 51.2 30.72 28.314 0 51.2-2.458 51.2-30.72v-215.04h215.04c28.314 0 30.772-22.938 30.772-51.2s-2.458-51.2-30.772-51.2z" />
  </IconBase>
);

export const IconQuestion = (props: Props) => (
  <IconBase
    viewBox="0 0 1024 1024"
    {...props}
    data-component-name="IconQuestion"
  >
    <path d="M721.408 114.38c-58.42-42.136-131.686-63.18-219.956-63.18-67.174 0-123.8 14.848-169.83 44.442-73.062 46.386-111.872 125.132-116.582 236.236h169.268c0-32.358 9.42-63.54 28.314-93.542s50.944-45.004 96.154-45.004c45.926 0 77.62 12.186 94.924 36.506 17.356 24.422 26.01 51.404 26.01 80.998 0 25.754-12.902 49.306-28.468 70.758-8.55 12.492-19.866 23.962-33.844 34.508 0 0-91.802 58.88-132.148 106.188-23.398 27.444-25.498 68.506-27.546 127.436-.154 4.198 1.434 12.852 16.128 12.852h131.686s15.77-9.676 15.974-13.926c.922-21.452 3.328-32.41 7.27-44.8 7.424-23.398 27.494-43.828 50.124-61.388l46.592-32.154c42.036-32.768 75.622-59.648 90.42-80.742 25.296-34.714 43.062-77.414 43.062-128.052 0-82.688-29.236-145.048-87.552-187.136zm-222.668 649.728c-58.368-1.74-106.496 38.604-108.34 101.888-1.844 63.232 43.93 105.012 102.298 106.752 60.928 1.792 107.776-37.274 109.62-100.506 1.79-63.282-42.65-106.342-103.578-108.134z" />
  </IconBase>
);

export const IconQuestionCommercial = (props: Props) => (
  <IconBase
    viewBox="0 0 64 64"
    {...props}
    data-component-name="IconQuestionCommercial"
  >
    <g id="IconQuestionCommercial">
      <path d="M32,63.5a31.5,31.5,0,0,1,0-63,31.5,31.5,0,0,1,0,63ZM32,3.31a28.69,28.69,0,0,0,0,57.38A28.69,28.69,0,0,0,32,3.31Z" />
    </g>
    <path d="M43.62,16.93a9.5,9.5,0,0,0-2.77-3.61A14.58,14.58,0,0,0,37,11.24a14.44,14.44,0,0,0-4.61-.8,14.74,14.74,0,0,0-5.55,1,12.74,12.74,0,0,0-4.22,2.79A11.8,11.8,0,0,0,20,18.67a12.23,12.23,0,0,0-.66,5.52l.12,1.63h6.8l-.22-1.95a7,7,0,0,1,.33-2.55l.05-.23a5.93,5.93,0,0,1,1.19-2.27,4.52,4.52,0,0,1,1.94-1.46,7.63,7.63,0,0,1,3-.58,7.29,7.29,0,0,1,2.24.47,3,3,0,0,1,1.55.84A11.9,11.9,0,0,1,37.69,20a4.67,4.67,0,0,1,.37,2.05,5.17,5.17,0,0,1-.75,2.8l0,.09a7.82,7.82,0,0,1-2,2.42c-1.17,1-2,1.91-2.89,2.78l-.11.12a15.92,15.92,0,0,0-2,2.89l-.2.45a10.92,10.92,0,0,0-.91,2.91,12.57,12.57,0,0,0-.32,3.62v1.76h6.72V40.17a14.87,14.87,0,0,1,.12-2.68l0-.17V37.2a3,3,0,0,1,.38-1.34,3.63,3.63,0,0,1,1-1.3l2.6-2.62a22.68,22.68,0,0,0,3.47-4.3,10.91,10.91,0,0,0,1.5-5.84A11,11,0,0,0,43.62,16.93Zm-2,9.82a20.53,20.53,0,0,1-3.21,3.95c-1.11,1.14-2,2-2.51,2.55a5.33,5.33,0,0,0-1.4,1.83A4.76,4.76,0,0,0,34,37.2a17.83,17.83,0,0,0-.13,3H30.6a10.75,10.75,0,0,1,.28-3.25,10.58,10.58,0,0,1,1-3,14.69,14.69,0,0,1,1.82-2.54c.83-.85,1.67-1.69,2.79-2.68a9.66,9.66,0,0,0,2.37-3,6.88,6.88,0,0,0,1-3.67,6.4,6.4,0,0,0-.56-2.83A12.85,12.85,0,0,0,37.72,17a4.4,4.4,0,0,0-2.37-1.41A8.71,8.71,0,0,0,32.56,15a9.13,9.13,0,0,0-3.63.71,6.17,6.17,0,0,0-2.65,2,7.42,7.42,0,0,0-1.54,3,9,9,0,0,0-.42,3.39H21.11a10.58,10.58,0,0,1,.56-4.8,10.21,10.21,0,0,1,2.23-3.82A11.21,11.21,0,0,1,27.53,13a13.26,13.26,0,0,1,4.89-.84,12.94,12.94,0,0,1,4,.7,13,13,0,0,1,3.35,1.84,7.85,7.85,0,0,1,2.23,3,9.27,9.27,0,0,1,.84,4.09A9.27,9.27,0,0,1,41.63,26.75Z" />
    <path d="M32,44.74a4.41,4.41,0,1,0,4.4,4.41A4.42,4.42,0,0,0,32,44.74Zm0,7.07a2.66,2.66,0,1,1,2.66-2.66A2.66,2.66,0,0,1,32,51.81Z" />
  </IconBase>
);

export const IconRefresh = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconRefresh">
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M42.38,10,38,15l9,1L45,7,42.42,10A23,23,0,1,0,50,27"
    />
  </IconBase>
);

export const IconPivotRefresh = (props: Props) => (
  <IconBase
    viewBox="0 0 64 64"
    {...props}
    data-component-name="IconPivotRefresh"
  >
    <path d="M.5,32A31.46,31.46,0,0,1,53.6,9.12V5.24a2.69,2.69,0,0,1,.64-1.83A2.17,2.17,0,0,1,56,2.64a2.49,2.49,0,0,1,1.83.74,2.51,2.51,0,0,1,.78,1.81L58.5,16.41A2.53,2.53,0,0,1,56,18.94L44.76,19a2.51,2.51,0,0,1-1.82-.78,2.42,2.42,0,0,1-.75-1.82A2.17,2.17,0,0,1,43,14.68,2.84,2.84,0,0,1,44.8,14h3.35a24.16,24.16,0,1,0,8,18,3.66,3.66,0,1,1,7.32,0,31.5,31.5,0,0,1-63,0Z" />
  </IconBase>
);

export const IconRemote = (props: Props) => (
  <IconBase viewBox="0 0 19 44" {...props} data-component-name="IconRemote">
    <path d="M16.5,44h-14C1.1,44,0,42.9,0,41.5v-30C0,10.1,1.1,9,2.5,9h14c1.4,0,2.5,1.1,2.5,2.5v30C19,42.9,17.9,44,16.5,44z M2.5,10 C1.7,10,1,10.7,1,11.5v30C1,42.3,1.7,43,2.5,43h14c0.8,0,1.5-0.7,1.5-1.5v-30c0-0.8-0.7-1.5-1.5-1.5H2.5z M15.1,41.2h-11v-6.6 l5.5-3.3l5.5,3.3V41.2z M5.1,40.2h9v-5l-4.5-2.7l-4.5,2.7V40.2z M9.6,29.7l-5.5-5.3l0.7-0.7l4.7,4.7l4.6-4.6l0.7,0.7L9.6,29.7z M4.9,19l-0.7-0.7l5.5-5.3l5.3,5.4L14.2,19l-4.6-4.6L4.9,19z M13.6,6.7C12.6,5.6,11,5,9.5,5C7.9,5,6.6,5.6,5.6,6.6L4.8,6 C6,4.7,7.6,4,9.5,4c1.8,0,3.6,0.7,4.9,1.9L13.6,6.7z M2.6,4L1.8,3.4C3.9,1.2,6.6,0,9.5,0c2.9,0,5.6,1.2,7.6,3.4L16.3,4 c-1.8-2-4.2-3-6.8-3C6.9,1,4.4,2.1,2.6,4z" />
  </IconBase>
);

export const IconRemoveSign = (props: Props) => (
  <IconBase
    viewBox="0 0 876 1024"
    {...props}
    data-component-name="IconRemoveSign"
  >
    <path d="M655.714 641.142q0-14.858-10.858-25.714l-103.428-103.428 103.428-103.428q10.858-10.858 10.858-25.714 0-15.428-10.858-26.286l-51.428-51.428q-10.858-10.858-26.286-10.858-14.858 0-25.714 10.858l-103.428 103.428-103.428-103.428q-10.858-10.858-25.714-10.858-15.428 0-26.286 10.858l-51.428 51.428q-10.858 10.858-10.858 26.286 0 14.858 10.858 25.714l103.428 103.428-103.428 103.428q-10.858 10.858-10.858 25.714 0 15.428 10.858 26.286l51.428 51.428q10.858 10.858 26.286 10.858 14.858 0 25.714-10.858l103.428-103.428 103.428 103.428q10.858 10.858 25.714 10.858 15.428 0 26.286-10.858l51.428-51.428q10.858-10.858 10.858-26.286zm221.142-129.142q0 119.428-58.858 220.286t-159.714 159.714-220.286 58.858-220.286-58.858-159.714-159.714-58.858-220.286 58.858-220.286 159.714-159.714 220.286-58.858 220.286 58.858 159.714 159.714 58.858 220.286z" />
  </IconBase>
);

export const IconRemove = (props: Props) => (
  <IconBase viewBox="0 0 804 1024" {...props} data-component-name="IconRemove">
    <path d="M741.428 755.428q0 22.858-16 38.858l-77.714 77.714q-16 16-38.858 16t-38.858-16l-168-168-168 168q-16 16-38.858 16t-38.858-16l-77.714-77.714q-16-16-16-38.858t16-38.858l168-168-168-168q-16-16-16-38.858t16-38.858l77.714-77.714q16-16 38.858-16t38.858 16l168 168 168-168q16-16 38.858-16t38.858 16l77.714 77.714q16 16 16 38.858t-16 38.858l-168 168 168 168q16 16 16 38.858z" />
  </IconBase>
);

export const IconPivotRemove = (props: Props) => (
  <IconBase
    viewBox="0 0 64 64"
    {...props}
    data-component-name="IconPivotRemove"
  >
    <path d="M6,63.5a5.45,5.45,0,0,1-3.88-9.28L24.29,32,2.14,9.85a5.45,5.45,0,0,1-.07-7.72,5.44,5.44,0,0,1,7.71-.06L32,24.29,54.15,2.14a5.45,5.45,0,1,1,7.78,7.64L39.71,32,61.86,54.15A5.46,5.46,0,0,1,58,63.5h0a5.4,5.4,0,0,1-3.82-1.57L32,39.71,9.85,61.86A5.43,5.43,0,0,1,6,63.5Z" />
  </IconBase>
);

export const IconHamburgerMenu = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconHamburgerMenu"
  >
    <line
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      x1="5"
      x2="49"
      y1="13.5"
      y2="13.5"
    />
    <line
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      x1="5"
      x2="49"
      y1="27.0"
      y2="27.0"
    />
    <line
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      x1="5"
      x2="49"
      y1="40.5"
      y2="40.5"
    />
  </IconBase>
);

export const IconSamsungDryer = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconSamsungDryer"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M9.6,4.6H44.4V45.8H9.6ZM22.4,8.7h9.4m4.9,23.1a10.85,10.85,0,1,1-.5-11.5m-7.5,4.3s3-4.5,7.6,0c0,0,3.3,2.6,5.1-1.6M28.7,29.1s3-4.5,7.6,0c0,0,3.3,2.6,5.1-1.6"
    />
  </IconBase>
);

export const IconSamsungDryerOffline = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconSamsungDryerOffline"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M9.6,4.6H44.4V45.8H9.6ZM22.4,8.7h9.4m4.9,23.1a10.85,10.85,0,1,1-.5-11.5m-7.5,4.3s3-4.5,7.6,0c0,0,3.3,2.6,5.1-1.6M28.7,29.1s3-4.5,7.6,0c0,0,3.3,2.6,5.1-1.6M3.5,2.5l49,49"
    />
  </IconBase>
);

export const IconSamsungVacuum = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconSamsungVacuum"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M27,6.4A20.6,20.6,0,1,1,6.4,27,20.6,20.6,0,0,1,27,6.4ZM17.2,8.9l2,6.9a.66.66,0,0,0,.5.4H34.1a.82.82,0,0,0,.6-.4l2.9-6.4M31.7,43.2H23c-.4,0-.3-.5-.3-.9l-.4-8a.68.68,0,0,1,.7-.7h8.7a.68.68,0,0,1,.7.7l-.3,8C32.1,42.8,32.1,43.2,31.7,43.2Zm-17.1.3s-3,4.6-4.6,5.1m30-5.3s3,4.6,4.6,5.1"
    />
  </IconBase>
);

export const IconSamsungVacuumCharging = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconSamsungVacuumCharging"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M27,6.2A20.4,20.4,0,1,1,6.6,26.6,20.4,20.4,0,0,1,27,6.2ZM17.4,8.6l2,6.8a.66.66,0,0,0,.5.4H34.1a.62.62,0,0,0,.6-.4L37.5,9M31.7,42.6H23.1c-.4,0-.3-.5-.3-.9l-.4-7.9a.68.68,0,0,1,.7-.7h8.6a.68.68,0,0,1,.7.7l-.4,8C32,42.2,32,42.6,31.7,42.6Zm-17,.2s-2.9,4.5-4.6,5m29.8-5.1s2.9,4.5,4.6,5M27.18,18.1h1.46l-1.58,3.53a.19.19,0,0,0,0,.19.2.2,0,0,0,.17.09h1.43l-2.76,4.21L27,22.78a.23.23,0,0,0,0-.18.26.26,0,0,0-.16-.09H25.33Z"
    />
  </IconBase>
);

export const IconSamsungVacuumOffline = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconSamsungVacuumOffline"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M27,6.2A20.4,20.4,0,1,1,6.6,26.6,20.4,20.4,0,0,1,27,6.2ZM17.4,8.6l2,6.8a.66.66,0,0,0,.5.4H34.1a.62.62,0,0,0,.6-.4L37.5,9M31.7,42.6H23.1c-.4,0-.3-.5-.3-.9l-.4-7.9a.68.68,0,0,1,.7-.7h8.6a.68.68,0,0,1,.7.7l-.4,8C32,42.2,32,42.6,31.7,42.6Zm-17,.2s-2.9,4.5-4.6,5m29.8-5.1s2.9,4.5,4.6,5M7.8,5.7l41,41.4"
    />
  </IconBase>
);

export const IconSamsungWasher = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconSamsungWasher"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M9.6,6.45H44.4v41.1H9.6Zm12.8,4.1h9.4m-4.6,6.8a10.9,10.9,0,1,1-10.9,10.9A10.9,10.9,0,0,1,27.2,17.35Z"
    />
  </IconBase>
);

export const IconSamsungWasherOffline = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconSamsungWasherOffline"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M9.6,6.45H44.4v41.1H9.6Zm12.8,4.1h9.4m-4.6,6.8a10.9,10.9,0,1,1-10.9,10.9A10.9,10.9,0,0,1,27.2,17.35ZM5.72,3.62l41,41.4"
    />
  </IconBase>
);

export const IconSensorActivated = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconSensorActivated"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M37.87,8.55H16.6a3.21,3.21,0,0,0-3.24,3.24V42.21a3.21,3.21,0,0,0,3.24,3.24H37.87a3.21,3.21,0,0,0,3.24-3.24V11.79a3.21,3.21,0,0,0-3.24-3.24Zm-.67,3.72c0,2.38-5.05,4.38-10,4.38s-10-2-10-4.38Zm.95,26a.82.82,0,0,1-.76.76H17.08a.82.82,0,0,1-.76-.76V23a.82.82,0,0,1,.76-.76H37.49a.82.82,0,0,1,.76.76l-.1,15.26ZM34.82,26.46v8M10,19.64,5.72,15.29m2.21,11.4H1.86M9.25,32.6,4.9,37M49.13,16.29l-4.27,4.35m2,7.05H53M50,38,45.6,33.6"
    />
  </IconBase>
);

export const IconSensorGenericActive = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconSensorGenericActive"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="2px"
      d="M42.47,29.38H11.53a4,4,0,0,0-4,4v9.06a4,4,0,0,0,4,4H42.47a4,4,0,0,0,4-4V33.41A4,4,0,0,0,42.47,29.38Zm-5,11.73a3.18,3.18,0,1,1,3.18-3.17A3.17,3.17,0,0,1,37.46,41.11Zm0-19c-8.2-8-17-3.62-20.81,0l2.7,2.71c1.41-1.31,8.27-6.89,15.39,0l2.72-2.71ZM43,14.42C28-.27,13,12.72,11.11,14.42l2.71,2.7c1.66-1.56,13.94-12.22,26.42,0Z"
    />
  </IconBase>
);

export const IconSensorGeneric = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconSensorGeneric"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2px"
      d="M42,27.88H11a4,4,0,0,0-4,4V41a4,4,0,0,0,4,4H42a4,4,0,0,0,4-4V31.91A4,4,0,0,0,42,27.88ZM37,39.61a3.17,3.17,0,1,1,3.17-3.17A3.17,3.17,0,0,1,37,39.61ZM33.32,11a.85.85,0,0,0-.23-.61L31.88,9.21A.79.79,0,0,0,31.29,9a.82.82,0,0,0-.6.25L25.3,14.59l-3-3a.83.83,0,0,0-1.19,0l-1.2,1.19a.88.88,0,0,0,0,1.21l4.78,4.78a.82.82,0,0,0,.6.25.84.84,0,0,0,.61-.25l7.18-7.18A.81.81,0,0,0,33.32,11Zm3.33,2.14a9.94,9.94,0,0,1-1.36,5.1,10.2,10.2,0,0,1-3.69,3.69,10.24,10.24,0,0,1-10.2,0,10.2,10.2,0,0,1-3.69-3.69,9.94,9.94,0,0,1-1.36-5.1,9.94,9.94,0,0,1,1.36-5.1A10.2,10.2,0,0,1,21.4,4.36a10.24,10.24,0,0,1,10.2,0,10.2,10.2,0,0,1,3.69,3.69A9.94,9.94,0,0,1,36.65,13.15Z"
    />
  </IconBase>
);

export const IconSensorMotionIdle = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconSensorMotionIdle"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M37.87,8.55H16.6a3.21,3.21,0,0,0-3.24,3.24V42.21a3.21,3.21,0,0,0,3.24,3.24H37.87a3.21,3.21,0,0,0,3.24-3.24V11.79a3.21,3.21,0,0,0-3.24-3.24Zm-.67,3.72c0,2.38-5.05,4.38-10,4.38s-10-2-10-4.38Zm.95,26a.82.82,0,0,1-.76.76H17.08a.82.82,0,0,1-.76-.76V23a.82.82,0,0,1,.76-.76H37.49a.82.82,0,0,1,.76.76l-.1,15.26ZM34.82,26.46v8"
    />
  </IconBase>
);

export const IconSettings = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconSettings">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M30,52H24a1,1,0,0,1-1-.82l-1.19-6.47A17.92,17.92,0,0,1,18,43.08l-5.38,3.74a1,1,0,0,1-1.28-.11l-4.2-4.2a1,1,0,0,1-.1-1.3l3.82-5.27a18.46,18.46,0,0,1-1.62-3.86L2.83,31A1,1,0,0,1,2,30V24a1,1,0,0,1,.83-1l6.36-1.09A17.92,17.92,0,0,1,10.82,18L7.17,12.66a1,1,0,0,1,.12-1.27l4.2-4.2a1,1,0,0,1,1.3-.1l5.27,3.82a18.46,18.46,0,0,1,3.86-1.62L23,2.83A1,1,0,0,1,24,2h6a1,1,0,0,1,1,.83l1.09,6.46A18.06,18.06,0,0,1,36,10.92l5.38-3.74a1,1,0,0,1,1.28.11l4.2,4.2a1,1,0,0,1,.1,1.29L43.1,18.14a16.54,16.54,0,0,1,1.61,3.78L51.17,23A1,1,0,0,1,52,24v6a1,1,0,0,1-.82,1l-6.4,1.19a20.06,20.06,0,0,1-1.59,3.77L47,41.32a1,1,0,0,1-.1,1.29l-4.2,4.2a1,1,0,0,1-1.29.1L36,43.09a18.53,18.53,0,0,1-3.87,1.62L31,51.18A1,1,0,0,1,30,52ZM51,30h0ZM27,36a9,9,0,1,1,9-9A9,9,0,0,1,27,36Z"
    />
  </IconBase>
);

export const IconShadesBottomHalfOpen = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconShadesBottomHalfOpen"
  >
    <path d="M43.3,47.49H10.7a1,1,0,0,1-1-1V43.41a1,1,0,0,1,1-1h1.48V14.17h-.32a1,1,0,0,1-1-1V7.51a1,1,0,0,1,1-1H42.14a1,1,0,0,1,1,1v5.66a1,1,0,0,1-1,1h-.31V42.41H43.3a1,1,0,0,1,1,1v3.08A1,1,0,0,1,43.3,47.49Zm-31.6-2H42.3V44.41H41.06a1,1,0,0,1-1.23-1V13.17a1,1,0,0,1,1-1h.31V8.51H12.86v3.66h.32a1,1,0,0,1,1,1V43.41a1,1,0,0,1-1,1H11.7Zm26.41-1.08H15.89a1,1,0,0,1-1-1V13.17a1,1,0,0,1,1-1h22.2a1,1,0,0,1,1,1v30a1.64,1.64,0,0,1,0,.23A1,1,0,0,1,38.11,44.41ZM17.68,41.62H36.3V27.87H17.68Zm-.79-15.75h20.2V14.17H16.89Zm-.21,1H37.3V42.62H16.68ZM37.3,43.62H16.68a1,1,0,0,1-1-1V26.87a1,1,0,0,1,1-1H37.3a1,1,0,0,1,1,1V42.62A1,1,0,0,1,37.3,43.62Zm-19.62-2H36.3V27.87H17.68Z" />
  </IconBase>
);

export const IconShadesBottomMostlyClosed = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconShadesBottomMostlyClosed"
  >
    <path d="M43.3,47.49H10.7a1,1,0,0,1-1-1V43.41a1,1,0,0,1,1-1h1.48V14.17h-.32a1,1,0,0,1-1-1V7.51a1,1,0,0,1,1-1H42.14a1,1,0,0,1,1,1v5.66a1,1,0,0,1-1,1h-.31V42.41H43.3a1,1,0,0,1,1,1v3.08A1,1,0,0,1,43.3,47.49Zm-31.6-2H42.3V44.41H41.06a1,1,0,0,1-1.23-1V13.17a1,1,0,0,1,1-1h.31V8.51H12.86v3.66h.32a1,1,0,0,1,1,1V43.41a1,1,0,0,1-1,1H11.7Zm26.41-1.08H15.89a1,1,0,0,1-1-1V13.17a1,1,0,0,1,1-1h22.2a1,1,0,0,1,1,1v30a1.64,1.64,0,0,1,0,.23A1,1,0,0,1,38.11,44.41ZM17.68,41.59H36.3V22.71H17.68Zm-.79-20.88h20.2V14.17H16.89Zm-.21,1H37.3V42.59H16.68ZM37.3,43.59H16.68a1,1,0,0,1-1-1V21.71a1,1,0,0,1,1-1H37.3a1,1,0,0,1,1,1V42.59A1,1,0,0,1,37.3,43.59Zm-19.62-2H36.3V22.71H17.68Z" />
  </IconBase>
);

export const IconShadesBottomMostlyOpen = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconShadesBottomMostlyOpen"
  >
    <path d="M43.3,47.49H10.7a1,1,0,0,1-1-1V43.41a1,1,0,0,1,1-1h1.48V14.17h-.32a1,1,0,0,1-1-1V7.51a1,1,0,0,1,1-1H42.14a1,1,0,0,1,1,1v5.66a1,1,0,0,1-1,1h-.31V42.41H43.3a1,1,0,0,1,1,1v3.08A1,1,0,0,1,43.3,47.49Zm-31.6-2H42.3V44.41H41.06a1,1,0,0,1-1.23-1V13.17a1,1,0,0,1,1-1h.31V8.51H12.86v3.66h.32a1,1,0,0,1,1,1V43.41a1,1,0,0,1-1,1H11.7Zm26.41-1.08H15.89a1,1,0,0,1-1-1V13.17a1,1,0,0,1,1-1h22.2a1,1,0,0,1,1,1v30a1.64,1.64,0,0,1,0,.23A1,1,0,0,1,38.11,44.41ZM17.68,41.62H36.3V32.9H17.68ZM16.89,30.9h20.2V14.17H16.89Zm-.21,1H37.3V42.62H16.68ZM37.3,43.62H16.68a1,1,0,0,1-1-1V31.9a1,1,0,0,1,1-1H37.3a1,1,0,0,1,1,1V42.62A1,1,0,0,1,37.3,43.62Zm-19.62-2H36.3V32.9H17.68Z" />
  </IconBase>
);

export const IconShadesClosed = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconShadesClosed"
  >
    <path d="M43.3,47.49H10.7a1,1,0,0,1-1-1V43.41a1,1,0,0,1,1-1h1.48V14.17h-.32a1,1,0,0,1-1-1V7.51a1,1,0,0,1,1-1H42.14a1,1,0,0,1,1,1v5.66a1,1,0,0,1-1,1h-.31V42.41H43.3a1,1,0,0,1,1,1v3.08A1,1,0,0,1,43.3,47.49Zm-31.6-2H42.3V44.41H41.06a1,1,0,0,1-1.23-1V13.17a1,1,0,0,1,1-1h.31V8.51H12.86v3.66h.32a1,1,0,0,1,1,1V43.41a1,1,0,0,1-1,1H11.7Zm26.41-1.08H15.89a1,1,0,0,1-1-1V13.17a1,1,0,0,1,1-1h22.2a1,1,0,0,1,1,1v30a1.64,1.64,0,0,1,0,.23A1,1,0,0,1,38.11,44.41ZM17.68,41.62H36.3V15H17.68ZM16.68,14H37.3V42.62H16.68ZM37.3,43.62H16.68a1,1,0,0,1-1-1V14a1,1,0,0,1,1-1H37.3a1,1,0,0,1,1,1V42.62A1,1,0,0,1,37.3,43.62Zm-19.62-2H36.3V15H17.68Z" />
  </IconBase>
);

export const IconShadesHalfOpen = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconShadesHalfOpen"
  >
    <path d="M43.3,47.49H10.7a1,1,0,0,1-1-1V43.41a1,1,0,0,1,1-1h1.48V14.17h-.32a1,1,0,0,1-1-1V7.51a1,1,0,0,1,1-1H42.14a1,1,0,0,1,1,1v5.66a1,1,0,0,1-1,1h-.31V42.41H43.3a1,1,0,0,1,1,1v3.08A1,1,0,0,1,43.3,47.49Zm-31.6-2H42.3V44.41H41.06a1,1,0,0,1-1.23-1V13.17a1,1,0,0,1,1-1h.31V8.51H12.86v3.66h.32a1,1,0,0,1,1,1V43.41a1,1,0,0,1-1,1H11.7Zm26.41-1.08H15.89a1,1,0,0,1-1-1V13.17a1,1,0,0,1,1-1h22.2a1,1,0,0,1,1,1v30a1.64,1.64,0,0,1,0,.23A1,1,0,0,1,38.11,44.41Zm-21.22-2h20.2V30.9H16.89Zm.79-13.51H36.3V15H17.68ZM16.68,14H37.3V29.9H16.68ZM37.3,30.9H16.68a1,1,0,0,1-1-1V14a1,1,0,0,1,1-1H37.3a1,1,0,0,1,1,1V29.9A1,1,0,0,1,37.3,30.9Zm-19.62-2H36.3V15H17.68Z" />
  </IconBase>
);

export const IconShadesMostlyClosed = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconShadesMostlyClosed"
  >
    <path d="M43.3,47.49H10.7a1,1,0,0,1-1-1V43.41a1,1,0,0,1,1-1h1.48V14.17h-.32a1,1,0,0,1-1-1V7.51a1,1,0,0,1,1-1H42.14a1,1,0,0,1,1,1v5.66a1,1,0,0,1-1,1h-.31V42.41H43.3a1,1,0,0,1,1,1v3.08A1,1,0,0,1,43.3,47.49Zm-31.6-2H42.3V44.41H41.06a1,1,0,0,1-1.23-1V13.17a1,1,0,0,1,1-1h.31V8.51H12.86v3.66h.32a1,1,0,0,1,1,1V43.41a1,1,0,0,1-1,1H11.7Zm26.41-1.08H15.89a1,1,0,0,1-1-1V13.17a1,1,0,0,1,1-1h22.2a1,1,0,0,1,1,1v30a1.64,1.64,0,0,1,0,.23A1,1,0,0,1,38.11,44.41Zm-21.22-2h20.2V36H16.89ZM17.68,34H36.3V15H17.68ZM16.68,14H37.3V35H16.68ZM37.3,36H16.68a1,1,0,0,1-1-1V14a1,1,0,0,1,1-1H37.3a1,1,0,0,1,1,1V35A1,1,0,0,1,37.3,36ZM17.68,34H36.3V15H17.68Z" />
  </IconBase>
);

export const IconShadesMostlyOpen = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconShadesMostlyOpen"
  >
    <path d="M43.3,47.49H10.7a1,1,0,0,1-1-1V43.41a1,1,0,0,1,1-1h1.48V14.17h-.32a1,1,0,0,1-1-1V7.51a1,1,0,0,1,1-1H42.14a1,1,0,0,1,1,1v5.66a1,1,0,0,1-1,1h-.31V42.41H43.3a1,1,0,0,1,1,1v3.08A1,1,0,0,1,43.3,47.49Zm-31.6-2H42.3V44.41H41.06a1,1,0,0,1-1.23-1V13.17a1,1,0,0,1,1-1h.31V8.51H12.86v3.66h.32a1,1,0,0,1,1,1V43.41a1,1,0,0,1-1,1H11.7Zm26.41-1.08H15.89a1,1,0,0,1-1-1V13.17a1,1,0,0,1,1-1h22.2a1,1,0,0,1,1,1v30a1.64,1.64,0,0,1,0,.23A1,1,0,0,1,38.11,44.41Zm-21.22-2h20.2V25.68H16.89Zm.79-18.73H36.3V15H17.68Zm-1-9.72H37.3V24.68H16.68ZM37.3,25.68H16.68a1,1,0,0,1-1-1V14a1,1,0,0,1,1-1H37.3a1,1,0,0,1,1,1V24.68A1,1,0,0,1,37.3,25.68Zm-19.62-2H36.3V15H17.68Z" />
  </IconBase>
);

export const IconShadesOpen = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconShadesOpen">
    <path d="M43.3,47.49H10.7a1,1,0,0,1-1-1V43.41a1,1,0,0,1,1-1h1.48V14.17h-.32a1,1,0,0,1-1-1V7.51a1,1,0,0,1,1-1H42.14a1,1,0,0,1,1,1v5.66a1,1,0,0,1-1,1h-.31V42.41H43.3a1,1,0,0,1,1,1v3.08A1,1,0,0,1,43.3,47.49Zm-31.6-2H42.3V44.41H41.06a1,1,0,0,1-1.23-1V13.17a1,1,0,0,1,1-1h.31V8.51H12.86v3.66h.32a1,1,0,0,1,1,1V43.41a1,1,0,0,1-1,1H11.7Zm26.41-1.08H15.89a1,1,0,0,1-1-1V13.17a1,1,0,0,1,1-1h22.2a1,1,0,0,1,1,1v30a1.64,1.64,0,0,1,0,.23A1,1,0,0,1,38.11,44.41Zm-21.22-2h20.2V14.17H16.89Z" />
  </IconBase>
);

export const IconShield = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconShield">
    <path d="M27,51.85a1,1,0,0,1-.42-.09C26.36,51.66,5,41.44,5,11a1,1,0,0,1,.78-1,54.81,54.81,0,0,0,15-5.59C23.23,3.09,25,2.15,27,2.15s3.74.94,6.19,2.23a52.54,52.54,0,0,0,15,5.59A1,1,0,0,1,49,11c0,15.43-5.84,25.69-10.73,31.58a37.74,37.74,0,0,1-10.82,9.21A1,1,0,0,1,27,51.85ZM7,11.75c.34,26.21,17,36.38,20,38,2.93-1.71,19.67-12.56,20-38a54.51,54.51,0,0,1-14.74-5.6c-2.19-1.16-3.78-2-5.25-2s-3.1.84-5.32,2A57,57,0,0,1,7,11.75Z" />
  </IconBase>
);

export const IconSirenOn = (props: Props) => (
  <IconBase viewBox="0 0 54 54 " {...props} data-component-name="IconSirenOn">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M9,44H45v7H9ZM37.7,20l3.2,24h-28l3.2-24A7,7,0,0,1,23,13.9h7.6A7.21,7.21,0,0,1,37.7,20ZM35.6,7.4,37.8,3m8.8,13.2L51,14M46.6,29.4,51,31.6M18.4,7.4,16.2,3M7.4,16.2,3,14M7.4,29.4,3,31.6"
    />
  </IconBase>
);

export const IconSiren = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconSiren">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M9,44H45v7H9ZM37.7,20l3.2,24h-28l3.2-24A7,7,0,0,1,23,13.9h7.6A7.21,7.21,0,0,1,37.7,20Z"
    />
  </IconBase>
);

export const IconSlidingDoorClosedLocked = (props: Props) => (
  <IconBase
    viewBox="0 0 1278 1024"
    {...props}
    data-component-name="IconSlidingDoorClosedLocked"
  >
    <path d="M609.524 56.381h464.762v591.238c-13.714 1.524-25.905 3.048-38.095 7.619v-562.286h-390.095v755.81h254.476c1.524 13.714 3.048 25.905 6.095 38.095h-297.143v-830.476zm321.524 882.286h-912.762c-10.667 0-18.286-9.143-18.286-18.286v-902.095c0-10.667 7.619-18.286 18.286-18.286h1097.143c10.667 0 18.286 7.619 18.286 18.286v633.905c-12.19-3.048-24.381-4.571-36.571-4.571v-609.524h-512v865.524h327.619c4.571 10.667 10.667 22.857 18.286 35.048zm-894.477-36.572h512v-865.524h-512v865.524zm24.381-845.714h464.762v832h-464.762v-832zm36.572 793.905h390.095v-757.333h-390.095v757.333zm992-196.572c-100.571 0-181.333 80.762-181.333 181.333s80.762 181.333 181.333 181.333 181.333-80.762 181.333-181.333-80.762-181.333-181.333-181.333zm102.095 272.762c0 15.238-13.714 28.952-28.952 28.952h-146.286c-15.238 0-28.952-13.714-28.952-28.952v-97.524c0-15.238 13.714-28.952 28.952-28.952v-35.048c0-39.619 32-73.143 73.143-73.143s73.143 32 73.143 73.143v35.048c15.238 0 28.952 13.714 28.952 28.952v97.524zm-57.905-160v33.524h-88.381v-33.524c0-24.381 19.81-44.19 44.19-44.19s44.19 19.81 44.19 44.19zm-27.428 97.524c0 6.095-3.048 10.667-9.143 13.714v25.905c0 3.048-1.524 4.571-4.571 4.571s-4.571-1.524-4.571-4.571v-25.905h-3.048c-6.095-1.524-9.143-7.619-9.143-13.714 0-9.143 6.095-15.238 15.238-15.238 7.619 0 15.238 6.095 15.238 15.238z" />
  </IconBase>
);

export const IconSlidingDoorClosedUnlocked = (props: Props) => (
  <IconBase
    viewBox="0 0 1278 1024"
    {...props}
    data-component-name="IconSlidingDoorClosedUnlocked"
  >
    <path d="M609.524 56.381h464.762v591.238c-13.714 1.524-25.905 3.048-38.095 7.619v-562.286h-390.095v755.81h254.476c1.524 13.714 3.048 25.905 6.095 38.095h-297.143v-830.476zm-548.572 0h464.762v832h-464.762v-832zm36.572 793.905h390.095v-757.333h-390.095v757.333zm833.524 88.381h-912.762c-10.667 0-18.286-9.143-18.286-18.286v-902.095c0-10.667 7.619-18.286 18.286-18.286h1097.143c10.667 0 18.286 7.619 18.286 18.286v633.905c-12.19-3.048-24.381-4.571-36.571-4.571v-609.524h-512v865.524h327.619c4.571 10.667 10.667 22.857 18.286 35.048zm-894.477-36.572h512v-865.524h-512v865.524zm1052.953-248.381c-100.571 0-181.333 80.762-181.333 181.333s80.762 181.333 181.333 181.333 181.333-80.762 181.333-181.333-80.762-181.333-181.333-181.333zm106.666 257.524c0 12.19-10.667 22.857-22.857 22.857h-114.286c-12.19 0-22.857-10.667-22.857-22.857v-76.19c0-12.19 10.667-22.857 22.857-22.857-1.524 0-1.524-57.905-1.524-57.905 0-18.286-15.238-33.524-33.524-33.524s-33.524 15.238-33.524 33.524v30.476c0 6.095-6.095 12.19-12.19 12.19s-12.19-6.095-12.19-12.19v-30.476c0-30.476 25.905-56.381 56.381-56.381h1.524c32 0 57.905 24.381 57.905 56.381v57.905h91.429c12.19 0 22.857 10.667 22.857 22.857v76.19zm-71.619-48.762c0 4.571-3.048 9.143-7.619 10.667v19.81c0 1.524-1.524 3.048-3.048 3.048s-3.048-1.524-3.048-3.048v-19.81c-4.571-3.048-7.619-6.095-10.667-10.667 0-6.095 6.095-12.19 12.19-12.19s12.19 4.571 12.19 12.19z" />
  </IconBase>
);

export const IconSlidingDoorClosed = (props: Props) => (
  <IconBase
    viewBox="0 0 1237 1024"
    {...props}
    data-component-name="IconSlidingDoorClosed"
  >
    <path d="M1171.355 968.285h-506.927v-907.58h506.927zm-465.681-41.08h424.435v-825.42h-424.435zm511.584 96.795h-598.733c-10.931 0-19.791-8.861-19.791-19.791v-984.583c.094-10.859 8.919-19.625 19.791-19.625h598.7339999999999c10.931 0 19.791 8.861 19.791 19.791v984.583c-.094 10.859-8.919 19.625-19.791 19.625h-.001zm-578.942-39.417h559.15v-945.167h-559.15zm-65.694-16.631h-506.927v-907.247h506.927zm-465.682-41.08h424.435v-825.088h-424.435zm511.585 97.128h-598.733c-10.931 0-19.791-8.861-19.791-19.791v-984.583c.094-10.859 8.919-19.625 19.791-19.625h598.7339999999999c10.931 0 19.791 8.861 19.791 19.791v984.583c-.094 10.859-8.919 19.625-19.791 19.625h-.001zm-578.942-39.417h559.15v-945.167h-559.15z" />
  </IconBase>
);

export const IconSlidingDoorOpen = (props: Props) => (
  <IconBase
    viewBox="0 0 1237 1024"
    {...props}
    data-component-name="IconSlidingDoorOpen"
  >
    <path d="M871.065 967.481h-505.351v-905.974h507.013l-1.662 905.974zm-465.455-39.897h425.558v-826.182h-425.558v826.182zm811.221 96.416h-598.442v-39.896h578.494v-944.208h-578.494v-39.896h598.442c11.636 0 19.948 8.312 19.948 19.948v984.104c0 9.974-9.974 19.948-19.948 19.948zm-644.987-56.519h-505.351v-905.974h505.351v905.974zm-465.454-39.897h425.558v-826.182h-425.558v826.182zm512 96.416h-598.442c-11.636 0-19.948-8.312-19.948-19.948v-984.104c0-11.636 8.312-19.948 19.948-19.948h598.442v39.896h-578.494v944.208h578.494v39.896z" />
  </IconBase>
);

export const IconSlidingDoorUnknown = (props: Props) => (
  <IconBase
    viewBox="0 0 1278 1024"
    {...props}
    data-component-name="IconSlidingDoorUnknown"
  >
    <path d="M609.524 56.381h464.762v591.238c-13.714 1.524-25.905 3.048-38.095 7.619v-562.286h-390.095v755.81h254.476c1.524 13.714 3.048 25.905 6.095 38.095h-297.143v-830.476zm321.524 882.286h-912.762c-10.667 0-18.286-7.619-18.286-18.286v-902.095c0-10.667 7.619-18.286 18.286-18.286h1097.143c10.667 0 18.286 7.619 18.286 18.286v632.381c-12.19-3.048-24.381-4.571-36.571-4.571v-609.524h-512v865.524h327.619c4.571 12.19 10.667 24.381 18.286 36.571zm-894.477-36.572h512v-865.524h-512v865.524zm24.381-845.714h463.238v832h-463.238v-832zm36.572 793.905h390.095v-757.333h-390.095v757.333zm992-196.572c-100.571 0-181.333 80.762-181.333 181.333s80.762 181.333 181.333 181.333 181.333-80.762 181.333-181.333-80.762-181.333-181.333-181.333zm22.857 259.048h-30.476v-121.905h30.476v121.905zm0-152.381h-30.476v-30.476h30.476v30.476z" />
  </IconBase>
);

export const IconSmile = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconSmile">
    <path d="M27,51a24,24,0,0,1-.23-48L27,3h0l.22,0A24,24,0,0,1,27,51ZM27,5l-.15,0a22,22,0,1,0,.3,0Zm0,36c-9,0-14.41-7.52-14.63-7.84A1,1,0,0,1,14,32c.05.07,5.06,7,13,7s13-6.92,13-7a1,1,0,1,1,1.63,1.15C41.41,33.48,36,41,27,41Zm8-14a4,4,0,1,1,4-4A4,4,0,0,1,35,27Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,35,21ZM19,27a4,4,0,1,1,4-4A4,4,0,0,1,19,27Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,19,21Z" />
  </IconBase>
);

export const IconSmokeDetectorTriggered = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconSmokeDetectorTriggered"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M27,41.61a14.61,14.61,0,0,1,0-29.22A14.54,14.54,0,0,1,41.54,27,14.59,14.59,0,0,1,27,41.61Zm0-4.15a2.09,2.09,0,1,1,2.08-2.09A2.1,2.1,0,0,1,27,37.46ZM22.85,18.21h8.33m-8.33,3.44h8.33m-8.33,3.79h8.33M43.1,19.85l4.76-4.67m-2.51,12.4H52m-8,6.48,4.67,4.76M6.24,15.18,11,19.85M2.1,27.58H8.75M5.43,38.82l4.67-4.76"
    />
  </IconBase>
);

export const IconSmokeDetector = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconSmokeDetector"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M27,41.61a14.61,14.61,0,0,1,0-29.22A14.54,14.54,0,0,1,41.54,27,14.59,14.59,0,0,1,27,41.61Zm0-4.15a2.09,2.09,0,1,1,2.08-2.09A2.1,2.1,0,0,1,27,37.46ZM22.85,18.21h8.33m-8.33,3.44h8.33m-8.33,3.79h8.33"
    />
  </IconBase>
);

export const IconStar = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconStar">
    <path d="M12.2,51.8a1.75,1.75,0,0,1-.51-.07,2,2,0,0,1-1.42-2.44l4.17-15.76L1.73,23.15A2,2,0,0,1,1,21.7a2,2,0,0,1,1.9-2.1l16.3-.83L25.14,3.48A2,2,0,0,1,27,2.2h0a2,2,0,0,1,1.86,1.28L34.8,18.77l16.3.83a2,2,0,0,1,1.45.73,2,2,0,0,1-.28,2.82L39.56,33.53l4.17,15.76a1.94,1.94,0,0,1-.25,1.59,2,2,0,0,1-2.76.6L27,42.68l-13.72,8.8A2,2,0,0,1,12.2,51.8ZM27,40.3l14.8,9.5-4.5-17L51,21.6l-17.6-.9L27,4.2,20.6,20.7,3,21.6,16.7,32.8l-4.5,17Z" />
  </IconBase>
);

export const IconSunny = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconSunny">
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M27,2a1,1,0,0,0-.81.45l-5.5,8.24h0a1.43,1.43,0,0,1-.73.3L10.23,9.05a1,1,0,0,0-1.18,1.18L11,19.94a1.52,1.52,0,0,1-.3.73l-8.24,5.5a1,1,0,0,0,0,1.66l8.24,5.5h0a1.43,1.43,0,0,1,.3.73L9.05,43.78a1,1,0,0,0,.27.9,1,1,0,0,0,.91.27L19.94,43a1.48,1.48,0,0,1,.73.3l5.5,8.24a1,1,0,0,0,1.66,0l5.5-8.24h0a1.43,1.43,0,0,1,.73-.3L43.78,45a1,1,0,0,0,.9-.27,1,1,0,0,0,.27-.91L43,34.06a1.39,1.39,0,0,1,.3-.73h0l8.24-5.5a1,1,0,0,0,0-1.66l-8.24-5.5h0a1.43,1.43,0,0,1-.3-.73L45,10.23a1,1,0,0,0-1.18-1.18L34.06,11a1.48,1.48,0,0,1-.73-.3l-5.5-8.24A1,1,0,0,0,27,2Zm0,12A13,13,0,1,0,40,27,13,13,0,0,0,27,14Z"
    />
  </IconBase>
);

export const IconSupport = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconSupport">
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2px"
      d="M43.5,25h-2v8h2a2,2,0,0,0,2-2V27A2,2,0,0,0,43.5,25Zm-13,17h5a7,7,0,0,0,7-7V33m-14,11h-2a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2h0A2,2,0,0,1,28.5,44Zm-18-16.9,4,1.9V21s11.5-.6,16-6c2.7,4.4,8,6,8,6v8l2-1m2.67-3.17c.6,0,.33-.33.33-.83V20c-.4-8.8-5.3-13.8-13.6-14l-2-2h-.4C14.8,4,9.9,12.2,9.5,20v6.7a4.45,4.45,0,0,0-1,3.1,4.73,4.73,0,0,0,3.7,4.7C14.8,41.3,19.1,50,26.5,50c4,0,7.1-2.6,9.5-6"
    />
  </IconBase>
);

export const IconUndo = (props: Props) => (
  <IconBase viewBox="0 0 876 1024" {...props} data-component-name="IconUndo">
    <path d="M876.856 512q0 89.142-34.858 170.286t-93.714 140-140 93.714-170.286 34.858q-98.286 0-186.858-41.428t-150.858-116.858q-4-5.714-3.714-12.858t4.858-11.714l78.286-78.858q5.714-5.142 14.286-5.142 9.142 1.142 13.142 6.858 41.714 54.286 102.286 84t128.572 29.714q59.428 0 113.428-23.142t93.428-62.572 62.572-93.428 23.142-113.428-23.142-113.428-62.572-93.428-93.428-62.572-113.428-23.142q-56 0-107.428 20.286t-91.428 58l78.286 78.858q17.714 17.142 8 39.428-9.714 22.858-33.714 22.858h-256q-14.858 0-25.714-10.858t-10.858-25.714v-256q0-24 22.858-33.714 22.286-9.714 39.428 8l74.286 73.714q61.142-57.714 139.714-89.428t162.572-31.714q89.142 0 170.286 34.858t140 93.714 93.714 140 34.858 170.286z" />
  </IconBase>
);

export const IconUser = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconUser">
    <path d="M27,51A24,24,0,1,1,51,27,24,24,0,0,1,27,51ZM11.87,43a22,22,0,0,0,30.34-.08A43.16,43.16,0,0,0,35.67,40a18.05,18.05,0,0,1-2.93-1.2,3.73,3.73,0,0,1-1.6-1.65l-.59-1.24,1.37-.18A21.59,21.59,0,0,0,36,35a5.45,5.45,0,0,0,1.48-.75c.48-.36.54-.62.54-.81a3.21,3.21,0,0,1-.74-1.7A17.43,17.43,0,0,1,37,28.88c0-.83,0-1.74,0-2.7,0-1.5,0-3.05,0-4.61a16,16,0,0,0-1.42-6.73,5.27,5.27,0,0,0-4.88-2.78h-.31l-.25-.18A5.32,5.32,0,0,0,27.09,11a9.38,9.38,0,0,0-7.2,3.53,14.16,14.16,0,0,0-2.4,7c-.22,1.86-.27,3.76-.32,5.43,0,.67,0,1.32-.06,1.92a16.78,16.78,0,0,1-.29,2.83A3.48,3.48,0,0,1,16,33.48a1.31,1.31,0,0,0,.55.94,4.9,4.9,0,0,0,1.51.67,28.27,28.27,0,0,0,3.9.69l1.33.17-.48,1.23a3.58,3.58,0,0,1-1.63,1.69,16.71,16.71,0,0,1-2.9,1.19A38.86,38.86,0,0,0,11.87,43ZM27,5A22,22,0,0,0,10.45,41.48a38.72,38.72,0,0,1,7.2-3.31c.63-.22,1.31-.46,1.9-.71A18.3,18.3,0,0,1,17.49,37a6.56,6.56,0,0,1-2.13-1A3.22,3.22,0,0,1,14,33.48,2,2,0,0,1,14.66,32a4.09,4.09,0,0,0,.21-.67,16.34,16.34,0,0,0,.25-2.49q0-.9.06-1.89c0-1.72.09-3.66.32-5.62a16.1,16.1,0,0,1,2.79-8A11.37,11.37,0,0,1,27,9h.14a7.36,7.36,0,0,1,3.95,1,7.25,7.25,0,0,1,6.33,3.83A17.7,17.7,0,0,1,39,21.49c.07,1.61,0,3.26,0,4.72,0,.93,0,1.83,0,2.64a15.79,15.79,0,0,0,.19,2.48,2.6,2.6,0,0,0,.2.66,2,2,0,0,1,.57,1.4,3,3,0,0,1-1.33,2.4,7.37,7.37,0,0,1-2,1,13.63,13.63,0,0,1-2.29.59c.58.26,1.27.5,1.94.73a43.2,43.2,0,0,1,7.32,3.25A22,22,0,0,0,27,5Z" />
  </IconBase>
);

export const IconUserAndroid = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconUserAndroid"
  >
    <path
      d="M17.2,42.2C8.8,42.2,2,35.4,2,27s6.8-15.2,15.2-15.2S32.5,18.6,32.5,27S25.7,42.2,17.2,42.2z M7.6,37.2
    	c5.4,5.1,13.9,5.1,19.3-0.1c-1.3-0.7-2.7-1.4-4.2-1.9c-0.6-0.2-1.3-0.5-1.9-0.8c-0.4-0.2-0.8-0.6-1-1l-0.4-0.8l0.9-0.1
    	c0.9-0.1,1.7-0.2,2.6-0.5c0.3-0.1,0.7-0.3,0.9-0.5c0.3-0.2,0.3-0.4,0.3-0.5c-0.3-0.3-0.4-0.7-0.5-1.1c-0.1-0.6-0.2-1.2-0.2-1.8
    	c0-0.5,0-1.1,0-1.7c0-1,0-1.9,0-2.9c0-1.5-0.3-2.9-0.9-4.3c-0.6-1.1-1.8-1.8-3.1-1.8h-0.2L19,17.3c-0.6-0.4-1.3-0.6-1.9-0.6
    	c-1.8,0-3.5,0.8-4.6,2.2c-0.9,1.3-1.4,2.9-1.5,4.4c0.1,1.4,0,2.6,0,3.7c0,0.4,0,0.8,0,1.2c0,0.6-0.1,1.2-0.2,1.8
    	c-0.1,0.4-0.2,0.8-0.5,1.1c0,0.2,0.2,0.5,0.3,0.6c0.3,0.2,0.6,0.3,1,0.4c0.8,0.2,1.6,0.4,2.5,0.4l0.8,0.1l-0.3,0.8
    	c-0.2,0.5-0.6,0.8-1,1.1c-0.6,0.3-1.2,0.6-1.8,0.8C10.3,35.8,8.9,36.4,7.6,37.2z M17.2,13c-7.7,0-14,6.3-14,14
    	c0,3.4,1.2,6.6,3.5,9.2c1.4-0.9,3-1.6,4.6-2.1c0.4-0.1,0.8-0.3,1.2-0.5c-0.4-0.1-0.9-0.2-1.3-0.3c-0.5-0.1-0.9-0.3-1.4-0.6
    	c-0.5-0.4-0.8-1-0.9-1.6c0-0.4,0.2-0.7,0.4-0.9c0.1-0.1,0.1-0.3,0.1-0.4c0.1-0.5,0.1-1.1,0.2-1.6c0-0.4,0-0.8,0-1.2
    	c0-1.1,0.1-2.3,0.2-3.6c0.1-1.8,0.7-3.6,1.8-5.1c1.3-1.7,3.4-2.7,5.5-2.8h0.1c0.9,0,1.7,0.2,2.5,0.6c1.7,0,3.2,0.9,4,2.4
    	c0.7,1.5,1,3.2,1,4.9c0,1,0,2.1,0,3c0,0.6,0,1.2,0,1.7s0,1.1,0.1,1.6c0,0.1,0.1,0.3,0.1,0.4c0.2,0.2,0.4,0.6,0.4,0.9
    	c0,0.6-0.3,1.2-0.8,1.5c-0.4,0.3-0.8,0.5-1.3,0.6c-0.5,0.2-1,0.3-1.5,0.4c0.4,0.2,0.8,0.3,1.2,0.5c1.6,0.5,3.2,1.2,4.7,2.1
    	c5-5.8,4.4-14.7-1.5-19.7C23.8,14.2,20.6,13,17.2,13z"
    />
    <path
      strokeWidth="0.25"
      strokeMiterlimit="10"
      stroke="currentColor"
      d="M40,20.4C40,20.4,39.9,20.4,40,20.4c-0.2,0-0.2,0.1-0.3,0.2c0,0.1,0,0.2,0,0.3l0.7,1.1
    		c-1.2,0.6-2.1,1.7-2.3,3.1c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0.1v0.5c-0.2-0.1-0.4-0.2-0.7-0.2
    		c-0.7,0-1.4,0.6-1.4,1.4v4.1c0,0.7,0.6,1.4,1.4,1.4c0.2,0,0.5-0.1,0.7-0.2v0.9c0,0.6,0.5,1,1,1h0.3v2c0,0.7,0.6,1.4,1.4,1.4
    		s1.4-0.6,1.4-1.4v-2h1.4v2c0,0.7,0.6,1.4,1.4,1.4c0.7,0,1.4-0.6,1.4-1.4v-2h0.3c0.6,0,1-0.5,1-1v-0.9c0.2,0.1,0.4,0.2,0.7,0.2
    		c0.7,0,1.4-0.6,1.4-1.4v-4.1c0-0.7-0.6-1.4-1.4-1.4c-0.2,0-0.5,0.1-0.7,0.2v-0.5c0,0,0-0.1,0-0.1c0,0,0,0,0,0s0,0,0,0
    		c-0.2-1.3-1.1-2.4-2.3-3.1l0.7-1.1c0.1-0.1,0.1-0.3,0-0.4c-0.1-0.1-0.2-0.2-0.4-0.1c-0.1,0-0.2,0.1-0.2,0.1l-0.8,1.2
    		c-0.6-0.2-1.2-0.3-1.8-0.3c-0.6,0-1.3,0.1-1.8,0.3l-0.8-1.2C40.2,20.4,40.1,20.4,40,20.4z M42.9,22.1c0.6,0,1.2,0.1,1.8,0.3
    		c0,0,0,0,0,0c1.1,0.5,1.8,1.3,2.1,2.4H39c0.3-1,1-1.9,2.1-2.3c0,0,0,0,0.1,0C41.6,22.2,42.3,22.1,42.9,22.1z M41,23.1
    		c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5C41.5,23.3,41.3,23.1,41,23.1z M44.8,23.1
    		c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5C45.3,23.3,45,23.1,44.8,23.1z M38.8,25.5H47v7.5
    		c0,0.2-0.1,0.3-0.3,0.3H44c0,0-0.1,0-0.1,0h-3.9c0,0-0.1,0-0.1,0h-0.6c-0.2,0-0.3-0.1-0.3-0.3V25.5z M37.5,26.1
    		c0.4,0,0.7,0.3,0.7,0.7v4.1c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7v-4.1C36.8,26.4,37.1,26.1,37.5,26.1z M48.3,26.1
    		c0.4,0,0.7,0.3,0.7,0.7v4.1c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7v-4.1C47.6,26.4,47.9,26.1,48.3,26.1z M40.2,34h1.4v2
    		c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7V34z M44.2,34h1.4v2c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7V34z"
    />
  </IconBase>
);

export const IconUserBrowser = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconUserBrowser"
  >
    <path
      d="M17.2,42.2C8.8,42.2,2,35.4,2,27s6.8-15.2,15.2-15.2S32.5,18.6,32.5,27S25.7,42.2,17.2,42.2z M7.6,37.2
    	c5.4,5.1,13.9,5.1,19.3-0.1c-1.3-0.7-2.7-1.4-4.2-1.9c-0.6-0.2-1.3-0.5-1.9-0.8c-0.4-0.2-0.8-0.6-1-1l-0.4-0.8l0.9-0.1
    	c0.9-0.1,1.7-0.2,2.6-0.5c0.3-0.1,0.7-0.3,0.9-0.5c0.3-0.2,0.3-0.4,0.3-0.5c-0.3-0.3-0.4-0.7-0.5-1.1c-0.1-0.6-0.2-1.2-0.2-1.8
    	c0-0.5,0-1.1,0-1.7c0-1,0-1.9,0-2.9c0-1.5-0.3-2.9-0.9-4.3c-0.6-1.1-1.8-1.8-3.1-1.8h-0.2l-0.2-0.1c-0.6-0.4-1.3-0.6-1.9-0.6
    	c-1.8,0-3.5,0.8-4.6,2.2c-0.9,1.3-1.4,2.9-1.5,4.4C11.1,24.7,11,25.9,11,27c0,0.4,0,0.8,0,1.2c0,0.6-0.1,1.2-0.2,1.8
    	c-0.1,0.4-0.2,0.8-0.5,1.1c0,0.2,0.2,0.5,0.3,0.6c0.3,0.2,0.6,0.3,1,0.4c0.8,0.2,1.6,0.4,2.5,0.4l0.8,0.1l-0.3,0.8
    	c-0.2,0.5-0.6,0.8-1,1.1c-0.6,0.3-1.2,0.6-1.8,0.8C10.3,35.8,8.9,36.4,7.6,37.2z M17.2,13c-7.7,0-14,6.3-14,14
    	c0,3.4,1.2,6.6,3.5,9.2c1.4-0.9,3-1.6,4.6-2.1c0.4-0.1,0.8-0.3,1.2-0.5c-0.4-0.1-0.9-0.2-1.3-0.3c-0.5-0.1-0.9-0.3-1.4-0.6
    	c-0.5-0.4-0.8-1-0.9-1.6c0-0.4,0.2-0.7,0.4-0.9c0.1-0.1,0.1-0.3,0.1-0.4c0.1-0.5,0.1-1.1,0.2-1.6c0-0.4,0-0.8,0-1.2
    	c0-1.1,0.1-2.3,0.2-3.6c0.1-1.8,0.7-3.6,1.8-5.1c1.3-1.7,3.4-2.7,5.5-2.8h0.1c0.9,0,1.7,0.2,2.5,0.6c1.7,0,3.2,0.9,4,2.4
    	c0.7,1.5,1,3.2,1,4.9c0,1,0,2.1,0,3c0,0.6,0,1.2,0,1.7c0,0.5,0,1.1,0.1,1.6c0,0.1,0.1,0.3,0.1,0.4c0.2,0.2,0.4,0.6,0.4,0.9
    	c0,0.6-0.3,1.2-0.8,1.5c-0.4,0.3-0.8,0.5-1.3,0.6c-0.5,0.2-1,0.3-1.5,0.4c0.4,0.2,0.8,0.3,1.2,0.5c1.6,0.5,3.2,1.2,4.7,2.1
    	c5-5.8,4.4-14.7-1.5-19.7C23.8,14.2,20.6,13,17.2,13z"
    />
    <path
      strokeMiterlimit="10"
      fill="none"
      stroke="currentColor"
      d="M35.9,20.8c-0.5,0-0.9,0.4-0.9,0.9v11.2c0,0.2,0.1,0.3,0.2,0.3h14.4c0.3,0,0.5-0.1,0.5-0.3V21.7
    	c0-0.5-0.4-0.9-0.9-0.9H35.9z M40.6,22.1v0.3V24h7.9v-2H40.6z M37,22.4c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7
    	c0.4,0,0.7-0.3,0.7-0.7C37.6,22.7,37.3,22.4,37,22.4z M38.9,22.4c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7
    	c0.4,0,0.7-0.3,0.7-0.7C39.6,22.7,39.3,22.4,38.9,22.4z M35,25.4h15.1"
    />
  </IconBase>
);

export const IconUserMobile = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconUserMobile">
    <path d="M17.2,42.2A15.2,15.2,0,1,1,32.5,27,15.19,15.19,0,0,1,17.2,42.2Zm-9.6-5a14,14,0,0,0,19.3-.1,26.81,26.81,0,0,0-4.2-1.9,15.39,15.39,0,0,1-1.9-.8,2.41,2.41,0,0,1-1-1l-.4-.8.9-.1a11.93,11.93,0,0,0,2.6-.5,2.62,2.62,0,0,0,.9-.5.54.54,0,0,0,.3-.5,2.22,2.22,0,0,1-.5-1.1,11,11,0,0,1-.2-1.8V23.5a10.7,10.7,0,0,0-.9-4.3,3.53,3.53,0,0,0-3.1-1.8h-.2l-.2-.1a3.53,3.53,0,0,0-1.9-.6,5.83,5.83,0,0,0-4.6,2.2A8.92,8.92,0,0,0,11,23.3c.1,1.4,0,2.6,0,3.7v1.2a11,11,0,0,1-.2,1.8,2.22,2.22,0,0,1-.5,1.1,1.14,1.14,0,0,0,.3.6,3,3,0,0,0,1,.4,10.05,10.05,0,0,0,2.5.4l.8.1-.3.8a2.66,2.66,0,0,1-1,1.1,14.17,14.17,0,0,1-1.8.8A20,20,0,0,0,7.6,37.2ZM17.2,13a14,14,0,0,0-14,14,13.72,13.72,0,0,0,3.5,9.2,19.15,19.15,0,0,1,4.6-2.1,6.12,6.12,0,0,0,1.2-.5l-1.3-.3a4.24,4.24,0,0,1-1.4-.6,2.6,2.6,0,0,1-.9-1.6,1.27,1.27,0,0,1,.4-.9.6.6,0,0,0,.1-.4c.1-.5.1-1.1.2-1.6V27c0-1.1.1-2.3.2-3.6a9.54,9.54,0,0,1,1.8-5.1,7.43,7.43,0,0,1,5.5-2.8h.1a5.42,5.42,0,0,1,2.5.6,4.47,4.47,0,0,1,4,2.4,11.62,11.62,0,0,1,1,4.9v4.7a8.6,8.6,0,0,0,.1,1.6c0,.1.1.3.1.4a1.49,1.49,0,0,1,.4.9,1.76,1.76,0,0,1-.8,1.5,3.1,3.1,0,0,1-1.3.6,8.33,8.33,0,0,1-1.5.4c.4.2.8.3,1.2.5a21.83,21.83,0,0,1,4.7,2.1,14,14,0,0,0-1.5-19.7A12.82,12.82,0,0,0,17.2,13Z" />
    <g id="surface1">
      <path d="M37,22.26a1.12,1.12,0,0,0-1.12,1.13v10.7A1.13,1.13,0,0,0,37,35.22H43V33H37.33V23.67h7.32v2.25h1.41V23.39a1.13,1.13,0,0,0-1.13-1.13Zm7,3.94a.85.85,0,0,0-.84.85v8.17a.85.85,0,0,0,.84.84h5.08a.85.85,0,0,0,.84-.84V27.05a.85.85,0,0,0-.84-.85Zm.57,1.41h3.94v6.2H44.65ZM41,33.52a.43.43,0,1,1-.43.43A.42.42,0,0,1,41,33.52Zm5.63.85a.43.43,0,1,1-.42.42A.42.42,0,0,1,46.62,34.37Z" />
    </g>
  </IconBase>
);

export const IconUserWindows = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconUserWindows"
  >
    <path
      d="M17.2,42.2C8.8,42.2,2,35.4,2,27s6.8-15.2,15.2-15.2S32.5,18.6,32.5,27S25.7,42.2,17.2,42.2z M7.6,37.2
    	c5.4,5.1,13.9,5.1,19.3-0.1c-1.3-0.7-2.7-1.4-4.2-1.9c-0.6-0.2-1.3-0.5-1.9-0.8c-0.4-0.2-0.8-0.6-1-1l-0.4-0.8l0.9-0.1
    	c0.9-0.1,1.7-0.2,2.6-0.5c0.3-0.1,0.7-0.3,0.9-0.5c0.3-0.2,0.3-0.4,0.3-0.5c-0.3-0.3-0.4-0.7-0.5-1.1c-0.1-0.6-0.2-1.2-0.2-1.8
    	c0-0.5,0-1.1,0-1.7c0-1,0-1.9,0-2.9c0-1.5-0.3-2.9-0.9-4.3c-0.6-1.1-1.8-1.8-3.1-1.8h-0.2l-0.2-0.1c-0.6-0.4-1.3-0.6-1.9-0.6
    	c-1.8,0-3.5,0.8-4.6,2.2c-0.9,1.3-1.4,2.9-1.5,4.4C11.1,24.7,11,25.9,11,27c0,0.4,0,0.8,0,1.2c0,0.6-0.1,1.2-0.2,1.8
    	c-0.1,0.4-0.2,0.8-0.5,1.1c0,0.2,0.2,0.5,0.3,0.6c0.3,0.2,0.6,0.3,1,0.4c0.8,0.2,1.6,0.4,2.5,0.4l0.8,0.1l-0.3,0.8
    	c-0.2,0.5-0.6,0.8-1,1.1c-0.6,0.3-1.2,0.6-1.8,0.8C10.3,35.8,8.9,36.4,7.6,37.2z M17.2,13c-7.7,0-14,6.3-14,14
    	c0,3.4,1.2,6.6,3.5,9.2c1.4-0.9,3-1.6,4.6-2.1c0.4-0.1,0.8-0.3,1.2-0.5c-0.4-0.1-0.9-0.2-1.3-0.3c-0.5-0.1-0.9-0.3-1.4-0.6
    	c-0.5-0.4-0.8-1-0.9-1.6c0-0.4,0.2-0.7,0.4-0.9c0.1-0.1,0.1-0.3,0.1-0.4c0.1-0.5,0.1-1.1,0.2-1.6c0-0.4,0-0.8,0-1.2
    	c0-1.1,0.1-2.3,0.2-3.6c0.1-1.8,0.7-3.6,1.8-5.1c1.3-1.7,3.4-2.7,5.5-2.8h0.1c0.9,0,1.7,0.2,2.5,0.6c1.7,0,3.2,0.9,4,2.4
    	c0.7,1.5,1,3.2,1,4.9c0,1,0,2.1,0,3c0,0.6,0,1.2,0,1.7c0,0.5,0,1.1,0.1,1.6c0,0.1,0.1,0.3,0.1,0.4c0.2,0.2,0.4,0.6,0.4,0.9
    	c0,0.6-0.3,1.2-0.8,1.5c-0.4,0.3-0.8,0.5-1.3,0.6c-0.5,0.2-1,0.3-1.5,0.4c0.4,0.2,0.8,0.3,1.2,0.5c1.6,0.5,3.2,1.2,4.7,2.1
    	c5-5.8,4.4-14.7-1.5-19.7C23.8,14.2,20.6,13,17.2,13z"
    />
    <path
      d="M50.8,18.6l-16.5,2.1v11.7l16.5,2.1V18.6z M50,19.5v6.6h-7.5v-5.7L50,19.5z M41.8,20.5v5.6h-6.7v-4.8L41.8,20.5z
    		 M35.1,26.9h6.7v5.6l-6.7-0.8V26.9z M42.6,26.9H50v6.6l-7.5-0.9V26.9z"
    />
  </IconBase>
);

export const IconVolumeHigh = (props: Props) => (
  <IconBase
    viewBox="0 0 1088 1024"
    {...props}
    data-component-name="IconVolumeHigh"
  >
    <path d="M890.04 922.04c-12.286 0-24.566-4.686-33.942-14.056-18.744-18.746-18.744-49.136 0-67.882 87.638-87.642 135.904-204.16 135.904-328.1 0-123.938-48.266-240.458-135.904-328.098-18.744-18.746-18.744-49.138 0-67.882s49.138-18.744 67.882 0c105.77 105.772 164.022 246.4 164.022 395.98s-58.252 290.208-164.022 395.98c-9.372 9.372-21.656 14.058-33.94 14.058zm-170.51-90.51c-12.286 0-24.566-4.686-33.942-14.056-18.744-18.744-18.744-49.136 0-67.882 131.006-131.006 131.006-344.17 0-475.176-18.744-18.746-18.744-49.138 0-67.882 18.744-18.742 49.138-18.744 67.882 0 81.594 81.59 126.53 190.074 126.53 305.466 0 115.39-44.936 223.876-126.53 305.47-9.372 9.374-21.656 14.06-33.94 14.06zm-170.51-90.51c-12.286 0-24.568-4.686-33.942-14.058-18.746-18.746-18.746-49.134 0-67.88 81.1-81.1 81.1-213.058 0-294.156-18.746-18.746-18.746-49.138 0-67.882s49.136-18.744 67.882 0c118.53 118.53 118.53 311.392 0 429.922-9.372 9.368-21.656 14.054-33.94 14.054zm-133.014 218.98c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436z" />
  </IconBase>
);

export const IconVolumeMedium = (props: Props) => (
  <IconBase
    viewBox="0 0 1024 1024"
    {...props}
    data-component-name="IconVolumeMedium"
  >
    <path d="M719.53 831.53c-12.286 0-24.566-4.686-33.942-14.056-18.744-18.744-18.744-49.136 0-67.882 131.006-131.006 131.006-344.17 0-475.176-18.744-18.746-18.744-49.138 0-67.882 18.744-18.742 49.138-18.744 67.882 0 81.594 81.59 126.53 190.074 126.53 305.466 0 115.39-44.936 223.876-126.53 305.47-9.372 9.374-21.656 14.06-33.94 14.06zm-170.51-90.51c-12.286 0-24.566-4.686-33.942-14.058-18.746-18.746-18.746-49.134 0-67.88 81.1-81.1 81.1-213.058 0-294.156-18.746-18.746-18.746-49.138 0-67.882s49.136-18.744 67.882 0c118.53 118.53 118.53 311.392 0 429.922-9.372 9.368-21.656 14.054-33.94 14.054zm-133.014 218.98c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436z" />
  </IconBase>
);

export const IconVolumeLow = (props: Props) => (
  <IconBase
    viewBox="0 0 1024 1024"
    {...props}
    data-component-name="IconVolumeLow"
  >
    <path d="M549.02 741.02c-12.286 0-24.566-4.686-33.942-14.058-18.746-18.746-18.746-49.134 0-67.88 81.1-81.1 81.1-213.058 0-294.156-18.746-18.746-18.746-49.138 0-67.882s49.136-18.744 67.882 0c118.53 118.53 118.53 311.392 0 429.922-9.372 9.368-21.656 14.054-33.94 14.054zm-133.014 218.98c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436z" />
  </IconBase>
);

export const IconVolumeMute = (props: Props) => (
  <IconBase
    viewBox="0 0 1024 1024"
    {...props}
    data-component-name="IconVolumeMute"
  >
    <path d="M960 619.148v84.852h-84.852l-107.148-107.148-107.148 107.148h-84.852v-84.852l107.148-107.148-107.148-107.148v-84.852h84.852l107.148 107.148 107.148-107.148h84.852v84.852l-107.148 107.148 107.148 107.148zm-543.994 340.852c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436z" />
  </IconBase>
);

export const IconWand = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconWand">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M35.06,2.53l-1,2.63L31.65,11.5,25.56,8.41,23,7.13l1.18,2.59L27,15.91,20.5,18.07l-2.69.87,2.62,1,5.5,2.13-6.65,6.71a1.1,1.1,0,0,0-.19.25L3.5,44.6l0,0a3.47,3.47,0,0,0,0,4.78l1.12,1.12a3.47,3.47,0,0,0,4.78,0L25.22,34.72l1.59-1.62,4.78-4.78,1.75,5.21.88,2.6,1-2.56,2.5-6.38,6,3,2.5,1.25-3.88-8.72,6.44-2.06,2.66-.88-2.6-1-6.37-2.5,3.09-6,1.28-2.53L44.28,8.88l-6.19,2.78L35.93,5.19Zm1.58,11M31.59,28.32,36.4,23.5a3.47,3.47,0,0,0,0-4.78l-.06-.06L35.22,17.6l0,0a3.39,3.39,0,0,0-2.37-1,3.43,3.43,0,0,0-2.41,1h0l-4.44,4.47M42.5,35.75l-.94,2.38-1.25,3.19-3.19,1.25-2.37.93,2.37.94,3.19,1.25,1.25,3.19.94,2.37.93-2.37,1.25-3.19,3.19-1.25,2.38-.94-2.38-.93-3.19-1.25-1.25-3.19Zm-12.82.75-1,2.5-2.5,1,2.5,1,1,2.5,1-2.5,2.5-1-2.5-1ZM22.08,26,28,31.89"
    />
  </IconBase>
);

export const IconWarning = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconWarning3">
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2px"
      d="M26.84,5.44a1,1,0,0,0-.72.5L2.12,47.5a1,1,0,0,0,0,1A1,1,0,0,0,3,49H51a1,1,0,0,0,.87-.5,1,1,0,0,0,0-1l-24-41.56A1,1,0,0,0,26.84,5.44Zm.08,12.68V36.31M27.07,40a1.07,1.07,0,1,0-.28,2.12h.28a1.07,1.07,0,0,0,0-2.12Z"
    />
  </IconBase>
);

export const IconWaterSensor = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconWaterSensor"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2px"
      d="M27,3.1S10.4,23.2,10.4,34.3a16.6,16.6,0,0,0,33.2,0C43.6,23.2,27,3.1,27,3.1ZM25.8,45.4a11,11,0,0,1-9.1-11.3c0-7.6,9.7-20.1,9.7-20.1"
    />
  </IconBase>
);

export const IconWaterValveClosed = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconWaterValveClosed"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M1.81,2A1,1,0,1,0,2,4v7.81A13.22,13.22,0,0,0,15.19,25H25a1,1,0,0,0,2,0h9.81A1.21,1.21,0,0,1,38,26.19V34h-.09a1,1,0,0,0,0,2H50a1,1,0,0,0,0-2V26.19A13.22,13.22,0,0,0,36.81,13H27a1,1,0,0,0-2,0H15.19A1.21,1.21,0,0,1,14,11.81V4a1,1,0,0,0,0-2ZM25,13V25m2-12V25"
    />
  </IconBase>
);

export const IconWaterValve = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconWaterValve">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M1.81,2A1,1,0,1,0,2,4v7.81A13.22,13.22,0,0,0,15.19,25H25a1,1,0,0,0,2,0h9.81A1.21,1.21,0,0,1,38,26.19V34h-.09a1,1,0,0,0,0,2H50a1,1,0,0,0,0-2V26.19A13.22,13.22,0,0,0,36.81,13H27a1,1,0,0,0-2,0H15.19A1.21,1.21,0,0,1,14,11.81V4a1,1,0,0,0,0-2ZM44,36l-.88,1.47s-1,1.71-2,3.72c-.5,1-1,2.1-1.4,3.09A7.37,7.37,0,0,0,39,47a5,5,0,0,0,10,0,7.38,7.38,0,0,0-.69-2.69c-.39-1-.9-2.09-1.4-3.09-1-2-2-3.72-2-3.72Z "
    />
  </IconBase>
);

export const IconWindowNotOk = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconWindowNotOk"
  >
    <path d="M36.39,48.8H6.8a2,2,0,0,1-2-2V4.8a2,2,0,0,1,1.63-2l.37,0h36a2,2,0,0,1,2,2V37.39h-2V4.8H6.8v42H36.39Zm-1.25-4H8.8V6.8h32V37.55h-2V27.3H25.14V42.8h10Zm-24.34-2H23.14V27.3H10.8ZM25.14,25.3H38.8V8.8H25.14Zm-14.34,0H23.14V8.8H10.8Zm31,25.9a7.4,7.4,0,1,1,7.4-7.4A7.41,7.41,0,0,1,41.8,51.2Zm0-12.79a5.4,5.4,0,1,0,5.4,5.39A5.4,5.4,0,0,0,41.8,38.41Zm1,6.47V40.62a1,1,0,0,0-2,0v4.26a1,1,0,0,0,2,0Zm-1,3.38a.95.95,0,1,1,.94-.94A.95.95,0,0,1,41.75,48.26Zm0-1a.07.07,0,0,0-.08.08c0,.09.16.09.16,0A.08.08,0,0,0,41.75,47.24Z" />
  </IconBase>
);

export const IconWindowOk = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconWindowOk">
    <path d="M42.88,44.26v-36h-32v38h32v-2Zm-15.66-34H40.88v16.5H27.22Zm-2,34H12.88V28.76H25.22Zm0-17.5H12.88V10.26H25.22Zm2,2H40.88v15.5H27.22ZM46.75,51H7.25a1,1,0,0,1-1-1V4a1,1,0,0,1,1-1h39.5a1,1,0,0,1,1,1V50A1,1,0,0,1,46.75,51ZM8.25,49h37.5V5H8.25Z" />
  </IconBase>
);

export const IconWindowOpen = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconWindowOpen">
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2px"
      d="M40.37,42.81V8.21H13.63v34.6h-2.4v3H42.77v-3Zm-24-31.94h9.87v5.94H16.39Zm0,7.39h9.87V24.2H16.39ZM37.84,33.4v7.39H16.39V27.45H37.84Zm0-9.2H27.74V18.26h10.1Zm0-7.39H27.74V10.87h10.1Z"
    />
  </IconBase>
);

export const IconWindowClosed = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconWindowClosed"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2px"
      d="M40.37,42.8V8.2H13.63V42.8h-2.4v3H42.77v-3ZM27.74,10.86h10.1V16.8H27.74Zm0,7.39h10.1v5.94H27.74Zm0,9.2h10.1v5.94H27.74Zm0,7.39h10.1v5.94H27.74Zm-11.35-24h9.87V16.8H16.39Zm0,7.39h9.87v5.94H16.39Zm0,9.2h9.87v5.94H16.39Zm0,7.39h9.87v5.94H16.39Z"
    />
  </IconBase>
);

export const IconZWave = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconZWave">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      d="M37.16,24.83a14,14,0,1,0,14,14A14,14,0,0,0,37.16,24.83Zm4.18,20.76H29.49l6.42-10.06H29.76l2.67-4.27H44.1l-6.23,9.92H44.1ZM37.16,3.82a35,35,0,0,0-35,35m35-25.65A25.67,25.67,0,0,0,11.52,38.78"
    />
  </IconBase>
);

export const IconDeletePinpad = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconDeletePinpad"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M48,41H12c-0.7,0-1.3-0.3-1.6-0.9L2,28l8.4-12.1c0.4-0.5,1-0.8,1.6-0.9h36c1.1,0,2,0.9,2,2v22 C50,40.1,49.1,41,48,41z"
    />
    <line
      fill="none"
      stroke="currentColor"
      strokeWidth={3.6069}
      strokeMiterlimit={10}
      strokeLinecap="round"
      x1="22.4"
      y1="34.2"
      x2="34.9"
      y2="21.8"
    />
    <line
      fill="none"
      stroke="currentColor"
      strokeWidth={3.6069}
      strokeMiterlimit={10}
      strokeLinecap="round"
      x1="22.4"
      y1="21.8"
      x2="34.9"
      y2="34.2"
    />
  </IconBase>
);

export const IconDigit = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconDigit">
    <circle
      stroke="currentColor"
      strokeMiterlimit={30}
      cx="28.62"
      cy="28"
      r="14"
    />
  </IconBase>
);

export const IconEmptyDigit = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconEmptyDigit">
    <circle
      fill="none"
      stroke="currentColor"
      strokeMiterlimit={30}
      cx="28.62"
      cy="28"
      r="14"
    />
  </IconBase>
);

export const IconForgotPassword = (props: Props) => (
  <IconBase
    viewBox="0 0 50 50"
    {...props}
    data-component-name="IconForgotPassword"
    version="1.1"
    x="0px"
    y="0px"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeMiterlimit={10}
      d="M38,27c-6.1,0-11,4.9-11,11s4.9,11,11,11s11-4.9,11-11S44.1,27,38,27z"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeMiterlimit={10}
      d="M26.3,31.3c-0.7-0.4-1.1-1.1-1.4-1.8c-0.1-1.6-0.1-2.7-0.1-4.2c0.7-0.4,2-2.8,2.3-4.9c0.6,0,1.5-0.6,1.7-2.8
        c0.1-1.2-0.4-1.9-0.8-2.1C29,12.7,30.9,4,24.5,3.1c-0.7-1.2-2.4-1.8-4.6-1.8c-8.9,0.2-9.9,6.7-8,14.2c-0.3,0.2-0.9,0.9-0.8,2.1
        c0.3,2.2,1.2,2.8,1.7,2.8c0.2,2.1,1.6,4.5,2.3,4.9c0,1.5,0.1,2.6-0.1,4.2C13.4,34.2,1.5,32.9,1,42h21"
    />
    <polygon
      fill="currentColor"
      stroke="none"
      points="22,41 22,43 25,43 24.4,41"
    />
    <text
      stroke="currentColor"
      fill="currentColor"
      fontSize="18px"
      transform="matrix(1 0 0 1 34 44)"
    >
      ?
    </text>
  </IconBase>
);

export const IconPasswordNotVisible = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconPasswordNotVisible"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth="2px"
      d="M27,15C13.67,15,3.25,27.34,3.25,27.34a1,1,0,0,0,0,1.32s11,10.22,24.29,10.22S50.75,28.66,50.75,28.66a1,1,0,0,0,0-1.32S40.33,15,27,15ZM16.19,17.84a12,12,0,1,0,21.65,0M27,19a5,5,0,1,0,5,5A5,5,0,0,0,27,19ZM11.73,10.36l33,32.48"
    />
  </IconBase>
);

export const IconPasswordVisible = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconPasswordVisible"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth="2px"
      d="M27,15C13.67,15,3.25,27.34,3.25,27.34a1,1,0,0,0,0,1.32s11,10.22,24.29,10.22S50.75,28.66,50.75,28.66a1,1,0,0,0,0-1.32S40.33,15,27,15Zm0,24M16.19,17.84A12,12,0,1,0,39,23a12.08,12.08,0,0,0-1.16-5.16M27,18a5,5,0,1,0,5,5A5,5,0,0,0,27,18Z"
    />
  </IconBase>
);

export const IconWaterDrop = (props: Props) => (
  <IconBase viewBox="0 0 50 50" {...props} data-component-name="IconWaterDrop">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="  M25,1.173c0,0-16.615,20.135-16.615,31.211C8.385,41.562,15.822,49,25,49s16.615-7.438,16.615-16.615  C41.615,21.308,25,1.173,25,1.173z"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="  M23.843,43.491c0,0-9.1-1.308-9.1-11.297c0-7.588,9.666-20.064,9.666-20.064"
    />
  </IconBase>
);

export const IconWaterDropOff = (props: Props) => (
  <IconBase
    viewBox="0 0 54 54"
    {...props}
    data-component-name="IconWaterDropOff"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2px"
      strokeMiterlimit="10"
      d="M13,15.09l28.6,28.57M26.93,8.35S14,24.05,14,32.69a13,13,0,0,0,25.92,0C39.89,24.05,26.93,8.35,26.93,8.35Zm-.91,33a8.54,8.54,0,0,1-7.09-8.82c0-5.91,7.53-15.65,7.53-15.65"
    />
  </IconBase>
);

export const IconCheck = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconCheck">
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M41,6H13a7,7,0,0,0-7,7V41a7,7,0,0,0,7,7H41a7,7,0,0,0,7-7V17M16.41,26.44l8.9,8.28.78.72.66-.78L46.75,11m1.37,5.63V41A7,7,0,0,1,41,48.12H13A7,7,0,0,1,5.88,41V13A7,7,0,0,1,13,5.88H41.26M46.93,11l-.08.09L26.11,35.62l-.88-.81-9-8.37m29-16.87"
    />
  </IconBase>
);

export const IconRachioLogo = (props: Props) => (
  <IconBase
    viewBox="0 0 1024 1024"
    {...props}
    data-component-name="IconRachioLogo"
  >
    <path d="M762.89 489.517c0 133.365-103.218 242.715-234.028 252.423v-185.996c0-9.198 7.665-15.84 18.395-18.395 17.884-4.088 45.988-9.198 72.559-9.198h5.621v-53.142s-39.345-3.577-108.838 15.329v-101.685c0-8.687 7.154-15.329 17.373-17.884 10.731-2.044 24.527-4.088 37.301-4.088h3.577v-33.725s-61.317 2.555-92.487 17.373v58.762c-55.697-15.329-87.377-12.263-87.377-12.263v42.411h4.599c19.417 0 39.345 3.577 54.164 6.643h-.511c10.731 2.044 18.395 4.599 18.395 13.796v279.505c-121.102-18.906-214.1-123.657-214.1-249.868 0-139.497 113.437-252.934 252.934-252.934 138.986 0 252.423 112.926 252.423 252.934zm261.11 468.056v-891.657c0-36.279-29.637-65.916-65.916-65.916h-892.168c-36.279 0-65.916 29.637-65.916 65.916v891.657c0 36.279 29.637 65.916 65.916 65.916h891.657c36.79.511 66.427-29.126 66.427-65.916zm-66.427-926.914c19.417 0 35.257 15.84 35.257 35.257v891.657c0 19.417-15.84 35.257-35.257 35.257h-891.657c-19.417 0-35.257-15.84-35.257-35.257v-891.657c0-19.417 15.84-35.257 35.257-35.257h891.657z" />
  </IconBase>
);

export const IconFire = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconFire">
    <path d="M27.75,53.27a28.21,28.21,0,0,1-6.95-.9l0,.06a1.75,1.75,0,0,1-.39-.19C12.53,49.41,8,43.51,8,36.08c0-6.36,2.83-11.35,5.57-16.18l.34-.61c2.79-4.91,5.67-10,7.14-16.95A2,2,0,0,1,22.69.75h.15a2.11,2.11,0,0,1,1.53.55c8.18,7.56,13.06,12.89,16.31,17.83A29.67,29.67,0,0,1,46,36c0,8.25-5.76,15.35-13.48,16.7v.05A20.9,20.9,0,0,1,27.75,53.27Zm-6.63-2.89a24.45,24.45,0,0,0,10.72.47v-.07c7-1,12.2-7.37,12.2-14.79a27.73,27.73,0,0,0-5-15.77c-3.16-4.79-7.94-10-16-17.47h0C21.44,10,18.35,15.48,15.62,20.28l-.34.61C12.67,25.49,10,30.25,10,36.08,10,45,16.94,48.87,21.12,50.38ZM27.91,49a16.32,16.32,0,0,1-6.26-1.35l-.2-.11C19.67,46.12,17,42.69,17,39.71a16.25,16.25,0,0,1,1.42-6.79l.21-.51c.57-1.4,1.23-3,1.82-4.88l.57-1.79,1.17,1.47A13.53,13.53,0,0,1,25,33.73h0a34.89,34.89,0,0,0,3.1-15.27L28,15.81l1.83,1.93C36.6,24.93,38,31.14,38,35.09c0,6.18-1.59,10.37-4.81,12.45A9.57,9.57,0,0,1,27.91,49Zm-5.33-3.12c.78.33,5.91,2.34,9.5,0C34.69,44.17,36,40.55,36,35.08c0-3.23-1-8.17-5.92-14a38.84,38.84,0,0,1-3.24,13.63,2,2,0,0,1-3.84-.8h0a12,12,0,0,0-1.25-3.78c-.41,1.14-.83,2.15-1.21,3.08l-.21.51a14.38,14.38,0,0,0-1.27,6C19,41.85,21.1,44.64,22.58,45.84Z" />
  </IconBase>
);

export const IconSnowflake = (props: Props) => (
  <IconBase viewBox="0 0 54 54" {...props} data-component-name="IconSnowflake">
    <path d="M48.67,39.5a1,1,0,0,1-1.37.37l-6.62-3.82,1.59,5.89a1,1,0,0,1-.71,1.23l-.26,0a1,1,0,0,1-1-.74l-2.1-7.82L28,28.73V40.59l5.71,5.7a1,1,0,0,1,0,1.42,1,1,0,0,1-1.42,0L28,43.41V51a1,1,0,0,1-2,0V43.41l-4.29,4.3a1,1,0,0,1-1.42-1.42L26,40.59V28.73L15.76,34.64l-2.09,7.82a1,1,0,0,1-1,.74l-.26,0a1,1,0,0,1-.71-1.23l1.58-5.89L6.7,39.87a1,1,0,1,1-1-1.74l6.59-3.8L6.44,32.77A1,1,0,1,1,7,30.83l7.78,2.09L25,27,14.74,21.08,7,23.17l-.26,0a1,1,0,0,1-1-.74,1,1,0,0,1,.71-1.23l5.85-1.56L5.7,15.87a1,1,0,0,1,1-1.74L13.31,18l-1.58-5.89a1,1,0,0,1,1.94-.52l2.09,7.82L26,25.27V13.41l-5.71-5.7a1,1,0,0,1,1.42-1.42L26,10.59V3a1,1,0,0,1,2,0v7.59l4.29-4.3a1,1,0,1,1,1.42,1.42L28,13.41V25.27l10.23-5.91,2.1-7.82a1,1,0,1,1,1.94.52L40.68,18l6.62-3.82a1,1,0,1,1,1,1.74l-6.59,3.8,5.85,1.56a1,1,0,0,1,.71,1.23,1,1,0,0,1-1,.74,1.15,1.15,0,0,1-.26,0l-7.78-2.09L29,27l10.26,5.92L47,30.83a1,1,0,1,1,.52,1.94l-5.85,1.56,6.59,3.8A1,1,0,0,1,48.67,39.5Z" />
  </IconBase>
);

export const IconPivotOccupied = (props: Props) => (
  <IconBase
    viewBox="0 0 64 64"
    {...props}
    data-component-name="IconPivotOccupied"
  >
    <path d="M41.84,30.4V40.59l-.09.2a1.16,1.16,0,0,1-2.22-.21,2.81,2.81,0,0,1-.06-.65V31.66c0-.14,0-.27,0-.42H37.13v.48q0,11.72,0,23.44a4,4,0,0,1,0,.68,1.68,1.68,0,0,1-1.72,1.36,1.66,1.66,0,0,1-1.61-1.44,4.74,4.74,0,0,1-.05-.65V41.93c0-.15,0-.3,0-.48a30.81,30.81,0,0,0-3.33,0V55.59a1.71,1.71,0,0,1-1.72,1.61A1.67,1.67,0,0,1,27,55.58c0-.17,0-.34,0-.5V31.71c0-.15,0-.3,0-.46H24.55v4.92c0,1.32,0,2.64,0,3.95a1.61,1.61,0,0,1-.19.81,1.13,1.13,0,0,1-1,.59,1.09,1.09,0,0,1-1-.58,1.65,1.65,0,0,1-.19-.84c0-3.06,0-6.11,0-9.17,0-2.16,2.67-3.87,4.82-3.89,2.64,0,7.29,0,9.93,0,1.72,0,4,.85,4.64,2.43A7,7,0,0,1,41.84,30.4Z" />
    <path d="M32.65,18.33c.34.14.69.24,1,.41A3.57,3.57,0,1,1,31,18.46l.38-.13Z" />
    <rect x="43.06" y="10.34" width="9.84" fill="none" />
    <polygon
      points="51.9 30.01 51.9 29.67 51.9 11.34 44.06 11.34 44.06 17.21 44.06 20.09 42.27 17.82 32 4.81 4.6 39.53 11.11 39.53 12.11 39.53 12.11 40.53 12.11 59.47 51.9 59.47 51.9 40.53 51.9 39.53 52.9 39.53 59.4 39.53 52.11 30.29 51.9 30.01"
      fill="none"
    />
    <path d="M63,39.41,54.77,29V8.47H41.19v3.35l-7.3-9.25a2.41,2.41,0,0,0-3.78,0L1,39.41a1.93,1.93,0,0,0-.38,2,1.9,1.9,0,0,0,1.82,1H9.24V59.54a2.8,2.8,0,0,0,2.8,2.8H52a2.8,2.8,0,0,0,2.81-2.8V42.4h6.76a1.74,1.74,0,0,0,1.44-3Zm-10.07.12h-1V59.47H12.11V39.53H4.6L32,4.81l10.28,13,1.78,2.26V11.34H51.9V30l.21.28,7.29,9.24Z" />
  </IconBase>
);

export const IconPivotUnoccupied = (props: Props) => (
  <IconBase
    viewBox="0 0 64 64"
    {...props}
    data-component-name="IconPivotUnoccupied"
  >
    <polygon
      points="51.9 30.01 51.9 29.67 51.9 11.34 44.06 11.34 44.06 17.21 44.06 20.09 42.27 17.82 32 4.81 4.6 39.53 11.1 39.53 12.1 39.53 12.1 40.53 12.1 59.47 51.9 59.47 51.9 40.53 51.9 39.53 52.9 39.53 59.4 39.53 52.11 30.29 51.9 30.01"
      fill="none"
    />
    <path d="M63,39.41,54.77,29V8.47H41.19v3.35l-7.3-9.25a2.41,2.41,0,0,0-3.78,0L1,39.41a1.91,1.91,0,0,0-.38,2,1.9,1.9,0,0,0,1.82,1H9.23V59.54A2.8,2.8,0,0,0,12,62.34H52a2.8,2.8,0,0,0,2.81-2.8V42.4h6.76a1.74,1.74,0,0,0,1.44-3Zm-10.07.12h-1V59.47H12.1V39.53H4.6L32,4.81l10.28,13,1.78,2.26V11.34H51.9V30l.21.28,7.29,9.24Z" />
  </IconBase>
);

export const IconBuilding = (props: Props) => (
  <IconBase viewBox="0 0 64 64" {...props} data-component-name="IconBuilding">
    <path d="M7.62,28.52V5.93c0-2.38.54-2.95,3-2.95H53.35c2.47,0,3,.59,3,3.11q0,22.59,0,45.18a6.93,6.93,0,0,1-.2,1.7,1.47,1.47,0,0,1-1.55,1.14A1.44,1.44,0,0,1,53.06,53a10.32,10.32,0,0,1-.22-2.22q0-20.94,0-41.88c0-2.69.23-2.4-2.45-2.4H13c-2.1,0-2.1,0-2.1,2q0,20.43,0,40.84c0,1,0,2.09,0,3.12a1.6,1.6,0,0,1-3.2.17,11.21,11.21,0,0,1-.08-1.74V28.52Z" />
    <path d="M32.12,57.47h29a6.14,6.14,0,0,1,.86,0,1.75,1.75,0,0,1,1.77,1.58A1.9,1.9,0,0,1,62.08,61a7,7,0,0,1-1.21.05H3.57a9.94,9.94,0,0,1-1.73-.08,1.72,1.72,0,0,1,.07-3.43,13.54,13.54,0,0,1,1.56,0H32.12Z" />
    <path d="M46.3,34.47A1.6,1.6,0,0,1,44.73,36a1.52,1.52,0,0,1-1.59-1.32,29.71,29.71,0,0,1,0-4.81,1.42,1.42,0,0,1,1.62-1.24A1.48,1.48,0,0,1,46.27,30,29.13,29.13,0,0,1,46.3,34.47Z" />
    <path d="M33.59,34.47A1.6,1.6,0,0,1,32,36a1.51,1.51,0,0,1-1.58-1.32,28.61,28.61,0,0,1,0-4.81,1.42,1.42,0,0,1,1.62-1.24A1.5,1.5,0,0,1,33.57,30,30.4,30.4,0,0,1,33.59,34.47Z" />
    <path d="M20.88,34.47A1.59,1.59,0,0,1,19.31,36a1.51,1.51,0,0,1-1.58-1.32,29.71,29.71,0,0,1,0-4.81,1.41,1.41,0,0,1,1.61-1.24A1.49,1.49,0,0,1,20.86,30,27.86,27.86,0,0,1,20.88,34.47Z" />
    <path d="M46.3,20.44A1.6,1.6,0,0,1,44.73,22a1.52,1.52,0,0,1-1.59-1.32,29.71,29.71,0,0,1,0-4.81,1.42,1.42,0,0,1,1.62-1.24A1.48,1.48,0,0,1,46.27,16,29.13,29.13,0,0,1,46.3,20.44Z" />
    <path d="M33.59,20.44A1.6,1.6,0,0,1,32,22a1.51,1.51,0,0,1-1.58-1.32,28.61,28.61,0,0,1,0-4.81,1.42,1.42,0,0,1,1.62-1.24A1.5,1.5,0,0,1,33.57,16,30.4,30.4,0,0,1,33.59,20.44Z" />
    <path d="M20.88,20.44A1.59,1.59,0,0,1,19.31,22a1.51,1.51,0,0,1-1.58-1.32,29.71,29.71,0,0,1,0-4.81,1.41,1.41,0,0,1,1.61-1.24A1.49,1.49,0,0,1,20.86,16,27.86,27.86,0,0,1,20.88,20.44Z" />
    <path d="M38.78,44c0-1.91-.62-2.44-2.54-2.47-1.41,0-2.83,0-4.24,0s-2.83,0-4.24,0c-1.92,0-2.5.56-2.54,2.47,0,2.55,0,5.09,0,7.64,0,1.67.67,2.52,1.78,2.51s1.73-.88,1.75-2.53c0-1.85,0-3.7,0-5.55,0-.5.08-.93.72-1s.85.42.85,1v5.38a7,7,0,0,0,.09,1.38,1.62,1.62,0,0,0,3.16,0,7,7,0,0,0,.09-1.38V46.06c0-.58.12-1,.85-1s.72.47.72,1c0,1.85,0,3.7,0,5.55,0,1.65.63,2.51,1.75,2.53s1.76-.84,1.78-2.51C38.82,49.05,38.83,46.51,38.78,44Z" />
  </IconBase>
);

export const IconTransferAccount = (props: Props) => (
  <IconBase
    viewBox="0 0 48 48"
    {...props}
    data-component-name="IconTransferAccount"
  >
    <g
      opacity="1"
      fillOpacity="0"
      stroke="#959DA4"
      strokeWidth="2"
      strokeOpacity="1"
    >
      <path d="M37.5 24L48 13.5L37.5 3L37.5 10.5L0 10.5L0 16.5L37.5 16.5L37.5 24Z" />
      <path d="M10.5 45L0 34.5L10.5 24L10.5 31.5L48 31.5L48 37.5L10.5 37.5L10.5 45Z" />
    </g>
  </IconBase>
);

/* eslint-disable camelcase */
const apiNameMap = {
  // These are organized in roughly the same order as in mobile/icons.rb in the
  // serverside code.

  settings: IconSettings,
  "plus-sign": IconPlusSign,
  calendar: IconCalendar,
  calendar_empty: IconCalendarEmpty,
  clock: IconClock,
  sun: IconSunny,
  moon: IconMoon,
  new_device: IconLightning,
  create_group: IconCreateGroup,
  zwave: IconZWave,
  bridge: IconNexiaLogo,
  automation: IconWand,
  mode: IconRefresh,
  remove: IconRemove,
  music: IconMusic,

  question: IconQuestion,

  window_blind_open: IconBlindsOpen,
  window_blind_mostly_open: IconBlindsMostlyOpen,
  window_blind_half_open: IconBlindsHalfOpen,
  window_blind_mostly_closed: IconBlindsMostlyClosed,
  window_blind_closed: IconBlindsClosed,

  window_shade_open: IconShadesOpen,
  window_shade_mostly_open: IconShadesMostlyOpen,
  window_shade_half_open: IconShadesHalfOpen,
  window_shade_mostly_closed: IconShadesMostlyClosed,
  window_shade_closed: IconShadesClosed,
  window_shade_bottomup_open: IconShadesOpen,
  window_shade_bottomup_mostly_open: IconShadesBottomMostlyOpen,
  window_shade_bottomup_half_open: IconShadesBottomHalfOpen,
  window_shade_bottomup_mostly_closed: IconShadesBottomMostlyClosed,
  window_shade_bottomup_closed: IconShadesClosed,

  speaker: IconMusic,
  speaker_play: IconPlay,
  speaker_pause: IconPause,
  speaker_volume: IconVolumeHigh,
  speaker_play_favorite: IconPlay,
  speaker_play_url: IconPlay,
  speaker_next: IconFastForward,
  speaker_previous: IconRewind,

  lock_locked: IconLocked,
  lock_unknown: IconLockUnknown,
  lock_unlocked: IconUnlocked,
  caution: IconWarning,

  mouse_trap_armed: IconMouseTrapArmed,
  mouse_trap_disarmed: IconMouseTrapDisarmed,
  mouse_trap_tripped: IconMouseTrapTripped,

  sensor_generic_tripped: IconSensorGenericActive,
  sensor_generic_idle: IconSensorGeneric,
  sensor_glass_tripped: IconWindowNotOk,
  sensor_glass_idle: IconWindowOk,
  sensor_door_tripped: IconDoorOpen,
  sensor_door_idle: IconDoor,
  sensor_window_tripped: IconWindowOpen,
  sensor_window_idle: IconWindowClosed,
  sensor_water_tripped: IconWaterSensor,
  sensor_water_idle: IconWaterSensor,
  sensor_motion_tripped: IconSensorActivated,
  sensor_motion_idle: IconSensorMotionIdle,

  "sliding-door-unknown": IconSlidingDoorUnknown,
  "sliding-door-open": IconSlidingDoorOpen,
  "sliding-door-closed": IconSlidingDoorClosed,
  "sliding-door-closed-locked": IconSlidingDoorClosedLocked,
  "sliding-door-closed-unlocked": IconSlidingDoorClosedUnlocked,
  "hinged-door-unknown": IconHingedDoorUnknown,
  "hinged-door-open": IconHingedDoorOpen,
  "hinged-door-closed": IconHingedDoorClosed,
  "hinged-door-closed-locked": IconHingedDoorClosedLocked,
  "hinged-door-closed-unlocked": IconHingedDoorClosedUnlocked,
  "double-hung-window-unknown": IconDoubleHungWindowUnknown,
  "double-hung-window-open": IconDoubleHungWindowOpen,
  "double-hung-window-closed": IconDoubleHungWindowClosed,
  "double-hung-window-closed-locked": IconDoubleHungWindowClosedLocked,
  "double-hung-window-closed-unlocked": IconDoubleHungWindowClosedUnlocked,
  "casement-window-unknown": IconCasementWindowUnknown,
  "casement-window-open": IconCasementWindowOpen,
  "casement-window-closed": IconCasementWindowClosed,
  "casement-window-closed-locked": IconCasementWindowClosedLocked,
  "casement-window-closed-unlocked": IconCasementWindowClosedUnlocked,

  smoke_detector_tripped: IconSmokeDetectorTriggered,
  smoke_detector_idle: IconSmokeDetector,

  thermostat: IconThermostat,
  climate: IconClimate,
  heating: IconFire,
  cooling: IconSnowflake,

  humidity: IconDroplets,
  temperature: IconThermostat,
  above_value: IconThinArrowUp,
  below_value: IconThinArrowDown,

  dimmer_0: IconLightbulb0,
  dimmer_30: IconLightbulb100,
  dimmer_70: IconLightbulb100,
  dimmer_100: IconLightbulb100,

  remote: IconRemote,

  switch_on: IconLightSwitchOn,
  switch_off: IconLightSwitchOff,

  siren_on: IconSirenOn,
  siren_off: IconSiren,

  doorbell_triggered: IconDoorbellTriggered,
  doorbell_waiting: IconDoorbellWaiting,

  valve_open: IconWaterValve,
  valve_closed: IconWaterValveClosed,

  barrier_open: IconGarageOpen,
  barrier_closed: IconGarageClosed,
  barrier_partially_open: IconGaragePartial,

  nest_structure_home: IconNestHomeIcon,
  nest_structure_away: IconNestAwayIcon,
  nest_structure_unknown: IconNestUnknownIcon,

  camera: IconCamera,
  camera_disconnected: IconCameraDisconnected,

  zid_connected: IconSensorGeneric,
  zid_disconnected: IconSensorGenericActive,

  message: IconChat,

  insynctive: IconInsynctive,

  battery_full: IconBatteryFull,
  battery_mostly_full: IconBatteryMostlyFull,
  battery_mostly_empty: IconBatteryLow,
  battery_empty: IconBatteryEmpty,

  ceiling_fan_on: IconFanMoving,
  ceiling_fan_off: IconFanOff,

  thermostat_fan_on: IconFanOn,
  thermostat_fan_off: IconFanOff,

  home_controller: IconHomeController,

  energy_meter: IconEnergyMeter,

  sprinkler_on: IconIrrigationOn,
  sprinkler_off: IconIrrigationOff,

  samsung_vacuum: IconSamsungVacuum,
  samsung_vacuum_charging: IconSamsungVacuumCharging,
  samsung_vacuum_offline: IconSamsungVacuumOffline,

  samsung_washer: IconSamsungWasher,
  samsung_washer_offline: IconSamsungWasherOffline,

  samsung_dryer: IconSamsungDryer,
  samsung_dryer_offline: IconSamsungDryerOffline,

  at_home: IconHomeMode,
  shield: IconShield,
  heart: IconHeart,
  star: IconStar,
  key: IconKey,
  smile: IconSmile,
  user: IconUser,
  globe: IconGlobe,
  plane: IconPlane,
  dials: IconEqualizer,
  rewind: IconHistory,
  bell: IconBell,
  gears: IconGears,

  // Currently, serverside uses mode.icon instead of Mobile::Icons.mode_icon.
  // So we need to support these names, too. Duplicate entries are commented
  // out, but kept in here because they're mode icons.
  home: IconHomeMode,
  away: IconShield,
  sleep: IconMoon,
  "alarm-clock": IconClock,
  // heart: IconHeart,
  // star: IconStar,
  // key: IconKey,
  smiley: IconSmile,
  // user: IconUser,
  network: IconGlobe,
  picture: IconPlane,
  // dials: IconDials,
  // rewind: IconRewind,
  // bell: IconBell,
  // calendar: IconCalendar,
  // shield: IconShield,
};
/* eslint-enable camelcase */

export function iconFromAPIName(name: string) {
  return apiNameMap[name];
}



// WEBPACK FOOTER //
// ../nx-components/src/Icons.jsx